(function ($) {
    if (!$('#map').length) return;
    $(document).ready(function () {
        // const ENV = GeoInteractiveMap.mapSettings.prod_mode ? 'prod' : 'dev';
        const DEBUG_MODE = GeoInteractiveMap.mapSettings.map_debug_mode ?? false;

        let siteURL = GeoInteractiveMap.mapSettings.site_url;
        if (!siteURL.endsWith('/')) {
            siteURL = siteURL + '/';
        }

        const INITIAL_COORDINATES = {
            lat: 39.45571465324019, lng: -95.41731613339797
        };
        const INITIAL_ZOOM = 4;

        // Create the script tag, set the appropriate attributes
        // jQuery('.interactive__map-loading').addClass('open');
        var script = document.createElement('script');
        let MAP_API_KEY = GeoInteractiveMap.mapSettings.API_KEY;
        // MAP_API_KEY = 'AIzaSyAYR9exARgIJBiGfNteei06cnvo4LP9RoU';
        let MAP_STYLE_ID = GeoInteractiveMap.mapSettings.MAP_STYLE_ID;
        const MAP_ID = MAP_STYLE_ID;
        const MAP_CALLBACK = 'initMap';
        const MAP_LIBRARIES = '&libraries=visualization,marker&v=beta';
        script.src = `https://maps.googleapis.com/maps/api/js?key=${MAP_API_KEY}${MAP_LIBRARIES}&callback=${MAP_CALLBACK}`;
        script.async = true;

        const case__segue_action_logo_overlay_timer = 500;
        const remove_case__segue_action_logo_overlay_timer = 2500;

        let markers = [];
        let innerMarkers = [];
        let mapLines = [];
        let infoWindows = [];

        let heatMaps = [];

        let firstCorridorData = [];
        let secondCorridorData = [];
        let bothCorridorData = [];

        let curbsideData2020 = [];
        let curbsideData2020TotalStops = 0;
        let curbsideData2022 = [];
        let curbsideData2022TotalStops = 0;

        let duvalData = [];
        let duvalDataTotalStops = 0;

        let navigationStack = [];

        async function fetchJSON(url) {
            let x = await fetch(url);
            let data = await x.json();//.then(async response => await response.json());
            return data;
        }

        // function getColorByValue(value) {
        //     // Define the gradient colors for the red spectrum
        //     const startColor = [255, 204, 204]; // Light red
        //     const endColor = [255, 0, 0]; // Dark red

        //     // Calculate the color values based on the gradient
        //     const r = Math.round(startColor[0] + value * (endColor[0] - startColor[0]));
        //     const g = Math.round(startColor[1] + value * (endColor[1] - startColor[1]));
        //     const b = Math.round(startColor[2] + value * (endColor[2] - startColor[2]));

        //     // Return the color as a CSS RGB string
        //     return `rgb(${r}, ${g}, ${b})`;
        // }
        function getColorByValue(value, scalingFactor) {
            // Define the gradient colors for the red spectrum
            const startColor = [255, 204, 204]; // Light red
            const endColor = [255, 0, 0]; // Dark red

            // Scale the value by the scaling factor
            const scaledValue = value * scalingFactor;

            // Calculate the color values based on the gradient
            const r = Math.round(startColor[0] + scaledValue * (endColor[0] - startColor[0]));
            const g = Math.round(startColor[1] + scaledValue * (endColor[1] - startColor[1]));
            const b = Math.round(startColor[2] + scaledValue * (endColor[2] - startColor[2]));

            // Return the color as a CSS RGB string
            return `rgb(${r}, ${g}, ${b})`;
        }

        (async () => {
            try {
                firstCorridorData = await fetchJSON(siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/data/corridor_data/first_corridor_data.json');
                secondCorridorData = await fetchJSON(siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/data/corridor_data/second_corridor_data.json');
                bothCorridorData = [...firstCorridorData, ...secondCorridorData];

                curbsideData2020 = await fetchJSON(siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/data/curbside_data/map_dec_2020.json');
                curbsideData2020TotalStops = curbsideData2020.reduce((a, c) => a + c.NumberOfStops, 0);
                curbsideData2022 = await fetchJSON(siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/data/curbside_data/map_dec_2022.json');
                curbsideData2022TotalStops = curbsideData2022.reduce((a, c) => a + c.NumberOfStops, 0);

                duvalData = await fetchJSON(siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/data/duval_data/duval_county.json');
                duvalDataTotalStops = curbsideData2022.reduce((a, c) => a + c.NumberOfStops, 0);
                if (DEBUG_MODE)
                    console.log(curbsideData2020TotalStops, curbsideData2022TotalStops, duvalDataTotalStops);
            } catch (error) {
                alert("There was an import on data import and map initialization.")
            }
        })();


        // Todo, convert parents to above after JSON format has been formalized

        // Attach your callback function to the `window` object
        window.initMap = function () {
            // JS API is loaded and available
            let parentOne = GeoInteractiveMap.parentOne;
            let parentTwo = GeoInteractiveMap.parentTwo;
            let parentThree = GeoInteractiveMap.parentThree;

            let parentNavs = [parentOne, parentTwo, parentThree];
            const createParent = (markup, containerName) =>
                `<ul class="interactive__map-drawer-nav-container ${containerName || ''}">${markup}</ul>`;
            function createMarkup(parent) {
                let markupString = '';
                markupString = `<li class="interactive__map-drawer-nav-container-item"><a class="case__segue" data-casesegue="${parent.case}" href="#${parent.case}">#${parent.case} - ${parent.caseName}</a></li>`;
                // hasChildren: true,
                if (parent.hasChildren)
                    markupString += parent.children.map((child) => `<li class="interactive__map-drawer-nav-container-item-child"><a class="case__segue" data-casesegue="${child.case}" href="#${child.case}">#${child.case} - ${child.caseName}</a></li>`).join('');

                return markupString;
            }
            // interactive__map-drawer-nav-container
            let parentOneMarkup = createParent(parentOne.map((x) => createMarkup(x)).join(''), 'parent__one');
            let parentTwoMarkup = createParent(parentTwo.map((x) => createMarkup(x)).join(''), 'parent__two');
            let parentThreeMarkup = createParent(parentThree.map((x) => createMarkup(x)).join(''), 'parent__three');

            const createSubmenuMarkup = (theCase, level, parent) => {
                let markupString = '';
                markupString += `<div class="interactive__map-top__bar-nav-container-submenu-submenu__item-container">`;
                markupString += `<a class="interactive__map-top__bar-nav-container-submenu-submenu__item-container-menu__item case__segue" href="#${theCase.case}" title="${theCase.caseName}" data-parent="${parent}" data-level="${level}" data-casesegue="${theCase.case}">`;
                markupString += `<span>`;
                markupString += theCase.caseName;
                markupString += `</span>`;
                markupString += `</a>`;
                markupString += `</div>`;
                return markupString;
            }

            // Generate submenus
            let parentOneMenuMarkup = parentOne.map((aCase) => createSubmenuMarkup(aCase, 'second', 'parentOne')).join('');
            let parentTwoMenuMarkup = parentTwo.map((aCase) => createSubmenuMarkup(aCase, 'second', 'parentTwo')).join('');
            let parentThreeMenuMarkup = parentThree.map((aCase) => createSubmenuMarkup(aCase, 'second', 'parentThree')).join('');

            document.getElementById('interactive__map_submenu_1').innerHTML = parentOneMenuMarkup;
            document.getElementById('interactive__map_submenu_2').innerHTML = parentTwoMenuMarkup;
            document.getElementById('interactive__map_submenu_3').innerHTML = parentThreeMenuMarkup;

            let map = new google.maps.Map(document.getElementById('map'),
                {
                    disableDefaultUI: true,
                    // scrollwheel: false,
                    // draggable: false,
                    gestureHandling: 'greedy',
                    // mapId: MAP_STYLE_ID,
                    mapId: MAP_ID,
                    center: INITIAL_COORDINATES,
                    zoom: INITIAL_ZOOM
                }
            );

            /**
             * Debugger code
             */
            if (DEBUG_MODE) {
                $('.interactive__map .col.pr-0').append(`
                    <div id="map_debug_window" class="debug-window" style="max-height: 100% !important;color: black; z-index: 999; width: calc(100% - 15px); position: absolute; bottom: 0; background: rgba(255,255,255,0.75); padding: 13px 20px; border: 1px solid black;">
                        <div class="button-to-drag-height" style="cursor: ns-resize;user-select: none;">===============<div class="debug-window-title" style="font-weight:var(--bs-font-weight-bold,bold);">DEBUGGER<span class="tooltip-title" style="display:none;">(drag me to close)</span></div>===============</div>
                        <div class="zoom"><span class="title" style="font-weight:var(--bs-font-weight-bold,bold);">- Zoom: </span><span class="zoomdata">${INITIAL_ZOOM}</span></div>
                        <div class="latlng"><span class="title" style="font-weight:var(--bs-font-weight-bold,bold);">- LatLng: </span><code><span class="latlngdata">{ lat: ${INITIAL_COORDINATES.lat}, lng: ${INITIAL_COORDINATES.lng} }</span></code></div>
                        <div class="recent-coordinates">
                            <span class="title clear-all-coordinates" style="font-weight:var(--bs-font-weight-bold,bold);">- Recently Copied: <span class="tooltip-title" style="display:none;">(click coordinate to remove)</span></span>
                            <div style="background: rgba(255,255,255,0.65); margin-top: 5px;">
                                <pre class="code"></pre>
                            </div>
                        </div>
                    </div>
                `);

                var isDragging = false;
                var startY, startHeight;
                var minHeight = 12; // Set your minimum height here

                $(".button-to-drag-height").mousedown(function (e) {
                    isDragging = true;
                    startY = e.clientY;
                    startHeight = $("#map_debug_window").height();
                });

                $(document).mouseup(function () {
                    isDragging = false;
                });

                $(document).mousemove(function (e) {
                    if (isDragging) {
                        var newHeight = startHeight - (e.clientY - startY);

                        if (newHeight >= minHeight) {
                            $("#map_debug_window").height(newHeight);
                        }
                    }
                });

                google.maps.event.addListener(map, 'zoom_changed', function () {
                    $('#map_debug_window .zoom .zoomdata').html(`${map.getZoom()}`);
                });
                google.maps.event.addListener(map, 'center_changed', function () {
                    $('#map_debug_window .latlng .latlngdata').html(`{ lat: ${map.getCenter().lat()}, lng: ${map.getCenter().lng()} }`);
                    console.log('latlng', map.getCenter().lat(), map.getCenter().lng());
                });

                const myLatlng = { lat: 42.05174835379208, lng: -98.97688644589797 };
                // Create the initial InfoWindow.
                let infoWindow = new google.maps.InfoWindow({
                    content: "click map to get latlng",
                    position: myLatlng,
                });
                infoWindows.push(infoWindow);

                map.addListener("click", (mapsMouseEvent) => {
                    infoWindow.close();
                    infoWindow = new google.maps.InfoWindow({
                        position: mapsMouseEvent.latLng,
                    });

                    let coords_json = JSON.stringify(mapsMouseEvent.latLng.toJSON(), null, 2);

                    infoWindow.setContent(
                        coords_json
                    );

                    $('.interactive__map .col.pr-0 .recent-coordinates pre.code').append(`<code>${coords_json},</code>`);
                    $(".interactive__map .col.pr-0 .recent-coordinates pre.code").scrollTop(function () { return this.scrollHeight; });

                    if (navigator.clipboard !== undefined) {
                        navigator.clipboard.writeText(coords_json);
                    } else {
                        console.log(coords_json);
                    }
                    infoWindow.open(map);
                });

                $(document).on('click', '.interactive__map .col.pr-0 .recent-coordinates pre.code code', function () {
                    if (window.confirm('Would you like to delete this coordinate?')) {
                        $(this).remove();
                    }
                });
                $(document).on('click', '.clear-all-coordinates', function () {
                    if (window.confirm('Would you like to delete ALL copied coordinates?')) {
                        $('#map_debug_window .recent-coordinates pre.code code').remove();
                    }
                });
            }

            /***********************
             * Custom marker cases *
             ***********************/
            // First Case
            // const firstCaseMarker = new google.maps.Marker({
            //     position: { lat: 36.17371043420889, lng: -115.14548237630042 },
            //     map,
            //     title: "Las Vegas",
            //     // content: pinView.element,
            // });
            // firstCaseMarker.addListener("click", ({ domEvent, latLng }) => {
            //     const { target } = domEvent;
            //     case__segue_actions("1");
            // });


            // When a case is initiated, remove these pins, but if user navigates
            // back to home, re-render
            // const firstCasePinMarkup = document.createElement("div");
            // firstCasePinMarkup.className = "geo-tooltip map-interaction-pin";
            // firstCasePinMarkup.innerHTML = '<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div><span class="tooltiptext">Corridor Efficiency</span>';
            // const firstCasePinMarkupMarker = new google.maps.marker.AdvancedMarkerView({
            //     map,
            //     position: { lat: 36.17371043420889, lng: -115.14548237630042 },
            //     content: firstCasePinMarkup,
            // });
            // firstCasePinMarkupMarker.addListener("click", ({ domEvent, latLng }) => {
            //     animateCaseSegueOverlay(() => {
            //         case__segue_actions("1");
            //     });
            // });
            // markers.push(firstCasePinMarkupMarker);

            const secondCasePinMarkup = document.createElement("div");
            secondCasePinMarkup.className = "geo-tooltip map-interaction-pin";
            secondCasePinMarkup.innerHTML = '<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div><span class="tooltiptext">Incident Management</span>';
            const secondCasePinMarkupMarker = new google.maps.marker.AdvancedMarkerView({
                map,
                position: { lat: 39.087365920307164, lng: -84.50319069788853 },
                content: secondCasePinMarkup,
                title: 'Incident Management',
            });
            secondCasePinMarkupMarker.addListener("click", ({ domEvent, latLng }) => {
                animateCaseSegueOverlay(() => {
                    case__segue_actions("2");
                });
            });
            markers.push(secondCasePinMarkupMarker);

            const thirdCasePinMarkup = document.createElement("div");
            thirdCasePinMarkup.className = "geo-tooltip map-interaction-pin";
            thirdCasePinMarkup.innerHTML = '<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div><span class="tooltiptext">Traffic Calming</span>';
            const thirdCasePinMarkupMarker = new google.maps.marker.AdvancedMarkerView({
                map,
                position: { lat: 40.61838588522724, lng: -74.08022429330637 },
                content: thirdCasePinMarkup,
                title: 'Traffic Calming',
            });
            thirdCasePinMarkupMarker.addListener("click", ({ domEvent, latLng }) => {
                animateCaseSegueOverlay(() => {
                    case__segue_actions("3");
                });
            });
            markers.push(thirdCasePinMarkupMarker);


            const forthCasePinMarkup = document.createElement("div");
            forthCasePinMarkup.className = "geo-tooltip map-interaction-pin";
            forthCasePinMarkup.innerHTML = '<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div><span class="tooltiptext">Curbside Management</span>';
            const forthCasePinMarkupMarker = new google.maps.marker.AdvancedMarkerView({
                map,
                position:
                {
                    "lng": -83.01694368972852,
                    "lat": 40.01483687218137
                },
                content: forthCasePinMarkup,
                title: 'Curbside Management',
            });
            forthCasePinMarkupMarker.addListener("click", ({ domEvent, latLng }) => {
                animateCaseSegueOverlay(() => {
                    case__segue_actions("4");
                });
            });
            markers.push(forthCasePinMarkupMarker);

            // Fifth Case
            // const fifthCaseMarker = new google.maps.Marker({
            //     position: { lat: 34.05081607771005, lng: -118.23749918595396 },
            //     map,
            //     title: "Los Angeles",
            //     // content: pinView.element,
            // });
            // fifthCaseMarker.addListener("click", ({ domEvent, latLng }) => {
            //     const { target } = domEvent;
            //     case__segue_actions("5");
            // });
            const fifthCasePinMarkup = document.createElement("div");
            fifthCasePinMarkup.className = "geo-tooltip map-interaction-pin";
            fifthCasePinMarkup.innerHTML = '<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div><span class="tooltiptext">Freight Movement</span>';
            const fifthCasePinMarkupMarker = new google.maps.marker.AdvancedMarkerView({
                map,
                position: { lat: 34.05081607771005, lng: -118.23749918595396 },
                content: fifthCasePinMarkup,
                title: 'Freight Movement',
            });
            fifthCasePinMarkupMarker.addListener("click", ({ domEvent, latLng }) => {
                animateCaseSegueOverlay(() => {
                    case__segue_actions("5");
                });
            });
            markers.push(fifthCasePinMarkupMarker);

            // 6.1 Case
            // const jacksonvilleFloridaCaseMarker = new google.maps.Marker({
            //     position: { lat: 30.337403339850187, lng: -81.76358979913455 },
            //     map,
            //     title: "Freight Parking - Jacksonville"
            // });
            // jacksonvilleFloridaCaseMarker.addListener("click", ({ domEvent, latLng }) => {
            //     const { target } = domEvent;
            //     case__segue_actions("6.1");
            // });

            // Sixth Case
            // const seventhCaseMarker = new google.maps.Marker({
            //     position: { lat: 28.575058142973443, lng: -81.83572768412587 },
            //     map,
            //     title: "Freight Parking"
            // });
            // seventhCaseMarker.addListener("click", ({ domEvent, latLng }) => {
            //     const { target } = domEvent;
            //     case__segue_actions("6");
            // });
            const sixthCasePinMarkup = document.createElement("div");
            sixthCasePinMarkup.className = "geo-tooltip map-interaction-pin";
            sixthCasePinMarkup.innerHTML = '<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div><span class="tooltiptext">Freight Parking</span>';
            const sixthCasePinMarkupMarker = new google.maps.marker.AdvancedMarkerView({
                map,
                position: { lat: 28.575058142973443, lng: -81.83572768412587 },
                content: sixthCasePinMarkup,
                title: 'Freight Parking',
            });
            sixthCasePinMarkupMarker.addListener("click", ({ domEvent, latLng }) => {
                animateCaseSegueOverlay(() => {
                    case__segue_actions("6");
                });
            });
            markers.push(sixthCasePinMarkupMarker);

            const seventhCasePinMarkup = document.createElement("div");
            seventhCasePinMarkup.className = "geo-tooltip map-interaction-pin";
            seventhCasePinMarkup.innerHTML = '<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div><span class="tooltiptext">Border Crossing</span>';
            const seventhCasePinMarkupMarker = new google.maps.marker.AdvancedMarkerView({
                map,
                position: { lat: 43.077288920590156, lng: -79.03814958890744 },
                content: seventhCasePinMarkup,
                title: 'Border Crossing',
            });
            seventhCasePinMarkupMarker.addListener("click", ({ domEvent, latLng }) => {
                animateCaseSegueOverlay(() => {
                    case__segue_actions("7");
                });
            });
            markers.push(seventhCasePinMarkupMarker);

            const eighthCasePinMarkup = document.createElement("div");
            eighthCasePinMarkup.className = "geo-tooltip map-interaction-pin";
            eighthCasePinMarkup.innerHTML = '<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div><span class="tooltiptext">Charging Infrastructure</span>';
            const eighthCasePinMarkupMarker = new google.maps.marker.AdvancedMarkerView({
                map,
                position: { lat: 32.08091806605336, lng: -81.09126909797172 },
                content: eighthCasePinMarkup,
                title: 'Charging Infrastructure',
            });
            eighthCasePinMarkupMarker.addListener("click", ({ domEvent, latLng }) => {
                animateCaseSegueOverlay(() => {
                    case__segue_actions("8");
                });
            });
            markers.push(eighthCasePinMarkupMarker);

            // FINISH INIT
            setTimeout(function () {
                jQuery('.interactive__map-loading').removeClass('open');
                jQuery('#INITIALIZATION_TEXT_TO_BE_REMOVED').remove();
                jQuery('#case_segue_loading').show();
            }, 1000);

            function menuTransformationsThirdLevel(clickedCaseLink) {
                // Second Breadcrumb
                $('.back-button-container').show();
                const clickedTextFirst = clickedCaseLink.text();
                const clickedHrefFirst = clickedCaseLink.attr('href');
                // $(`.interactive__map-top__bar-breadcrumbs-breadcrumb[data-casesegue=${casesegue}]`).addClass('opened-menu');
                const match = clickedHrefFirst.match(/#?(\d+)/);
                if (match)
                    preOpenDropdownMenu(match[1])
                $('.interactive__map-top__bar-breadcrumbs-breadcrumb.second-child').find('span.interactive__map-top__bar-breadcrumbs-breadcrumb-text').text(clickedTextFirst);
                $('.interactive__map-top__bar-breadcrumbs-breadcrumb.second-child').attr('href', clickedHrefFirst);
                $('.interactive__map-top__bar-breadcrumbs-breadcrumb.second-child').fadeIn(300);
            }

            function clickedMeSubmenuLevelThree(c) {

                var thisElement = $(`a.case__segue[data-casesegue="${c}"]`);
                menuTransformationsThirdLevel(thisElement);
            }

            $('.interactive__map-top__bar-nav-container-submenu.breadcrumb-menu').on('click', 'a', function () {
                menuTransformationsThirdLevel($(this));
            });

            function findAndMoveToTop(arr) {
                let index = arr.length - 1;
                let foundIndex = -1;

                while (index >= 0) {
                    const elementParts = arr[index].split(".");
                    if (elementParts.length === 1 && Number.isInteger(+elementParts[0])) {
                        foundIndex = index;
                        break;
                    }
                    index--;
                }

                if (foundIndex !== -1) {
                    const elementWithoutDecimals = arr[foundIndex].split(".")[0];
                    arr.splice(foundIndex, arr.length - foundIndex, elementWithoutDecimals);
                }
            }

            $('.interactive__map-back-button').click(function () {
                findAndMoveToTop(navigationStack);
                $('.back-button-container').hide();
                console.warn("[RESET STACK]", JSON.stringify(navigationStack));
                // navigationStack.pop();
                let lastItemOfStack = navigationStack[navigationStack.length - 1];

                animateCaseSegueOverlay(() => {
                    if (!Number.isInteger(parseFloat(lastItemOfStack))) {
                        // goToAnInnerCaseFromAMarker(lastItemOfStack);
                        // case__segue_actions(lastItemOfStack);
                    } else {
                        clickedMeSubMenuLevelTwo(lastItemOfStack);
                        $(".interactive__map-top__bar-breadcrumbs-breadcrumb.movement-left.second-child").fadeOut();
                        $(".current-case").removeClass('current-case');

                        goToACaseFromAMarker(lastItemOfStack);
                        case__segue_actions(lastItemOfStack);
                    }
                });


                // alert(JSON.stringify(navigationStack));

                // navigationStack.pop();
                // let lastItemOfStack = navigationStack[navigationStack.length - 1];

                // animateCaseSegueOverlay(() => {
                //     if (!Number.isInteger(parseFloat(lastItemOfStack))) {
                //         goToAnInnerCaseFromAMarker(lastItemOfStack);
                //         case__segue_actions(lastItemOfStack);
                //     } else {
                //         goToACaseFromAMarker(lastItemOfStack);
                //         case__segue_actions(lastItemOfStack);
                //     }
                // });
            });

            /**
             * Checks to see if the 2/3 levels have children to show dropdown menu or not.
             */
            function preOpenDropdownMenu(casesegue) {
                // interactive__map-top__bar-nav-container-submenu breadcrumb-menu
                if ($(`.interactive__map-top__bar-nav-container-submenu.breadcrumb-menu[data-casesubmenu="${casesegue}"]`).children().length > 0)
                    $(`.interactive__map-top__bar-breadcrumbs-breadcrumb[data-casesegue=${casesegue}]`).addClass('opened-menu');
            }

            function menuTransformationsSecondLevel(clickedCaseLink) {
                const treeLevel = clickedCaseLink.data('level');

                const clickedText = clickedCaseLink.find('span').text();
                const clickedHref = clickedCaseLink.attr('href');

                let casesegue = clickedCaseLink.data('casesegue');

                if (clickedCaseLink.hasClass('opened-menu')) {
                    clickedCaseLink.removeClass('opened-menu');
                } else {
                    $('.opened-menu').removeClass('opened-menu');
                    clickedCaseLink.addClass('opened-menu');
                }
                if (treeLevel != 'first') {
                    $('.interactive__map-top__bar').addClass('inner-page-active');
                    $('.interactive__map-top__bar-nav').fadeOut(300);
                    if (casesegue) {
                        $('button.hamburger-menu').removeClass("open");
                        $('button.hamburger-menu').find('.fa-bars').show();
                        $('button.hamburger-menu').find('.fa-times').hide();
                        $('.interactive__map-top__bar').removeClass('open');
                        casesegue = casesegue.toString();
                        let getCaseJSON = GeoInteractiveMap[clickedCaseLink.data('parent')].find((e) => e.case === casesegue);

                        let getCaseJSONChildren = getCaseJSON.children;
                        if (clickedCaseLink.data('level') === 'second') {
                            preOpenDropdownMenu(casesegue);
                            $(`.interactive__map-top__bar-nav-container-submenu.breadcrumb-menu`).hide();
                            $(`.interactive__map-top__bar-nav-container-submenu.breadcrumb-menu[data-casesubmenu=${casesegue}]`).show();
                        }
                        if (getCaseJSONChildren) {
                            // Create new submenu
                            // getCaseJSONChildren = getCaseJSONChildren.map((caseJSONChild) => {
                            //   let breadcrumbSubmenuMarkup = '';
                            //   breadcrumbSubmenuMarkup += `<div class="interactive__map-top__bar-nav-container-submenu-submenu__item-container">`;
                            //   breadcrumbSubmenuMarkup += `<a class="interactive__map-top__bar-nav-container-submenu-submenu__item-container-menu__item  case__segue" data-level="third" href="#${caseJSONChild.case}" title="${caseJSONChild.caseName}" data-casesegue="${caseJSONChild.case}">`;
                            //   breadcrumbSubmenuMarkup += `<span>`;
                            //   breadcrumbSubmenuMarkup += caseJSONChild.caseName;
                            //   breadcrumbSubmenuMarkup += `</span>`;
                            //   breadcrumbSubmenuMarkup += `</a>`;
                            //   breadcrumbSubmenuMarkup += `</div>`;
                            //   return breadcrumbSubmenuMarkup;
                            // }).join('');

                            // console.log(getCaseJSONChildren);

                            // $(".interactive__map-top__bar-nav-container-submenu.breadcrumb-menu").html(getCaseJSONChildren);
                        }
                    }
                }

                // <div class="interactive__map-top__bar-nav-container-submenu-submenu__item-container">
                //     <a class="interactive__map-top__bar-nav-container-submenu-submenu__item-container-menu__item" data-level="third" href="#" title="<?php echo __('Brent Spence Bridge', 'simplistics'); ?>">
                //         <span><?php echo __('Brent Spence Bridge', 'simplistics'); ?></span>
                //     </a>
                // </div>

                if (treeLevel === 'first') {
                    // First Breadcrumb
                    // $('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').find('span.interactive__map-top__bar-breadcrumbs-breadcrumb-text').text(clickedText);
                    // $('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').attr('href', 'javascript:void(0)');
                    // if (casesegue)
                    // $('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').attr('data-casesegue', casesegue);
                    // $('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').addClass('unclickable');
                    // setTimeout(() => {
                    // $('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').fadeIn(300);
                    // }, 300);
                } else if (treeLevel === 'second') {
                    // First Breadcrumb
                    $('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').removeClass('unclickable');
                    // const clickedTextFirst = clickedCaseLink.parent().parent().parent().find('a[data-level="first"] span').text();
                    // const clickedHrefFirst = clickedCaseLink.parent().parent().parent().find('a[data-level="first"]').attr('href');
                    const clickedDataMenuItem = clickedCaseLink.data('menuitem');
                    $('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').find('span.interactive__map-top__bar-breadcrumbs-breadcrumb-text').text(clickedText);//clickedTextFirst);
                    $('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').attr('href', 'javascript:void(0)');//clickedHrefFirst);
                    $('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').attr('data-casesegue', casesegue);
                    // $('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').attr('data-submenu', clickedDataMenuItem);//clickedHrefFirst);
                    setTimeout(() => {
                        $('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').fadeIn(300);
                    }, 300);
                    // Second Breadcrumb
                    // $('.interactive__map-top__bar-breadcrumbs-breadcrumb.second-child').find('span.interactive__map-top__bar-breadcrumbs-breadcrumb-text').text(clickedText);
                    // $('.interactive__map-top__bar-breadcrumbs-breadcrumb.second-child').attr('href', 'javascript:void(0)');
                    // setTimeout(() => {
                    //   $('.interactive__map-top__bar-breadcrumbs-breadcrumb.second-child').fadeIn(300);
                    // }, 600);
                    // console.log(clickedText, clickedHref);
                }

                // setTimeout(() => {
                // $('.interactive__map-top__bar-nav__options').fadeIn(300);
                // }, 300);
            }

            function clickedMeSubMenuLevelTwo(c) {
                var thisElement = $(`a.case__segue[data-casesegue="${c}"]`);
                menuTransformationsSecondLevel(thisElement);
            }

            $('.interactive__map-top__bar-nav').on('click', 'a', function () {
                menuTransformationsSecondLevel($(this));
            });

            /**
             * function animateCaseSegueOverlay
             *  Animate the loading case screen
             *
             * @param {function} theFunctions
             */
            function animateCaseSegueOverlay(theFunctions) {
                jQuery('.interactive__map-loading').addClass('open');
                setTimeout(function () {
                    theFunctions();
                }, case__segue_action_logo_overlay_timer);
                setTimeout(function () {
                    jQuery('.interactive__map-loading').removeClass('open');
                }, remove_case__segue_action_logo_overlay_timer);
            }

            function updateDynamicSidebarContent(selectedState, latlng) {
                if (selectedState.sidebar_image) {
                    $('.interactive__map-sidebar-featured').removeClass('no-img');
                    $('#interactive__map_siderbar__image').show();
                    //selectedState.sidebar_image ? selectedState.sidebar_image : `https://picsum.photos/340/260?random=${Math.floor((Math.random() * 1000) + 1
                    $('#interactive__map_siderbar__image').attr('src', selectedState.sidebar_image);
                } else {
                    $('.interactive__map-sidebar-featured').addClass('no-img');
                    $('#interactive__map_siderbar__image').hide();
                }
                $('#interactive__map_sidebar__title').text(selectedState.sidebar_title ? selectedState.sidebar_title : selectedState.caseName);
                $('#interactive__map_sidebar__body').html(selectedState.sidebar_content ? `<div class="interactive__map-sidebar-body-section mb-last-0">${selectedState.sidebar_content}</div>` : `<div class="interactive__map-sidebar-body-section mb-last-0"> <p> Start interacting with the map! </p> <p> This content will be editable in the plugin settings. </p> </div> <div class="interactive__map-sidebar-body-section mb-last-0"> <h3>Lorem ipsum</h3> <p> An example of another section. <img src="https://picsum.photos/200/300" alt="Figure 4.2, an example of this" /> </p> </div>`);
                window.setTimeout(function () {
                    $('.interactive__map-sidebar').scrollTop(0);
                }, 0);
                map.setCenter(latlng);
                map.setZoom(parseInt(selectedState.zoom));
            }

            function goToACaseFromAMarker(c) {
                let casesegue = c;
                let latLng;
                let selectedState = {
                    zoom: 5
                };
                selectedState = get_selected_state_by_casegue(casesegue);
                // parentNavs.forEach(parentNav => {
                //     parentNav.forEach(parentNavParentCase => {
                //         if (parentNavParentCase.case === casesegue)
                //             selectedState = parentNavParentCase;
                //         else if (parentNavParentCase.hasChildren) return parentNavParentCase.children.forEach(parentNavParentCaseChild => {
                //             if (parentNavParentCaseChild.case === casesegue)
                //                 selectedState = parentNavParentCaseChild;
                //         })
                //     });
                // })
                latLng = new google.maps.LatLng(selectedState.center.lat, selectedState.center.lng);

                updateDynamicSidebarContent(selectedState, latLng);

                clickedMeSubMenuLevelTwo(casesegue);
            }

            // Sets the map on all markers in the array.
            function setMapOnAll(map) {
                for (let i = 0; i < innerMarkers.length; i++) {
                    innerMarkers[i].map = null;
                }
            }

            // Deletes all markers in the array by removing references to them.
            function deleteMarkers() {
                setMapOnAll(null);
                innerMarkers = [];
            }

            function deleteTopLevelMarkers() {
                for (let i = 0; i < markers.length; i++) {
                    markers[i].map = null;
                }
            }

            function addTopLevelMarkers() {
                for (let i = 0; i < markers.length; i++) {
                    markers[i].map = map;
                }
            }

            function deleteLines() {
                for (let i = 0; i < mapLines.length; i++) {
                    mapLines[i].setMap(null);
                }
                mapLines = [];
            }

            $('button.remove-markers').click(function () {
                deleteMarkers();
            })

            function createFAIconsOnMap(iconsArray, className) {
                iconsArray.forEach((icon) => {
                    const preinterventionIconOneContent = document.createElement("i");
                    if (className.includes("road-traffic-icon")) {
                        preinterventionIconOneContent.innerHTML = `<span class='dot'><img class="fa-car" src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/geotruck.png'}"/> <span class='wave'></span> <span class='wave2'></span></span>`;
                    } else if (className.includes("road-blue-traffic-icon")) {
                        preinterventionIconOneContent.innerHTML = `<span class='dot'><img class="fa-car" src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/geotruck-blue.png'}"/> <span class='wave'></span> <span class='wave2'></span></span>`;
                    }
                    preinterventionIconOneContent.className = className;
                    const preinterventionIconOne = new google.maps.marker.AdvancedMarkerView({
                        map,
                        position: { lat: icon.lat, lng: icon.lng },
                        content: preinterventionIconOneContent,
                    });
                    innerMarkers.push(preinterventionIconOne);
                });
            }

            function innerMapNavOptionsOptionClicked(option) {
                option = option.toString();
                /**
                 * DON'T CLEAR ON THESE INNER MAP OPTIONS
                 */
                if (option !== "6.0.1" && option !== "6.0.2") {
                    deleteMarkers();
                    deleteTopLevelMarkers();
                    deleteLines();
                    clearHeatmaps();
                    $("#map_modal_draggable").css('bottom', '70px');
                }
                if (option === "3.1.1" || option === "3.1.2") {

                    const mainStreetNorthLine = new google.maps.Polyline({
                        path: [
                            {
                                "lat": 40.62180881831022,
                                "lng": -74.0738098501422
                            },
                            {
                                "lat": 40.61978060471002,
                                "lng": -74.07769301320926
                            }
                        ],
                        strokeColor: "red",
                        strokeOpacity: 0.2,
                        strokeWeight: 20,
                        // icons: [
                        //     {
                        //         icon: lineSymbol,
                        //         offset: "100%",
                        //     },
                        // ],
                        map: map,
                    });
                    mapLines.push(mainStreetNorthLine);
                }
                switch (option) {
                    case "3.1.1":
                        // $('#interactive__map_siderbar__image').attr('src', GeoInteractiveMap.default_sidebar_content.image);
                        $('#interactive__map_sidebar__title').text("Pre-Intervention: Speed studies identify need for traffic-calming measures");// + GeoInteractiveMap.default_sidebar_content.title);
                        $('#interactive__map_sidebar__body').html(`<div class="interactive__map-sidebar-body-section mb-last-0">
                        <p>In New York City, several factors can trigger an evaluation for traffic-calming measures. It might be citizen complaints, or simply that an area is a priority because it’s a school zone.</p>
                        <p>The NYC DOT also conducts speed studies across road networks, identifying corridors that have higher speeding averages and take action once they exceed a certain threshold over the posted speed limit.</p>
                        <p>Vanderbilt Ave is one of these cases. Average spot speeds, average travel speeds, and 85th percentile speeds exceed key thresholds. So what can NYC DOT do?</p>
                        <p>Click on the “Car hump” icon in the bottom left corner to see the results of traffic-calming interventions on Vanderbilt Ave.</p></div>`);
                        window.setTimeout(function () {
                            $('.interactive__map-sidebar').scrollTop(0);
                        }, 0);
                        createFAIconsOnMap([
                            { "lat": 40.6218041064122, "lng": -74.07382055909812 },
                            { lat: 40.62143650560306, lng: -74.07447142832845 },
                            { "lat": 40.62146083624677, "lng": -74.07448563697035 },
                            { "lat": 40.62109401324723, "lng": -74.07519611577735 },
                            // next
                        ], "fa-solid fa-triangle-exclamation preintervention-icon red");
                        createFAIconsOnMap([
                            // between talbot and tompkins start
                            { "lat": 40.62081206750572, "lng": -74.07573758038285 },
                            { "lat": 40.62071638059909, "lng": -74.07592131170037 },
                            // { "lat": 40.62063601023473, "lng": -74.0760740725582 },
                            { "lat": 40.62055457436357, "lng": -74.07622829957656 },
                            { "lat": 40.62050673074295, "lng": -74.07631949468306 },
                            { "lat": 40.62043040527629, "lng": -74.07646296545255 },
                            // { "lat": 40.62033878963225, "lng": -74.07663730903852 },
                            { "lat": 40.6202681337116, "lng": -74.07675539206662 },
                            // between talbot and tompkins end
                            // next
                        ], "fa-solid fa-triangle-exclamation preintervention-icon red extra");
                        createFAIconsOnMap([
                            { "lat": 40.62010487063351, "lng": -74.07708284214387 },
                            { lat: 40.61996251866325, lng: -74.07730384097287 },
                            { lat: 40.61975892675046, lng: -74.07767935022498 },
                            // next
                        ], "fa-solid fa-triangle-exclamation preintervention-icon red");
                        // Pre-intervention: Highlight the road red or orange between Errington Pl and Park Hill Ct.
                        // const line5 = new google.maps.Polyline({
                        //     path: [
                        //         // { lat: 40.62154290536269, lng: -74.07360630163106 },
                        //         { lat: 40.62181924826983, lng: -74.0738116049373 },
                        //         { lat: 40.61978335780904, lng: -74.07768471465185 }
                        //         // { lat: 40.618657483730736, lng: -74.07672180163114 }
                        //     ],
                        //     strokeColor: "#FF0000",
                        //     strokeOpacity: 0.75,
                        //     strokeWeight: 5,
                        //     map: map,
                        // });
                        // mapLines.push(line5);
                        break;
                    case "3.1.2":
                        // $('#interactive__map_siderbar__image').attr('src', GeoInteractiveMap.default_sidebar_content.image);
                        // $('#interactive__map_sidebar__title').text("Post" + GeoInteractiveMap.default_sidebar_content.title);
                        // $('#interactive__map_sidebar__body').html(`<div class="interactive__map-sidebar-body-section mb-last-0">${GeoInteractiveMap.default_sidebar_content.content}</div>`);
                        $('#interactive__map_sidebar__title').text("Post-Intervention: Speed humps reduce average travel speed by 63%");
                        $('#interactive__map_sidebar__body').html(`<div class="interactive__map-sidebar-body-section mb-last-0">
                        <p>After NYC DOT implements speed cushions, Vanderbilt Avenue’s average spot speeds, average travel speeds, and 85th percentile speeds drop by 6-9 mph.</p>
                        <div id="attachment_440" style="width: 260px" class="wp-caption alignnone"><img aria-describedby="caption-attachment-440" loading="lazy" class="wp-image-440 size-full" src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/pre-intervention-graph.png'}" alt="Dec 2021, post-intervention" width="1598" height="649" srcset="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/pre-intervention-graph.png'} 250w, ${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/pre-intervention-graph.png'} 700w, ${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/pre-intervention-graph.png'} 768w, ${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/pre-intervention-graph.png'} 1536w, ${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/pre-intervention-graph.png'} 120w" sizes="(max-width: 1598px) 100vw, 1598px"></div>
                        <p>Geotab ITS data insights indicate more vehicles were driving closer to the average travel speed. The result: more consistent and safer speeds throughout the week.</p>
                        <p>Read the full analysis in <a href="/insights-and-customer-stories/new-york-city-department-of-transportation/">this case study</a>.</p></div>`);
                        window.setTimeout(function () {
                            $('.interactive__map-sidebar').scrollTop(0);
                        }, 0);
                        // On post-intervention: highlight the road yellow or green.
                        createFAIconsOnMap([
                            // { lat: 40.62175002901688, lng: -74.07377405400312 },
                            // { lat: 40.62143650560306, lng: -74.07447142832845 },
                            { lat: 40.62110669367042, lng: -74.0752009891611 },
                            // { lat: 40.62087460281573, lng: -74.07559795608476 },
                            // { lat: 40.62054885990519, lng: -74.07621486414178 },
                            { lat: 40.62023940266883, lng: -74.07682104336303 },
                            // { lat: 40.61996251866325, lng: -74.07730384097287 },
                            // { lat: 40.61975892675046, lng: -74.07767935022498 },
                            // next
                            // { lat: 40.6197385675093, lng: -74.07604320277008 },
                            // { lat: 40.6199869496353, lng: -74.07559795608546 },
                            // { lat: 40.620257725818824, lng: -74.07503871552073 }
                        ], "fa-solid fa-triangle-exclamation preintervention-icon");
                        // const line6 = new google.maps.Polyline({
                        //     path: [
                        //         // { lat: 40.62154290536269, lng: -74.07360630163106 },
                        //         { lat: 40.62181924826983, lng: -74.0738116049373 },
                        //         { lat: 40.61978335780904, lng: -74.07768471465185 }
                        //         // { lat: 40.618657483730736, lng: -74.07672180163114 }
                        //     ],
                        //     strokeColor: "#00FF00",
                        //     strokeOpacity: 0.75,
                        //     strokeWeight: 5,
                        //     map: map,
                        // });
                        // mapLines.push(line6);
                        break;
                    case "4.1":
                        curbsideData2020.forEach((data, idx) => {
                            // if (idx % 8 == 0) {
                            // if (true) {
                            var highwayLineConfig = (color) => ({
                                strokeColor: color,
                                strokeOpacity: 1,
                                strokeWeight: 4,
                            });
                            // 1000-5000
                            var blackHighwayConfig = highwayLineConfig(getColorByValue(data.NumberOfStops / curbsideData2020TotalStops, 2500));
                            var corridor_line = new google.maps.Polyline({
                                path: data.GeographyJSON.coordinates.map(
                                    (pos) => {
                                        // if (idx % 4 == 0)
                                        return {
                                            'lat': pos[1],
                                            'lng': pos[0]
                                        };
                                    }
                                ),
                                strokeColor: blackHighwayConfig.strokeColor,
                                strokeOpacity: blackHighwayConfig.strokeOpacity,
                                strokeWeight: blackHighwayConfig.strokeWeight,
                                map: map,
                            });
                            mapLines.push(corridor_line);
                            // }
                        });
                        break;
                    case "4.2":
                        curbsideData2022.forEach((data, idx) => {
                            // if (idx % 8 == 0) {
                            // if (true) {
                            var highwayLineConfig = (color) => ({
                                strokeColor: color,
                                strokeOpacity: 1,
                                strokeWeight: 2,
                            });
                            var orangeHighwayConfig = highwayLineConfig(getColorByValue(data.NumberOfStops / curbsideData2022TotalStops, 2500));
                            var corridor_line = new google.maps.Polyline({
                                path: data.GeographyJSON.coordinates.map(
                                    (pos, idx) => {
                                        // if (idx % 4 == 0)
                                        return {
                                            'lat': pos[1],
                                            'lng': pos[0]
                                        };
                                    }
                                ),
                                strokeColor: orangeHighwayConfig.strokeColor,
                                strokeOpacity: orangeHighwayConfig.strokeOpacity,
                                strokeWeight: orangeHighwayConfig.strokeWeight,
                                map: map,
                            });
                            mapLines.push(corridor_line);
                            // }
                        });
                        break;
                    case "6.0.1":
                        $("#map_modal_draggable").draggable({
                            containment: '#map_draggable_container',
                        });
                        $("#map_modal_draggable .content").html(`<img style="max-height:400px;" src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/TA-BawldinFL-Graph.png'}" />`);
                        $("#map_modal_draggable").show();
                        $('#map_modal_draggable .close-modal').click(function () {
                            $(this).parent().find('.content').html('');
                            $(this).parent().hide();
                        })
                        break;
                    case "6.0.2":
                        $("#map_modal_draggable").draggable({
                            containment: '#map_draggable_container',
                        });
                        $("#map_modal_draggable .content").html(`<img style="max-height:400px;" src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/Pilot-BawldinFL-Graph.png'}" />`);
                        $("#map_modal_draggable").show();
                        $('#map_modal_draggable .close-modal').click(function () {
                            $(this).parent().find('.content').html('');
                            $(this).parent().hide();
                        })
                        break;
                }
            }


            $('.interactive__map-top__bar-nav__options').on('click', 'button.interactive__map-top__bar-nav__options-option', function () {
                $('.interactive__map-top__bar-nav__options-option').removeClass('active');
                $(this).addClass('active');
                if (DEBUG_MODE)
                    console.log("clicked", $(this).data('option'));
                innerMapNavOptionsOptionClicked($(this).data('option'));
            });

            function mobileMenuClicked(thisElement) {
                var thisElement = $('button.hamburger-menu');
                if (!$('.interactive__map-sidebar').hasClass('mobile-open')) {
                    if (thisElement.hasClass('open')) {
                        thisElement.removeClass("open");
                        thisElement.find('.fa-bars').show();
                        thisElement.find('.fa-times').hide();
                        $('.interactive__map-top__bar').removeClass('open');
                    } else {
                        thisElement.addClass("open");
                        thisElement.find('.fa-bars').hide();
                        thisElement.find('.fa-times').show();
                        $('.interactive__map-top__bar').addClass('open');
                    }
                }
            }

            $('button.hamburger-mend').click(function () {
                if (!$('button.hamburger-menu').hasClass('open')) {
                    $('.interactive__map-sidebar').addClass('mobile-open');
                    $('.sidebar-col').addClass('mobile-open');
                    $(this).fadeOut(200);
                }
            })

            $('button.interactive__map-sidebar-featured-close').click(function () {
                $('.interactive__map-sidebar').removeClass('mobile-open');
                $('.sidebar-col').removeClass('mobile-open');
                $('button.hamburger-mend').fadeIn(200);
            })

            $('button.hamburger-menu').click(function () {
                mobileMenuClicked();
            });

            // Reset View
            $('.navigation-home').click(function () {
                $('.back-button-container').hide();
                $('.current-case').removeClass('current-case');
                $('.interactive__map-top__bar-nav__options').removeClass('show');
                $('.interactive__map-top__bar-nav__options').removeClass('vertical');

                $("#map_modal_draggable").hide();
                mobileMenuClicked();
                $('.interactive__map-top__bar').removeClass('inner-page-active');
                // $('.interactive__map-top__bar-nav__options').fadeOut(300);
                $('.opened-menu').removeClass('opened-menu');
                deleteLines();
                clearHeatmaps();
                deleteMarkers();
                addTopLevelMarkers();

                $('#interactive__map_siderbar__image').attr('src', GeoInteractiveMap.default_sidebar_content.image);
                $('#interactive__map_sidebar__title').text(GeoInteractiveMap.default_sidebar_content.title);
                $('#interactive__map_sidebar__body').html(`<div class="interactive__map-sidebar-body-section mb-last-0">${GeoInteractiveMap.default_sidebar_content.content}</div>`);
                window.setTimeout(function () {
                    $('.interactive__map-sidebar').scrollTop(0);
                }, 0);
                $('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').fadeOut(300);
                $('.interactive__map-top__bar-breadcrumbs-breadcrumb.second-child').fadeOut(300);
                setTimeout(() => {
                    $('.interactive__map-top__bar-nav').fadeIn(300);
                }, 300);
            });

            function drawCaseFivePolygons(sanBernadinoColor, portzonesColor) {


                var sanbernardinoConfig = {
                    strokeColor: sanBernadinoColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: sanBernadinoColor,
                    fillOpacity: 0.6
                }

                // Construct the polygon.
                // Define the LatLng coordinates for the polygon's path.
                const triangleThreeCoords = [
                    { "lat": 34.06422284666531, "lng": -117.29628974981397 },
                    { "lat": 34.07350979781374, "lng": -117.31363164898323 },
                    { "lat": 34.09160614883678, "lng": -117.33438621908013 },
                    { "lat": 34.09225523720348, "lng": -117.33579571452461 },
                    { "lat": 34.088274692043804, "lng": -117.35021527018867 },
                    { "lat": 34.090549312196124, "lng": -117.3680680533918 },
                    { "lat": 34.103389905002594, "lng": -117.36198322170709 },
                    { "lat": 34.12385562989516, "lng": -117.3516835390899 },
                    { "lat": 34.122966648348886, "lng": -117.3380283313631 },
                    { "lat": 34.143427635780775, "lng": -117.34077491339436 },
                    { "lat": 34.15592913386247, "lng": -117.35004462774982 },
                    { "lat": 34.16700846021376, "lng": -117.35382117804279 },
                    { "lat": 34.17893841636996, "lng": -117.37304725226154 },
                    { "lat": 34.20165747636821, "lng": -117.42282905157795 },
                    { "lat": 34.205064807480326, "lng": -117.4255756336092 },
                    { "lat": 34.22578977079498, "lng": -117.42488898810139 },
                    { "lat": 34.23373771906713, "lng": -117.4090961414217 },
                    { "lat": 34.23287275934477, "lng": -117.40103617862057 },
                    { "lat": 34.22208596554722, "lng": -117.37975016787838 },
                    { "lat": 34.21271736597334, "lng": -117.37116709903073 },
                    { "lat": 34.207322851250375, "lng": -117.35159770205807 },
                    { "lat": 34.2064710542034, "lng": -117.33786479190182 },
                    { "lat": 34.19267764128797, "lng": -117.31940171963771 },
                    { "lat": 34.181601684697604, "lng": -117.29262254483302 },
                    { "lat": 34.16001613010537, "lng": -117.227714392999 },
                    { "lat": 34.15986197574059, "lng": -117.22615005874238 },
                    { "lat": 34.16454934214502, "lng": -117.22615005874238 },
                    { "lat": 34.16405220956029, "lng": -117.20889809035859 },
                    { "lat": 34.149989246876025, "lng": -117.20894100570283 },
                    { "lat": 34.15034440101914, "lng": -117.22627880477509 },
                    { "lat": 34.15465997650305, "lng": -117.22614056290631 },
                    { "lat": 34.153168395282485, "lng": -117.24356419266705 },
                    { "lat": 34.146704572257235, "lng": -117.2477698964024 }
                    , { "lat": 34.14436042631351, "lng": -117.2477698964024 },
                    { "lat": 34.142371402990015, "lng": -117.22588307084088 },
                    { "lat": 34.141343805592776, "lng": -117.20311963005872 },
                    { "lat": 34.141414843810324, "lng": -117.19487988396497 },
                    { "lat": 34.1388574303524, "lng": -117.19204747124525 },
                    { "lat": 34.13779181856733, "lng": -117.19101750298353 },
                    { "lat": 34.13580264061583, "lng": -117.19178997917982 },
                    { "lat": 34.13232146653853, "lng": -117.19779812737318 },
                    { "lat": 34.126657216421, "lng": -117.21282588369704 },
                    { "lat": 34.124667776415684, "lng": -117.22509967214918 },
                    { "lat": 34.11961174870909, "lng": -117.24308733684693 },
                    { "lat": 34.113180839290386, "lng": -117.20790809705353 },
                    { "lat": 34.11033831485861, "lng": -117.20722145154572 },
                    { "lat": 34.08816334636816, "lng": -117.24601692273713 },
                    { "lat": 34.06655137874826, "lng": -117.25328556503958 },
                    { "lat": 34.06029425371805, "lng": -117.2872745176763 },
                    { "lat": 34.060434357210035, "lng": -117.29134018220707 },
                    { "lat": 34.063029693806286, "lng": -117.29327137269779 }
                ];

                const pulseHTMLSanBernardino = document.createElement("div");
                pulseHTMLSanBernardino.className = "box-letter simple-pulse";
                pulseHTMLSanBernardino.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>`;

                const markerPulseHTMLSanBernardino = new google.maps.marker.AdvancedMarkerView({
                    map,
                    position: {
                        "lat": 34.11490053313679,
                        "lng": -117.29516117341886
                    },
                    content: pulseHTMLSanBernardino,
                });
                innerMarkers.push(markerPulseHTMLSanBernardino);

                const portzonesThree = new google.maps.Polygon({
                    paths: triangleThreeCoords,
                    strokeColor: sanbernardinoConfig.strokeColor,
                    strokeOpacity: sanbernardinoConfig.strokeOpacity,
                    strokeWeight: sanbernardinoConfig.strokeWeight,
                    fillColor: sanbernardinoConfig.fillColor,
                    fillOpacity: sanbernardinoConfig.fillOpacity,
                });

                portzonesThree.addListener("click", ({ domEvent, latLng }) => {
                    // show additional sidebar content
                    animateCaseSegueOverlay(() => {
                        case__segue_actions("5.3");
                    });
                });
                mapLines.push(portzonesThree);
                portzonesThree.setMap(map);

                // const islandOfLongBeachCircle = new google.maps.Circle({
                //     strokeColor: "#415968",
                //     strokeOpacity: 0.8,
                //     strokeWeight: 3,
                //     fillColor: "#C6D3DB",
                //     fillOpacity: 0.35,
                //     map,
                //     center: { lat: 33.757097741912375, lng: -118.2031519325791 },
                //     radius: 5000,
                // });

                // islandOfLongBeachCircle.addListener("click", ({ domEvent, latLng }) => {
                //     // show additional sidebar content
                //     animateCaseSegueOverlay(() => {
                //         case__segue_actions("5.2");
                //     });
                // });


                var portzonesConfig = {
                    strokeColor: portzonesColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: portzonesColor,
                    fillOpacity: 0.6
                }

                // Define the LatLng coordinates for the polygon's path.
                const defaultPortzoneCoords = [
                    { "lat": 33.73236204509784, "lng": -118.18325609525427 },
                    { "lat": 33.73193376231751, "lng": -118.19870561918005 },
                    { "lat": 33.742925676956744, "lng": -118.242822593057 },
                    { "lat": 33.75134710005162, "lng": -118.2457408364652 },
                    { "lat": 33.756342468696204, "lng": -118.23114961942419 },
                    { "lat": 33.77703446644312, "lng": -118.22840303739294 },
                    { "lat": 33.77433302400092, "lng": -118.20912886655218 },
                    { "lat": 33.771832863902645, "lng": -118.20652840547514 },
                    { "lat": 33.767233212745275, "lng": -118.20665797408506 },
                    { "lat": 33.76209576778527, "lng": -118.20511302169248 },
                    { "lat": 33.757528891511264, "lng": -118.19841822799131 },
                    { "lat": 33.75723869667542, "lng": -118.19796178650978 },
                    { "lat": 33.75586501367328, "lng": -118.19781158280495 },
                    { "lat": 33.74928173380477, "lng": -118.19029066872719 },
                    { "lat": 33.73843338424828, "lng": -118.1858274729264 },

                ];

                const pulseHTMLLongBeach = document.createElement("div");
                pulseHTMLLongBeach.className = "box-letter simple-pulse";
                pulseHTMLLongBeach.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>`;

                const markerPulseHTMLLongBeach = new google.maps.marker.AdvancedMarkerView({
                    map,
                    position: {
                        "lat": 33.759423989502515,
                        "lng": -118.20702640779386
                    },
                    content: pulseHTMLLongBeach,
                });
                innerMarkers.push(markerPulseHTMLLongBeach);

                // Construct the polygon.
                const defaultPortzone = new google.maps.Polygon({
                    paths: defaultPortzoneCoords,
                    strokeColor: portzonesConfig.strokeColor,
                    strokeOpacity: portzonesConfig.strokeOpacity,
                    strokeWeight: portzonesConfig.strokeWeight,
                    fillColor: portzonesConfig.fillColor,
                    fillOpacity: portzonesConfig.fillOpacity,
                });

                defaultPortzone.addListener("click", ({ domEvent, latLng }) => {
                    // show additional sidebar content
                    animateCaseSegueOverlay(() => {
                        case__segue_actions("5.2");
                    });
                });
                mapLines.push(defaultPortzone);

                defaultPortzone.setMap(map);
            }

            // case__segue_actions("8");

            // Use the DOM setInterval() function to change the offset of the symbol
            // at fixed intervals.
            function animateCircle(line) {
                let count = 0;

                window.setInterval(() => {
                    count = (count + 1) % 300;

                    const icons = line.get("icons");

                    icons[0].offset = count / 3 + "%";
                    line.set("icons", icons);
                }, 20);
            }

            function animateCircleSlow(line) {
                let count = 0;

                window.setInterval(() => {
                    count = (count + 1) % 800;

                    const icons = line.get("icons");

                    icons[0].offset = count / 8 + "%";
                    line.set("icons", icons);
                }, 20);
            }

            function animateCircleSlowest(line) {
                let count = 0;

                window.setInterval(() => {
                    count = (count + 1) % 1200;

                    const icons = line.get("icons");

                    icons[0].offset = count / 12 + "%";
                    line.set("icons", icons);
                }, 20);
            }

            function animateCircleSlowestAbsoluteSlowest(line) {
                let count = 0;

                window.setInterval(() => {
                    count = (count + 1) % 6000;

                    const icons = line.get("icons");

                    icons[0].offset = count / 60 + "%";
                    line.set("icons", icons);
                }, 20);
            }

            function case__segue_actions(c) {
                if (c !== navigationStack[navigationStack.length - 1])
                    navigationStack.push(c);

                if (typeof gtag === 'function') {
                    let selectedState = {
                        zoom: 5
                    };
                    // parentNavs.forEach(parentNav => {
                    //     parentNav.forEach(parentNavParentCase => {
                    //         if (parentNavParentCase.case === c)
                    //             selectedState = parentNavParentCase;
                    //         else if (parentNavParentCase.hasChildren) return parentNavParentCase.children.forEach(parentNavParentCaseChild => {
                    //             if (parentNavParentCaseChild.case === c)
                    //                 selectedState = parentNavParentCaseChild;
                    //         })
                    //     });
                    // })
                    selectedState = get_selected_state_by_casegue(c);
                    var clickedCase = `#${selectedState.case}: ${selectedState.caseName}`;
                    gtag('event', 'Map Click', {
                        'event_category': 'Interactive Map',
                        'event_action': 'Click',
                        'event_label': clickedCase
                    });
                }

                deleteMarkers();
                deleteTopLevelMarkers();
                deleteLines();
                clearHeatmaps();
                $("#map_modal_draggable").hide();
                $('.interactive__map-top__bar-nav__options').removeClass('show');
                $('.interactive__map-top__bar-nav__options').removeClass('vertical');
                switch (c) {
                    case '1':
                        goToACaseFromAMarker("1");

                        const LetterCorridorEfficiency = document.createElement("div");
                        LetterCorridorEfficiency.className = "box-letter";
                        // LetterCorridorEfficiency.textContent = "J";
                        LetterCorridorEfficiency.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>Cheyenne Avenue`;
                        const markerCorridorEfficiency = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 36.21816793773074, lng: -115.24675686603392 },
                            content: LetterCorridorEfficiency,
                        });
                        markerCorridorEfficiency.addListener("click", ({ domEvent, latLng }) => {
                            animateCaseSegueOverlay(() => {
                                goToAnInnerCaseFromAMarker("1.1");
                                case__segue_actions("1.1");
                            });
                        });
                        innerMarkers.push(markerCorridorEfficiency);
                        break;
                    case '1.1':
                        goToAnInnerCaseFromAMarker("1.1");

                        const LetterA = document.createElement("div");

                        LetterA.className = "box-letter non-interactive";
                        LetterA.textContent = "A";

                        const markerA = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 36.218252048374396, lng: -115.26045914196243 },
                            content: LetterA,
                        });
                        markerA.addListener("click", ({ domEvent, latLng }) => {
                            // animateCaseSegueOverlay(() => {
                            // goToAnInnerCaseFromAMarker("1.1");
                            // });
                        });
                        innerMarkers.push(markerA);

                        const LetterB = document.createElement("div");
                        LetterB.className = "box-letter non-interactive";
                        LetterB.textContent = "B";
                        const markerB = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 36.218209564483196, lng: -115.2513786274561 },
                            content: LetterB,
                        });
                        markerB.addListener("click", ({ domEvent, latLng }) => {
                            // animateCaseSegueOverlay(() => {
                            // goToAnInnerCaseFromAMarker("1.1");
                            // });
                        });
                        innerMarkers.push(markerB);

                        const LetterC = document.createElement("div");
                        LetterC.className = "box-letter non-interactive";
                        LetterC.textContent = "C";
                        const markerC = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 36.21821026082218, lng: -115.248197513353 },
                            content: LetterC,
                        });
                        markerC.addListener("click", ({ domEvent, latLng }) => {
                            // animateCaseSegueOverlay(() => {
                            // goToAnInnerCaseFromAMarker("1.1");
                            // });
                        });
                        innerMarkers.push(markerC);

                        const LetterD = document.createElement("div");
                        LetterD.className = "box-letter non-interactive";
                        LetterD.textContent = "D";
                        const markerD = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 36.21823190014554, lng: -115.24548848224796 },
                            content: LetterD,
                        });
                        markerD.addListener("click", ({ domEvent, latLng }) => {
                            // animateCaseSegueOverlay(() => {
                            //     goToAnInnerCaseFromAMarker("1.1");
                            // });
                        });
                        innerMarkers.push(markerD);

                        const LetterE = document.createElement("div");
                        LetterE.className = "box-letter non-interactive";
                        LetterE.textContent = "E";
                        const markerE = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 36.218202107944464, lng: -115.24228922036608 },
                            content: LetterE,
                        });
                        markerE.addListener("click", ({ domEvent, latLng }) => {
                            // animateCaseSegueOverlay(() => {
                            //     goToAnInnerCaseFromAMarker("1.1");
                            // });
                        });
                        innerMarkers.push(markerE);

                        const LetterF = document.createElement("div");
                        LetterF.className = "box-letter non-interactive";
                        LetterF.textContent = "F";
                        const markerF = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 36.217523880076776, lng: -115.2340375021347 },
                            content: LetterF,
                        });
                        markerF.addListener("click", ({ domEvent, latLng }) => {
                            // animateCaseSegueOverlay(() => {
                            //     goToAnInnerCaseFromAMarker("1.1");
                            // });
                        });
                        innerMarkers.push(markerF);

                        const LetterG = document.createElement("div");
                        LetterG.className = "box-letter non-interactive";
                        LetterG.textContent = "G";
                        const markerG = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 36.21683858889123, lng: -115.22579781299797 },
                            content: LetterG,
                        });
                        markerG.addListener("click", ({ domEvent, latLng }) => {
                            // animateCaseSegueOverlay(() => {
                            //     goToAnInnerCaseFromAMarker("1.1");
                            // });
                        });
                        innerMarkers.push(markerG);

                        const LetterH = document.createElement("div");
                        LetterH.className = "box-letter non-interactive";
                        LetterH.textContent = "H";
                        const markerH = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 36.21698821107618, lng: -115.21680647999558 },
                            content: LetterH,
                        });
                        markerH.addListener("click", ({ domEvent, latLng }) => {
                            // animateCaseSegueOverlay(() => {
                            //     goToAnInnerCaseFromAMarker("1.1");
                            // });
                        });
                        innerMarkers.push(markerH);

                        const LetterI = document.createElement("div");
                        LetterI.className = "box-letter non-interactive";
                        LetterI.textContent = "I";
                        const markerI = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 36.217122862143675, lng: -115.21209660650166 },
                            content: LetterI,
                        });
                        markerI.addListener("click", ({ domEvent, latLng }) => {
                            // animateCaseSegueOverlay(() => {
                            //     goToAnInnerCaseFromAMarker("1.1");
                            // });
                        });
                        innerMarkers.push(markerI);

                        const LetterJ = document.createElement("div");
                        LetterJ.className = "box-letter";
                        // LetterJ.textContent = "J";
                        LetterJ.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>J`;
                        const markerJ = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 36.217275915413026, lng: -115.20747809723464 },
                            content: LetterJ,
                        });
                        markerJ.addListener("click", ({ domEvent, latLng }) => {
                            animateCaseSegueOverlay(() => {
                                goToAnInnerCaseFromAMarker("1.2");
                                case__segue_actions("1.2");
                            });
                        });
                        innerMarkers.push(markerJ);
                        break;
                    case '1.2':
                        goToAnInnerCaseFromAMarker("1.2");
                        // down right green
                        createFAIconsOnMap([
                            { lat: 36.21763517287686, lng: -115.20757198401708 }
                        ], "road-blue-traffic-icon green ce-down-right");
                        // right up green
                        createFAIconsOnMap([
                            { lat: 36.21734732601607, lng: -115.20660101494775 },
                        ], "road-blue-traffic-icon green ce-right-up");
                        // up left red
                        createFAIconsOnMap([
                            { lat: 36.216719776118666, lng: -115.20738958434332 },
                        ], "road-blue-traffic-icon red ce-up-left");
                        // left up red
                        createFAIconsOnMap([
                            { lat: 36.217191520991264, lng: -115.20844637462167 }
                        ], "road-blue-traffic-icon red ce-left-up");

                        var line_sw = 10;
                        var line_opacity = 0.4;
                        var lineSymbol = {
                            path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                            scale: 5,
                            strokeWeight: 10,
                            fillOpacity: 0,
                            fillColor: '#000'
                        };

                        // createFAIconsOnMap([
                        //     { "lat": 39.091383791526994, "lng": -84.52257489282037 }
                        //     // next
                        // ], "fa-solid fa-triangle-exclamation preintervention-icon red");

                        // Left to Right to Up (red)
                        const line1 = new google.maps.Polyline({
                            path: [
                                // { lat: 36.217191520991264, lng: -115.20844637462167 },
                                {
                                    "lat": 36.21718897221548,
                                    "lng": -115.20835706686795
                                },
                                { lat: 36.21719584891268, lng: -115.20742445305808 },
                                { lat: 36.21764378748203, lng: -115.20742445305808 }
                            ],
                            strokeColor: "#D70040",
                            strokeOpacity: line_opacity,
                            strokeWeight: line_sw,
                            icons: [
                                {
                                    icon: lineSymbol,
                                    offset: "100%",
                                },
                            ],
                            map: map,
                        });
                        mapLines.push(line1);

                        // animateCircleSlow(line1);
                        // Right to Middle to Up (green)
                        const line2 = new google.maps.Polyline({
                            path: [
                                {
                                    "lat": 36.217348129813765,
                                    "lng": -115.2066712552623
                                },
                                // { lat: 36.21734732601607, lng: -115.20660101494775 },
                                { lat: 36.21734732601607, lng: -115.20735739783719 },
                                { lat: 36.21765244327458, lng: -115.20736276225503 }
                            ],
                            strokeColor: "#00FF00",
                            strokeOpacity: line_opacity,
                            strokeWeight: line_sw,
                            icons: [
                                {
                                    icon: lineSymbol,
                                    offset: "100%",
                                },
                            ],
                            map: map,
                        });
                        mapLines.push(line2);
                        // animateCircle(line2);
                        // Bottom to Middle to Left (dark red)
                        const line3 = new google.maps.Polyline({
                            path: [
                                {
                                    "lat": 36.21675976902753,
                                    "lng": -115.20739022733343
                                },
                                // { lat: 36.216719776118666, lng: -115.20738958434332 },
                                { lat: 36.21734250626277, lng: -115.20738794331689 },
                                { lat: 36.217308374782824, lng: -115.20844637462167 }
                            ],
                            strokeColor: "#D70040",
                            strokeOpacity: line_opacity,
                            strokeWeight: line_sw,
                            icons: [
                                {
                                    icon: lineSymbol,
                                    offset: "100%",
                                },
                            ],
                            map: map,
                        });
                        mapLines.push(line3);
                        // animateCircleSlow(line3);
                        // Top to Middle to Right (dark green)
                        const line4 = new google.maps.Polyline({
                            path: [
                                {
                                    "lat": 36.21759045577438,
                                    "lng": -115.20757232140004
                                },
                                // { lat: 36.21763517287686, lng: -115.20757198401708 },
                                { lat: 36.21723786484254, lng: -115.20757537253412 },
                                { lat: 36.21722527277435, lng: -115.20660167213198 }
                            ],
                            strokeColor: "#00FF00",
                            strokeOpacity: line_opacity,
                            strokeWeight: line_sw,
                            icons: [
                                {
                                    icon: lineSymbol,
                                    offset: "100%",
                                },
                            ],
                            map: map,
                        });
                        mapLines.push(line4);
                        // animateCircle(line4);
                        break;
                    case "2":
                        goToACaseFromAMarker("2");

                        const LetterBrentSpenceBridge = document.createElement("div");
                        LetterBrentSpenceBridge.className = "box-letter";
                        // LetterBrentSpenceBridge.textContent = "J";
                        LetterBrentSpenceBridge.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>Brent Spence Bridge`;
                        const markerBrentSpenceBridge = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 39.09097820105547, lng: -84.52262004346184 },
                            content: LetterBrentSpenceBridge,
                        });
                        markerBrentSpenceBridge.addListener("click", ({ domEvent, latLng }) => {
                            // goToACaseFromAMarker("3.1");
                            animateCaseSegueOverlay(() => {
                                goToAnInnerCaseFromAMarker("2.1");
                                case__segue_actions("2.1");
                            });
                        });
                        innerMarkers.push(markerBrentSpenceBridge);

                        const MainStreetMarker = document.createElement("div");
                        MainStreetMarker.className = "box-letter";
                        // Used to be <i class="fa fa-car" aria-hidden="true"></i> instead of "Main street"
                        MainStreetMarker.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div> Main Street`;
                        const markerMainStreet = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 39.08575891222146, lng: -84.517503074929 },
                            content: MainStreetMarker,
                        });
                        markerMainStreet.addListener("click", ({ domEvent, latLng }) => {
                            animateCaseSegueOverlay(() => {
                                goToAnInnerCaseFromAMarker("2.2");
                                case__segue_actions("2.2");
                            });
                        });
                        innerMarkers.push(markerMainStreet);

                        const InterstatesMarker = document.createElement("div");
                        InterstatesMarker.className = "box-letter";
                        InterstatesMarker.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div> Interstates`;
                        const markerInterstates = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { "lat": 39.077844166243764, "lng": -84.52061297249739 },
                            content: InterstatesMarker,
                        });
                        markerInterstates.addListener("click", ({ domEvent, latLng }) => {
                            animateCaseSegueOverlay(() => {
                                goToAnInnerCaseFromAMarker("2.3");
                                case__segue_actions("2.3");
                            });
                        });
                        innerMarkers.push(markerInterstates);
                        break;
                    case "2.1":
                        goToAnInnerCaseFromAMarker("2.1");
                        createFAIconsOnMap([
                            { "lat": 39.091383791526994, "lng": -84.52257489282037 }
                            // next
                        ], "fa-solid fa-triangle-exclamation preintervention-icon red");

                        // var line_sw = 2;
                        // var line_opacity = 0.4;

                        var line_sw = 20;
                        var line_opacity = 0.4;

                        // var lineSymbol = {
                        //     path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                        //     scale: 5,
                        //     strokeWeight: 4,
                        //     fillOpacity: 0,
                        //     fillColor: '#000'
                        // };

                        // Bottom to Top - 2.1
                        // line 1 - 2.1
                        createFAIconsOnMap([
                            {
                                "lat": 39.094212243017736,
                                "lng": -84.52028561646426
                            }
                        ], "road-blue-traffic-icon red ce-down-right bsb-down");
                        createFAIconsOnMap([
                            {
                                "lat": 39.088060434639566,
                                "lng": -84.51832250205118
                            }
                        ], "road-blue-traffic-icon red ce-down-right bsb-up");
                        const firstBridgeLeft = new google.maps.Polyline({
                            path: [
                                {
                                    "lat": 39.09373940062441,
                                    "lng": -84.52008517769936
                                },
                                {
                                    "lat": 39.08836102108175,
                                    "lng": -84.51847985456729
                                },
                            ],
                            strokeColor: "red",
                            strokeOpacity: line_opacity,
                            strokeWeight: line_sw,
                            // icons: [
                            //     {
                            //         icon: lineSymbol,
                            //         offset: "100%",
                            //     },
                            // ],
                            map: map,
                        });
                        mapLines.push(firstBridgeLeft);
                        // animateCircleSlow(firstBridgeLeft);
                        // line 2 - 2.1
                        createFAIconsOnMap([
                            {
                                "lat": 39.09560240459818,
                                "lng": -84.51055351194144
                            }
                        ], "road-blue-traffic-icon red-orange ce-down-right bsb-down");
                        createFAIconsOnMap([
                            {
                                "lat": 39.08940848663895,
                                "lng": -84.50902319846372
                            }
                        ], "road-blue-traffic-icon red-orange ce-down-right bsb-up");
                        const secondBridgeLeft = new google.maps.Polyline({
                            path: [
                                // { "lat": 39.095121927542344, "lng": -84.51071473805474 },
                                // { "lat": 39.089755774396274, "lng": -84.50957491262564 }
                                { "lat": 39.09509171946657, "lng": -84.51043310824126 },
                                {
                                    "lat": 39.08986586081971,
                                    "lng": -84.50908631908418
                                }
                                // { "lat": 39.089731442946096, "lng": -84.50913024617005 },
                                // { "lat": 39.09522800700874, "lng": -84.51050686590986 }
                            ],
                            strokeColor: "rgb(255,71,0)",
                            strokeOpacity: line_opacity,
                            strokeWeight: line_sw,
                            // icons: [
                            //     {
                            //         icon: lineSymbol,
                            //         offset: "100%",
                            //     },
                            // ],
                            map: map,
                        });
                        mapLines.push(secondBridgeLeft);
                        // animateCircleSlow(secondBridgeLeft);
                        // line 3 - 2.1
                        createFAIconsOnMap([
                            // { "lat": 39.09752452006824, "lng": -84.50342378283013 }
                            {
                                "lat": 39.0981205506699,
                                "lng": -84.50342071269522
                            },
                        ], "road-blue-traffic-icon red-orange ce-down-right bsb-down");
                        createFAIconsOnMap([
                            {
                                "lat": 39.09363555361112,
                                "lng": -84.49873725521316
                            }
                        ], "road-blue-traffic-icon red-orange ce-down-right bsb-up");
                        const thirdBridgeLeft = new google.maps.Polyline({
                            path: [
                                {
                                    "lat": 39.09775137051778,
                                    "lng": -84.50304470132563
                                },
                                {
                                    "lat": 39.09395665708125,
                                    "lng": -84.49914673420088
                                }
                                // { "lat": 39.09752452006824, "lng": -84.50342378283013 },
                                // { "lat": 39.09356880212365, "lng": -84.4995417036572 }
                            ],
                            // strokeColor: "rgb(255,152,0)",
                            strokeColor: "rgb(255,71,0)",
                            strokeOpacity: line_opacity,
                            strokeWeight: line_sw,
                            // icons: [
                            //     {
                            //         icon: lineSymbol,
                            //         offset: "100%",
                            //     },
                            // ],
                            map: map,
                        });
                        mapLines.push(thirdBridgeLeft);
                        // animateCircleSlow(thirdBridgeLeft);
                        // line 4 - 2.1
                        createFAIconsOnMap([
                            // { "lat": 39.101475155854374, "lng": -84.49769720472801 }
                            {
                                "lat": 39.10195872672615,
                                "lng": -84.49770633878234
                            }
                        ], "road-blue-traffic-icon red-orange ce-down-right bsb-down");
                        createFAIconsOnMap([
                            {
                                "lat": 39.09897951359831,
                                "lng": -84.49150005228886
                            }
                        ], "road-blue-traffic-icon red-orange ce-down-right bsb-up");
                        const forthBridgeLeft = new google.maps.Polyline({
                            path: [
                                // { "lat": 39.101475155854374, "lng": -84.49769720472801 },
                                // { "lat": 39.09870257648265, "lng": -84.49249908365717 }
                                {
                                    "lat": 39.10182188120541,
                                    "lng": -84.49727969190585
                                },
                                {
                                    "lat": 39.09918635730112,
                                    "lng": -84.49221414434687
                                }
                            ],
                            // strokeColor: "rgb(255, 200, 0)",
                            strokeColor: "rgb(255,71,0)",
                            // strokeOpacity: 0.7,
                            // strokeWeight: 4,
                            strokeOpacity: line_opacity,
                            strokeWeight: line_sw,
                            // icons: [
                            //     {
                            //         icon: lineSymbol,
                            //         offset: "100%",
                            //     },
                            // ],
                            map: map,
                        });
                        mapLines.push(forthBridgeLeft);
                        // animateCircleSlow(forthBridgeLeft);

                        // Top to Bottom - 2.1
                        // line 1 - 2.1
                        // const firstBridgeRight = new google.maps.Polyline({
                        //     path: [
                        //         { "lat": 39.08869052436227, "lng": -84.51817465496826 },
                        //         { "lat": 39.09378838507853, "lng": -84.5198832360646 }
                        //         // { "lat": 39.08857565155406, "lng": -84.51831192539073 },
                        //         // { "lat": 39.09378211896781, "lng": -84.51994620491585 }
                        //     ],
                        //     strokeColor: "red",
                        //     strokeOpacity: 0.7,
                        //     strokeWeight: 4,
                        //     icons: [
                        //         {
                        //             icon: lineSymbol,
                        //             offset: "100%",
                        //         },
                        //     ],
                        //     map: map,
                        // });
                        // mapLines.push(firstBridgeRight);
                        // animateCircleSlow(firstBridgeRight);
                        // line 2 - 2.1
                        // const secondBridgeRight = new google.maps.Polyline({
                        //     path: [
                        //         { "lat": 39.08988035270483, "lng": -84.50881025670222 },
                        //         { "lat": 39.09517167717661, "lng": -84.51010972613112 },
                        //         // { "lat": 39.09521548605577, "lng": -84.51033972955334 },
                        //         // { "lat": 39.08973897967765, "lng": -84.50903364134129 }
                        //     ],
                        //     strokeColor: "rgb(255,71,0)",
                        //     strokeOpacity: 0.7,
                        //     strokeWeight: 4,
                        //     icons: [
                        //         {
                        //             icon: lineSymbol,
                        //             offset: "100%",
                        //         },
                        //     ],
                        //     map: map,
                        // });
                        // mapLines.push(secondBridgeRight);
                        // animateCircleSlow(secondBridgeRight);
                        // line 3 - 2.1
                        // const thirdBridgeRight = new google.maps.Polyline({
                        //     path: [
                        //         { "lat": 39.094253926907484, "lng": -84.4990055809423 },
                        //         { "lat": 39.097892940940945, "lng": -84.5027158219129 },
                        //     ],
                        //     strokeColor: "rgb(255,152,0)",
                        //     strokeOpacity: 0.7,
                        //     strokeWeight: 4,
                        //     icons: [
                        //         {
                        //             icon: lineSymbol,
                        //             offset: "100%",
                        //         },
                        //     ],
                        //     map: map,
                        // });
                        // mapLines.push(thirdBridgeRight);
                        // animateCircleSlow(thirdBridgeRight);
                        // line 4 - 2.1
                        // const forthBridgeRight = new google.maps.Polyline({
                        //     path: [
                        //         { "lat": 39.0994609644075, "lng": -84.49189926027363 },
                        //         { "lat": 39.10211695250616, "lng": -84.49696327089374 }
                        //     ],
                        //     strokeColor: "rgb(255, 200, 0)",
                        //     strokeOpacity: 0.7,
                        //     strokeWeight: 4,
                        //     icons: [
                        //         {
                        //             icon: lineSymbol,
                        //             offset: "100%",
                        //         },
                        //     ],
                        //     map: map,
                        // });
                        // mapLines.push(forthBridgeRight);
                        // animateCircleSlow(forthBridgeRight);
                        break;
                    case "2.2":
                        goToAnInnerCaseFromAMarker("2.2");
                        createFAIconsOnMap([
                            { "lat": 39.091383791526994, "lng": -84.52257489282037 }
                            // next
                        ], "fa-solid fa-triangle-exclamation preintervention-icon red");
                        var line_sw = 20;
                        var line_opacity = 0.4;
                        // var lineSymbol = {
                        //     path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                        //     scale: 9,
                        //     strokeWeight: 8,
                        //     strokeOpacity: 1,
                        //     fillOpacity: 0,
                        //     fillColor: '#000'
                        // };

                        createFAIconsOnMap([
                            { "lat": 39.080377397775564, "lng": -84.51753015148527 }
                        ], "road-blue-traffic-icon red ce-down-right slight-left bsb-up");
                        const mainStreetNorthLine = new google.maps.Polyline({
                            path: [
                                { "lat": 39.080377397775564, "lng": -84.51753015148527 },
                                { "lat": 39.08535225056334, "lng": -84.51749706238029 },
                                { "lat": 39.086709669594825, "lng": -84.51749706238029 },
                                { "lat": 39.08698988411422, "lng": -84.51761507957694 },
                                { "lat": 39.087381280740935, "lng": -84.51786184280631 },

                            ],
                            strokeColor: "red",
                            strokeOpacity: line_opacity,
                            strokeWeight: line_sw,
                            // icons: [
                            //     {
                            //         icon: lineSymbol,
                            //         offset: "100%",
                            //     },
                            // ],
                            map: map,
                        });
                        mapLines.push(mainStreetNorthLine);
                        // animateCircleSlowest(mainStreetNorthLine);
                        break;
                    case "2.3":
                        goToAnInnerCaseFromAMarker("2.3");
                        createFAIconsOnMap([
                            // { "lat": 39.091383791526994, "lng": -84.52257489282037 }
                            {
                                "lat": 39.093556479727134,
                                "lng": -84.52246923593995
                            }
                            // next
                        ], "fa-solid fa-triangle-exclamation preintervention-icon red");
                        // var line_sw = 2;
                        // var line_opacity = 1;
                        var line_sw = 20;
                        var line_opacity = 0.4;
                        // var lineSymbol = {
                        //     path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                        //     scale: 6,
                        //     strokeWeight: 3,
                        //     fillOpacity: 0,
                        //     fillColor: '#000'
                        // };

                        createFAIconsOnMap([
                            // { "lat": 39.05177161907868, "lng": -84.55006475091275 }
                            {
                                "lat": 39.051082507186074,
                                "lng": -84.55262084322085
                            }
                        ], "road-blue-traffic-icon red ce-down-right slight-left bsb-up");
                        const l71 = new google.maps.Polyline({
                            path: [
                                { "lat": 39.05177161907868, "lng": -84.55006475091275 },
                                { "lat": 39.053048852662776, "lng": -84.54764910502415 },
                                { "lat": 39.05518171431214, "lng": -84.54460211558323 },
                                { "lat": 39.05754778233135, "lng": -84.54155512614231 },
                                { "lat": 39.05851418167513, "lng": -84.54007454676608 },
                                { "lat": 39.0593139504396, "lng": -84.53713484568576 },
                                { "lat": 39.06058023245602, "lng": -84.53162022395114 },
                                { "lat": 39.06091346079091, "lng": -84.52780075831393 },
                                { "lat": 39.06131333271669, "lng": -84.52634163660983 },
                                { "lat": 39.06292331078858, "lng": -84.52372745502595 },
                                { "lat": 39.06426892858187, "lng": -84.52202456624892 },
                                { "lat": 39.065268556635594, "lng": -84.52125209005263 },
                                { "lat": 39.0668346121258, "lng": -84.52069419057753 },
                                { "lat": 39.0733783254102, "lng": -84.51884026283916 },
                                { "lat": 39.0743696225457, "lng": -84.51876682908576 },
                                { "lat": 39.074952657185754, "lng": -84.5188633886103 },
                                { "lat": 39.07577897395977, "lng": -84.51927861209502 },
                                { "lat": 39.07939345765941, "lng": -84.5217009355179 },
                                { "lat": 39.079893166351354, "lng": -84.52191014782106 },
                                { "lat": 39.08065105111285, "lng": -84.52210326687013 },
                                { "lat": 39.08259794192646, "lng": -84.5225743683268 },
                                { "lat": 39.08408033338626, "lng": -84.5226816566874 },
                                { "lat": 39.087134779534516, "lng": -84.52278596964689 },
                                { "lat": 39.088542128846356, "lng": -84.52275378313871 },
                                { "lat": 39.091405586676004, "lng": -84.52256574722665 }
                                // { "lat": 39.054304430923544, "lng": -84.53985089898404 },
                                // { "lat": 39.05990295581264, "lng": -84.52834958672818 },
                                // { "lat": 39.0615024528201, "lng": -84.52302808404264 },
                                // { "lat": 39.06550103679928, "lng": -84.51993817925748 },
                                // { "lat": 39.06936611935446, "lng": -84.51899404168424 },
                                // // { "lat": 39.07029903860674, "lng": -84.5209681475192 },
                                // { "lat": 39.07509671425687, "lng": -84.52079648614225 },
                                // { "lat": 39.07882801426373, "lng": -84.52457303643521 },
                                // { "lat": 39.08702285554414, "lng": -84.52628965020475 },
                                // { "lat": 39.08962102107885, "lng": -84.52586049676236 },
                                // { "lat": 39.09154317990289, "lng": -84.52521676659879 }
                            ],
                            strokeColor: "red",
                            strokeOpacity: line_opacity,
                            strokeWeight: line_sw,
                            // icons: [
                            //     {
                            //         icon: lineSymbol,
                            //         offset: "66%",
                            //     },
                            // ],
                            map: map,
                        });
                        mapLines.push(l71);
                        // animateCircleSlowestAbsoluteSlowest(l71);

                        createFAIconsOnMap([
                            // { "lat": 39.04774393137745, "lng": -84.46250705363497 }
                            // {
                            //     "lat": 39.04587416808706,
                            //     "lng": -84.46024689574249
                            // }
                            {
                                "lat": 39.046475476688144,
                                "lng": -84.46014186329397
                            }
                        ], "road-blue-traffic-icon red ce-down-right bsb-up");
                        const l471 = new google.maps.Polyline({
                            path: [
                                { "lat": 39.04774393137745, "lng": -84.46250705363497 },
                                { "lat": 39.050826793807005, "lng": -84.46625141741976 },
                                { "lat": 39.05220987214183, "lng": -84.46796803118929 },
                                { "lat": 39.053259660506704, "lng": -84.46878342272981 },
                                { "lat": 39.053942290762926, "lng": -84.46910720041323 },
                                { "lat": 39.05461912896743, "lng": -84.4693857151892 },
                                { "lat": 39.05536895381022, "lng": -84.46951446122192 },
                                { "lat": 39.05955069733182, "lng": -84.46942863053344 },
                                { "lat": 39.06039009923051, "lng": -84.46936936321852 },
                                { "lat": 39.06117318543158, "lng": -84.46911187115309 },
                                { "lat": 39.062193675792436, "lng": -84.46859733321172 },
                                { "lat": 39.063776460202355, "lng": -84.46737424590093 },
                                { "lat": 39.06884113183983, "lng": -84.46357623793584 },
                                { "lat": 39.069953774331026, "lng": -84.46307642634572 },
                                { "lat": 39.07085336776062, "lng": -84.46311934168996 },
                                { "lat": 39.071852902567336, "lng": -84.46346266444387 },
                                { "lat": 39.07273572355206, "lng": -84.46404190611096 },
                                { "lat": 39.0734187223174, "lng": -84.46483583997937 },
                                { "lat": 39.07419874614642, "lng": -84.46590997642105 },
                                { "lat": 39.07521489157555, "lng": -84.46751930182998 },
                                { "lat": 39.07643091523277, "lng": -84.46897842353408 },
                                { "lat": 39.07733042609765, "lng": -84.46970798438613 },
                                { "lat": 39.08049528057832, "lng": -84.47103836005752 },
                                { "lat": 39.09110439200876, "lng": -84.47620357105416 },
                                { "lat": 39.09237662640848, "lng": -84.47722795128905 },
                                { "lat": 39.093575700599175, "lng": -84.47860124230468 },
                                { "lat": 39.09442503248194, "lng": -84.48010327935302 },
                                { "lat": 39.09692428175802, "lng": -84.48387176757839 },
                                { "lat": 39.09771318515721, "lng": -84.48577560627395 },
                                { "lat": 39.09799628030984, "lng": -84.48853291714126 },
                                { "lat": 39.098542004487506, "lng": -84.49121021646513 },
                                { "lat": 39.09966261174661, "lng": -84.49300319180301 },
                                { "lat": 39.10117794830422, "lng": -84.49609309658817 }
                            ],
                            strokeColor: "red",
                            strokeOpacity: line_opacity,
                            strokeWeight: line_sw,
                            map: map,
                            // icons: [
                            //     {
                            //         icon: lineSymbol,
                            //         offset: "24%",
                            //     },
                            // ],
                        });
                        mapLines.push(l471);
                        // animateCircleSlowestAbsoluteSlowest(l471);
                        break;
                    case "3":
                        goToACaseFromAMarker("3");

                        const LetterVanderbilt = document.createElement("div");
                        LetterVanderbilt.className = "box-letter";
                        // LetterVanderbilt.textContent = "J";
                        LetterVanderbilt.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>Vanderbilt Ave`;
                        const markerVanderbilt = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 40.62081357183366, lng: -74.07574725297718 },
                            content: LetterVanderbilt,
                        });
                        markerVanderbilt.addListener("click", ({ domEvent, latLng }) => {
                            // goToACaseFromAMarker("3.1");
                            animateCaseSegueOverlay(() => {
                                goToAnInnerCaseFromAMarker("3.1");
                                case__segue_actions("3.1");
                            });
                        });
                        innerMarkers.push(markerVanderbilt);

                        break;
                    case "3.1":
                        animateCaseSegueOverlay(() => {
                            $('.interactive__map-top__bar-nav__options').addClass('show');
                            let interactive__map_top__bar_nav__options = "";
                            // Button One
                            interactive__map_top__bar_nav__options += '<button class="interactive__map-top__bar-nav__options-option active tooltip" data-option="3.1.1">';
                            interactive__map_top__bar_nav__options += '<span class="tooltiptext">Pre-Intervention</span>';
                            interactive__map_top__bar_nav__options += '<span class="icon fa-solid fa-triangle-exclamation" aria-hidden="true"></span>';
                            interactive__map_top__bar_nav__options += '<span class="sr-only">';
                            interactive__map_top__bar_nav__options += 'Flag';
                            interactive__map_top__bar_nav__options += '</span>';
                            interactive__map_top__bar_nav__options += '</button>';
                            // Button Two
                            interactive__map_top__bar_nav__options += '<button class="interactive__map-top__bar-nav__options-option tooltip" data-option="3.1.2">';
                            interactive__map_top__bar_nav__options += '<span class="tooltiptext">Post-Intervention</span>';
                            interactive__map_top__bar_nav__options += '<sopan class="icon fa-solid fa-car-bump" aria-hidden="true"></span>';
                            interactive__map_top__bar_nav__options += '<span class="sr-only">';
                            interactive__map_top__bar_nav__options += 'Flag';
                            interactive__map_top__bar_nav__options += '</span>';
                            interactive__map_top__bar_nav__options += '</button>';
                            $('.interactive__map-top__bar-nav__options').html(interactive__map_top__bar_nav__options);


                            goToAnInnerCaseFromAMarker("3.1");
                            // case__segue_actions("3.1");
                            innerMapNavOptionsOptionClicked("3.1.1");
                        });
                        break;
                    case "4":
                        goToACaseFromAMarker("4");

                        innerMapNavOptionsOptionClicked("4.1");

                        $('.interactive__map-top__bar-nav__options').addClass('show');
                        let interactive__map_top__bar_nav__options = "";
                        // Button Two
                        interactive__map_top__bar_nav__options += '<button class="interactive__map-top__bar-nav__options-option larger active" data-option="4.1">';
                        interactive__map_top__bar_nav__options += '2020';//'<i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>';
                        interactive__map_top__bar_nav__options += '<span class="sr-only">';
                        interactive__map_top__bar_nav__options += 'Flag';
                        interactive__map_top__bar_nav__options += '</span>';
                        interactive__map_top__bar_nav__options += '</button>';
                        // Button One
                        interactive__map_top__bar_nav__options += '<button class="interactive__map-top__bar-nav__options-option larger" data-option="4.2">';
                        interactive__map_top__bar_nav__options += '2022';//'<i class="fa-solid fa-car-bump" aria-hidden="true"></i>';
                        interactive__map_top__bar_nav__options += '<span class="sr-only">';
                        interactive__map_top__bar_nav__options += 'Flag';
                        interactive__map_top__bar_nav__options += '</span>';
                        interactive__map_top__bar_nav__options += '</button>';
                        $('.interactive__map-top__bar-nav__options').html(interactive__map_top__bar_nav__options);



                        // innerMapNavOptionsOptionClicked("3.1.1");

                        // const LetterVanderbilt = document.createElement("div");
                        // LetterVanderbilt.className = "box-letter";
                        // // LetterVanderbilt.textContent = "J";
                        // LetterVanderbilt.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>Vanderbilt Ave`;
                        // const markerVanderbilt = new google.maps.marker.AdvancedMarkerView({
                        //     map,
                        //     position: { lat: 40.62081357183366, lng: -74.07574725297718 },
                        //     content: LetterVanderbilt,
                        // });
                        // markerVanderbilt.addListener("click", ({ domEvent, latLng }) => {
                        //     // goToACaseFromAMarker("3.1");
                        //     animateCaseSegueOverlay(() => {
                        //         goToAnInnerCaseFromAMarker("3.1");
                        //         case__segue_actions("3.1");
                        //     });
                        // });
                        // innerMarkers.push(markerVanderbilt);
                        break;
                    case "5":
                        goToACaseFromAMarker("5");
                        // const sanBernadinoCircle = new google.maps.Circle({
                        //     strokeColor: "#a26344",
                        //     strokeOpacity: 0.8,
                        //     strokeWeight: 3,
                        //     fillColor: "#EDDED1",
                        //     fillOpacity: 0.35,
                        //     map,
                        //     center: { lat: 34.10821633182525, lng: -117.29258642256158 },
                        //     radius: 15000,
                        // });
                        // sanBernadinoCircle.addListener("click", ({ domEvent, latLng }) => {
                        //     // show additional sidebar content
                        //     animateCaseSegueOverlay(() => {
                        //         case__segue_actions("5.3");
                        //     });
                        // });

                        drawCaseFivePolygons("red", "red");

                        // const LetterOntarioCalifornia = document.createElement("div");

                        // LetterOntarioCalifornia.className = "box-letter";
                        // LetterOntarioCalifornia.textContent = "Ontario";
                        // LetterOntarioCalifornia.innerHTML = `Ontario`;
                        // <div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>
                        // const markerOntarioCalifornia = new google.maps.marker.AdvancedMarkerView({
                        //     map,
                        //     position: { lat: 34.062310877255115, lng: -117.65182691359803 },
                        //     content: LetterOntarioCalifornia,
                        // });
                        // markerOntarioCalifornia.addListener("click", ({ domEvent, latLng }) => {
                        //     // show additional sidebar content
                        //     animateCaseSegueOverlay(() => {
                        //         case__segue_actions("5.1");
                        //     });
                        // });
                        // innerMarkers.push(markerOntarioCalifornia);

                        // const LetterPortZones = document.createElement("div");

                        // LetterPortZones.className = "box-letter";
                        // LetterPortZones.textContent = "port";

                        // const markerPortZones = new google.maps.marker.AdvancedMarkerView({
                        //     map,
                        //     position: { lat: 33.757097741912375, lng: -118.2031519325791 },
                        //     content: LetterPortZones,
                        // });
                        // markerPortZones.addListener("click", ({ domEvent, latLng }) => {
                        //     // show additional sidebar content
                        //     case__segue_actions("5.2");
                        // });
                        // innerMarkers.push(markerPortZones);
                        // const LetterSanBernadino = document.createElement("div");

                        // LetterSanBernadino.className = "box-letter";
                        // LetterSanBernadino.textContent = "sanber";

                        // const markerSanBernadino = new google.maps.marker.AdvancedMarkerView({
                        //     map,
                        //     position: { lat: 34.10821633182525, lng: -117.29258642256158 },
                        //     content: LetterSanBernadino,
                        // });
                        // markerSanBernadino.addListener("click", ({ domEvent, latLng }) => {
                        //     // show additional sidebar content
                        //     case__segue_actions("5.3");
                        // });
                        // innerMarkers.push(markerSanBernadino);
                        break;
                    case "5.1":
                        goToAnInnerCaseFromAMarker("5.1");
                        drawCaseFivePolygons("red", "red");
                        // var portzonesConfig = {
                        //     strokeColor: "#4D618B",
                        //     strokeOpacity: 0.8,
                        //     strokeWeight: 2,
                        //     fillColor: "#A3AABB",
                        //     fillOpacity: 0.6
                        // }

                        // // Define the LatLng coordinates for the polygon's path.
                        // var longBeachPolyCoords = [
                        //     { "lat": 33.76947176387286, "lng": -118.28007311185583 },
                        //     { "lat": 33.75548614045637, "lng": -118.2893428262113 },
                        //     { "lat": 33.7506334522007, "lng": -118.28659624418005 },
                        //     { "lat": 33.7506334522007, "lng": -118.27560991605505 },
                        //     { "lat": 33.739785273627724, "lng": -118.28247637113317 },
                        //     { "lat": 33.73093442751702, "lng": -118.28110308011755 },
                        //     { "lat": 33.717799231423484, "lng": -118.2786998208402 },
                        //     { "lat": 33.71151647058961, "lng": -118.27354997953161 },
                        //     { "lat": 33.712373237773164, "lng": -118.24745745023473 },
                        //     { "lat": 33.716085796788185, "lng": -118.24093431791052 },
                        //     { "lat": 33.72015514821211, "lng": -118.23080629667028 },
                        //     { "lat": 33.742426075026906, "lng": -118.24290842374548 },
                        //     { "lat": 33.7416409804006, "lng": -118.24514002164587 },
                        //     { "lat": 33.749246852812924, "lng": -118.25271788552102 },
                        //     { "lat": 33.75481323854545, "lng": -118.24464980080423 },
                        //     { "lat": 33.76152096680933, "lng": -118.24954215004739 },
                        //     { "lat": 33.75181599882392, "lng": -118.26567831948098 },
                        //     { "lat": 33.76822817017398, "lng": -118.26876822426614 }
                        // ];
                        // // Construct the polygon.
                        // var portzones = new google.maps.Polygon({
                        //     paths: longBeachPolyCoords,
                        //     strokeColor: portzonesConfig.strokeColor,
                        //     strokeOpacity: portzonesConfig.strokeOpacity,
                        //     strokeWeight: portzonesConfig.strokeWeight,
                        //     fillColor: portzonesConfig.fillColor,
                        //     fillOpacity: portzonesConfig.fillOpacity,
                        // });

                        // portzones.addListener("click", ({ domEvent, latLng }) => {
                        //     // show additional sidebar content
                        //     animateCaseSegueOverlay(() => {
                        //         case__segue_actions("5.2");
                        //     });
                        // });

                        // mapLines.push(portzones);
                        // portzones.setMap(map);
                        // // Define the LatLng coordinates for the polygon's path.
                        // var longBeachPolyCoordsTwo = [
                        //     { "lat": 33.73236204509784, "lng": -118.18325609525427 },
                        //     { "lat": 33.73193376231751, "lng": -118.19870561918005 },
                        //     { "lat": 33.742925676956744, "lng": -118.242822593057 },
                        //     { "lat": 33.75134710005162, "lng": -118.2457408364652 },
                        //     { "lat": 33.756342468696204, "lng": -118.23114961942419 },
                        //     { "lat": 33.77703446644312, "lng": -118.22840303739294 },
                        //     { "lat": 33.77433302400092, "lng": -118.20912886655218 },
                        //     { "lat": 33.771832863902645, "lng": -118.20652840547514 },
                        //     { "lat": 33.767233212745275, "lng": -118.20665797408506 },
                        //     { "lat": 33.76209576778527, "lng": -118.20511302169248 },
                        //     { "lat": 33.757528891511264, "lng": -118.19841822799131 },
                        //     { "lat": 33.75723869667542, "lng": -118.19796178650978 },
                        //     { "lat": 33.75586501367328, "lng": -118.19781158280495 },
                        //     { "lat": 33.74928173380477, "lng": -118.19029066872719 },
                        //     { "lat": 33.73843338424828, "lng": -118.1858274729264 },

                        // ];
                        // // Construct the polygon.
                        // var portzonesTwo = new google.maps.Polygon({
                        //     paths: longBeachPolyCoordsTwo,
                        //     strokeColor: portzonesConfig.strokeColor,
                        //     strokeOpacity: portzonesConfig.strokeOpacity,
                        //     strokeWeight: portzonesConfig.strokeWeight,
                        //     fillColor: portzonesConfig.fillColor,
                        //     fillOpacity: portzonesConfig.fillOpacity,
                        // });

                        // mapLines.push(portzonesTwo);
                        // portzonesTwo.addListener("click", ({ domEvent, latLng }) => {
                        //     // show additional sidebar content
                        //     animateCaseSegueOverlay(() => {
                        //         case__segue_actions("5.2");
                        //     });
                        // });

                        // portzonesTwo.setMap(map);
                        break;
                    case "5.2":
                        goToAnInnerCaseFromAMarker("5.2");

                        var portzonesConfig = {
                            strokeColor: "#21325E",
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: "#21325E",
                            fillOpacity: 0.6
                        }

                        // Define the LatLng coordinates for the polygon's path.
                        var longBeachPolyCoords = [
                            { "lat": 33.76947176387286, "lng": -118.28007311185583 },
                            { "lat": 33.75548614045637, "lng": -118.2893428262113 },
                            { "lat": 33.7506334522007, "lng": -118.28659624418005 },
                            { "lat": 33.7506334522007, "lng": -118.27560991605505 },
                            { "lat": 33.739785273627724, "lng": -118.28247637113317 },
                            { "lat": 33.73093442751702, "lng": -118.28110308011755 },
                            { "lat": 33.717799231423484, "lng": -118.2786998208402 },
                            { "lat": 33.71151647058961, "lng": -118.27354997953161 },
                            { "lat": 33.712373237773164, "lng": -118.24745745023473 },
                            { "lat": 33.716085796788185, "lng": -118.24093431791052 },
                            { "lat": 33.72015514821211, "lng": -118.23080629667028 },
                            { "lat": 33.742426075026906, "lng": -118.24290842374548 },
                            { "lat": 33.7416409804006, "lng": -118.24514002164587 },
                            { "lat": 33.749246852812924, "lng": -118.25271788552102 },
                            { "lat": 33.75481323854545, "lng": -118.24464980080423 },
                            { "lat": 33.76152096680933, "lng": -118.24954215004739 },
                            { "lat": 33.75181599882392, "lng": -118.26567831948098 },
                            { "lat": 33.76822817017398, "lng": -118.26876822426614 }
                        ];
                        // Construct the polygon.
                        var portzones = new google.maps.Polygon({
                            paths: longBeachPolyCoords,
                            strokeColor: portzonesConfig.strokeColor,
                            strokeOpacity: portzonesConfig.strokeOpacity,
                            strokeWeight: portzonesConfig.strokeWeight,
                            fillColor: portzonesConfig.fillColor,
                            fillOpacity: portzonesConfig.fillOpacity,
                        });

                        // portzones.addListener("click", ({ domEvent, latLng }) => {
                        //     // show additional sidebar content
                        //     animateCaseSegueOverlay(() => {
                        //         // case__segue_actions("5.2");
                        //     });
                        // });

                        mapLines.push(portzones);
                        // portzones.setMap(map);
                        // Define the LatLng coordinates for the polygon's path.
                        var longBeachPolyCoordsTwo = [
                            { "lat": 33.73236204509784, "lng": -118.18325609525427 },
                            { "lat": 33.73193376231751, "lng": -118.19870561918005 },
                            { "lat": 33.742925676956744, "lng": -118.242822593057 },
                            { "lat": 33.75134710005162, "lng": -118.2457408364652 },
                            { "lat": 33.756342468696204, "lng": -118.23114961942419 },
                            { "lat": 33.77703446644312, "lng": -118.22840303739294 },
                            { "lat": 33.77433302400092, "lng": -118.20912886655218 },
                            { "lat": 33.771832863902645, "lng": -118.20652840547514 },
                            { "lat": 33.767233212745275, "lng": -118.20665797408506 },
                            { "lat": 33.76209576778527, "lng": -118.20511302169248 },
                            { "lat": 33.757528891511264, "lng": -118.19841822799131 },
                            { "lat": 33.75723869667542, "lng": -118.19796178650978 },
                            { "lat": 33.75586501367328, "lng": -118.19781158280495 },
                            { "lat": 33.74928173380477, "lng": -118.19029066872719 },
                            { "lat": 33.73843338424828, "lng": -118.1858274729264 },

                        ];
                        // Construct the polygon.
                        var portzonesTwo = new google.maps.Polygon({
                            paths: longBeachPolyCoordsTwo,
                            strokeColor: portzonesConfig.strokeColor,
                            strokeOpacity: portzonesConfig.strokeOpacity,
                            strokeWeight: portzonesConfig.strokeWeight,
                            fillColor: portzonesConfig.fillColor,
                            fillOpacity: portzonesConfig.fillOpacity,
                        });

                        mapLines.push(portzonesTwo);
                        // portzonesTwo.addListener("click", ({ domEvent, latLng }) => {
                        //     // show additional sidebar content
                        //     animateCaseSegueOverlay(() => {
                        //         // case__segue_actions("5.2");
                        //     });
                        // });

                        portzonesTwo.setMap(map);

                        // Define the LatLng coordinates for the polygon's path.
                        var longBeachPolyCoordsThree = [
                            { "lat": 33.79292823593114, "lng": -118.23032564429094 },
                            { "lat": 33.80034622014095, "lng": -118.23770708349993 },
                            { "lat": 33.80262854748724, "lng": -118.26912111548235 },
                            { "lat": 33.80605192438162, "lng": -118.26980776099016 },
                            { "lat": 33.80612324327726, "lng": -118.27375597266008 },
                            { "lat": 33.80441157337579, "lng": -118.27401346472551 },
                            { "lat": 33.80634902003879, "lng": -118.2873218322258 },
                            { "lat": 33.80720483989177, "lng": -118.29008558013281 },
                            { "lat": 33.809986195296545, "lng": -118.2900169153201 },
                            { "lat": 33.91484851671934, "lng": -118.29162196626535 },
                            { "lat": 33.91942939967683, "lng": -118.23020108577016 },
                            { "lat": 33.84789021631482, "lng": -118.2267678582311 },
                            { "lat": 33.84668178173287, "lng": -118.2044120445142 },
                            { "lat": 33.845751668498046, "lng": -118.20496686335805 },
                            { "lat": 33.83605624704735, "lng": -118.20840009089711 },
                            { "lat": 33.83634142220219, "lng": -118.2128632866979 },
                            { "lat": 33.82864135905885, "lng": -118.21698315974477 },
                            { "lat": 33.828926558951274, "lng": -118.22247632380727 },
                            { "lat": 33.8346303570009, "lng": -118.22556622859243 },
                            { "lat": 33.8277857536733, "lng": -118.2351792657018 },
                            { "lat": 33.80525173065042, "lng": -118.22762616511586 }
                        ];
                        // Construct the polygon.
                        var portzonesThree = new google.maps.Polygon({
                            paths: longBeachPolyCoordsThree,
                            strokeColor: portzonesConfig.strokeColor,
                            strokeOpacity: portzonesConfig.strokeOpacity,
                            strokeWeight: portzonesConfig.strokeWeight,
                            fillColor: portzonesConfig.fillColor,
                            fillOpacity: portzonesConfig.fillOpacity,
                        });

                        mapLines.push(portzonesThree);
                        // portzonesTwo.addListener("click", ({ domEvent, latLng }) => {
                        //     // show additional sidebar content
                        //     animateCaseSegueOverlay(() => {
                        //     });
                        // });
                        portzonesThree.setMap(map);


                        $("#map_modal_draggable").draggable({
                            containment: '#map_draggable_container',
                        });
                        $("#map_modal_draggable").css('bottom', '30px');
                        $("#map_modal_draggable .content").html(`<img style="max-height:400px;" src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/portzones-overlay.png'}" />`);
                        $("#map_modal_draggable").show();
                        $('#map_modal_draggable .close-modal').click(function () {
                            $(this).parent().find('.content').html('');
                            $(this).parent().hide();
                        })

                        const portzonesLine41810 = new google.maps.Polyline({
                            path: [
                                {
                                    "lat": 33.825937828051174,
                                    "lng": -118.23450624515091
                                },
                                {
                                    "lat": 33.82540305877935,
                                    "lng": -118.22719601870935
                                },
                                {
                                    "lat": 33.82524262734558,
                                    "lng": -118.22127370120447
                                },
                                {
                                    "lat": 33.825429458510285,
                                    "lng": -118.21558348113221
                                },
                                {
                                    "lat": 33.826178260395686,
                                    "lng": -118.21236422327027
                                },
                                {
                                    "lat": 33.82648129397965,
                                    "lng": -118.21028282907471
                                },
                                {
                                    "lat": 33.82649911945116,
                                    "lng": -118.20821216371522
                                },
                                {
                                    "lat": 33.82646346850445,
                                    "lng": -118.20751478937134
                                },
                                {
                                    "lat": 33.82592870252014,
                                    "lng": -118.20724656846986
                                },
                                {
                                    "lat": 33.82477003141364,
                                    "lng": -118.20695688989625
                                },
                                {
                                    "lat": 33.823085103109534,
                                    "lng": -118.2069356680243
                                },
                                {
                                    "lat": 33.82212248389814,
                                    "lng": -118.20700004104066
                                },
                                {
                                    "lat": 33.82051171442598,
                                    "lng": -118.20697858336854
                                },
                                {
                                    "lat": 33.814486678023485,
                                    "lng": -118.2069615632193
                                },
                                {
                                    "lat": 33.80782867005358,
                                    "lng": -118.2069596267311
                                },
                                {
                                    "lat": 33.80700851551167,
                                    "lng": -118.20713128810806
                                },
                                {
                                    "lat": 33.80586741785405,
                                    "lng": -118.20734586482925
                                },
                                {
                                    "lat": 33.804726304979106,
                                    "lng": -118.20730294948501
                                },
                                {
                                    "lat": 33.80376347915456,
                                    "lng": -118.20743169551773
                                },
                                {
                                    "lat": 33.80255101640993,
                                    "lng": -118.20726003414077
                                },
                                {
                                    "lat": 33.80123155213991,
                                    "lng": -118.20713128810806
                                },
                                {
                                    "lat": 33.80005471549292,
                                    "lng": -118.20691671138687
                                },
                                {
                                    "lat": 33.79755596610227,
                                    "lng": -118.20691671138687
                                },
                                {
                                    "lat": 33.79559447846969,
                                    "lng": -118.20691671138687
                                },
                                {
                                    "lat": 33.793632945890266,
                                    "lng": -118.20713128810806
                                },
                                {
                                    "lat": 33.79220634851127,
                                    "lng": -118.20760335689468
                                },
                                {
                                    "lat": 33.79006386374744,
                                    "lng": -118.20786881978476
                                },
                                {
                                    "lat": 33.78810220444826,
                                    "lng": -118.20774007375205
                                },
                                {
                                    "lat": 33.78631883881339,
                                    "lng": -118.20748258168662
                                },
                                {
                                    "lat": 33.78375291358862,
                                    "lng": -118.20754963119589
                                },
                                {
                                    "lat": 33.780221634256485,
                                    "lng": -118.20772129257284
                                },
                                {
                                    "lat": 33.77925853280606,
                                    "lng": -118.20724922378622
                                },
                                {
                                    "lat": 33.77847377546926,
                                    "lng": -118.20703464706503
                                },
                                {
                                    "lat": 33.7767981350478,
                                    "lng": -118.20701869076542
                                },
                                {
                                    "lat": 33.77512155112754,
                                    "lng": -118.20701869076542
                                },
                                {
                                    "lat": 33.77390868273109,
                                    "lng": -118.20706160610966
                                },
                                {
                                    "lat": 33.77239814477117,
                                    "lng": -118.20704599124674
                                },
                                {
                                    "lat": 33.77218267614243,
                                    "lng": -118.20684471411714
                                },
                                {
                                    "lat": 33.77141569093109,
                                    "lng": -118.20647993369111
                                },
                                {
                                    "lat": 33.77022454809517,
                                    "lng": -118.20648467440314
                                },
                                {
                                    "lat": 33.76809044940318,
                                    "lng": -118.2065530949216
                                },
                                {
                                    "lat": 33.767025320719455,
                                    "lng": -118.2065232114309
                                },
                                {
                                    "lat": 33.766329641388516,
                                    "lng": -118.20637300772607
                                },
                                {
                                    "lat": 33.76529562103565,
                                    "lng": -118.20599973698292
                                },
                                {
                                    "lat": 33.762263070119836,
                                    "lng": -118.20509851475391
                                },
                                {
                                    "lat": 33.76195508342603,
                                    "lng": -118.20482375049605
                                },
                                {
                                    "lat": 33.761700582363524,
                                    "lng": -118.20445754515008
                                },
                                {
                                    "lat": 33.761361641311524,
                                    "lng": -118.20398547636346
                                },
                                {
                                    "lat": 33.760897825068426,
                                    "lng": -118.20321300016717
                                },
                                {
                                    "lat": 33.76018425671661,
                                    "lng": -118.20222594724969
                                },
                                {
                                    "lat": 33.75957771894703,
                                    "lng": -118.20119597898797
                                },
                                {
                                    "lat": 33.75923876950055,
                                    "lng": -118.20074536787347
                                },
                                {
                                    "lat": 33.758625641409814,
                                    "lng": -118.19999273060324
                                },
                            ],
                            strokeColor: '#000',
                            strokeOpacity: 1,
                            strokeWeight: 4,
                            map: map,
                        });
                        mapLines.push(portzonesLine41810);

                        const portzonesLine9 = new google.maps.Polyline({
                            path: [
                                {
                                    "lat": 33.78990559509142,
                                    "lng": -118.20786946027528
                                },
                                {
                                    "lat": 33.78987884545416,
                                    "lng": -118.20928164637648
                                },
                                {
                                    "lat": 33.789829535382005,
                                    "lng": -118.21191506688838
                                },
                                {
                                    "lat": 33.78986194184038,
                                    "lng": -118.21587976272833
                                },
                                {
                                    "lat": 33.78985947561046,
                                    "lng": -118.21868044481813
                                },
                                {
                                    "lat": 33.7898944052046,
                                    "lng": -118.22395637318998
                                },
                                {
                                    "lat": 33.78984698830056,
                                    "lng": -118.22495027495553
                                },
                            ],
                            strokeColor: '#97184F',
                            strokeOpacity: 1,
                            strokeWeight: 4,
                            map: map,
                        });
                        mapLines.push(portzonesLine9);

                        const portzonesLine5 = new google.maps.Polyline({
                            path: [
                                {
                                    "lat": 33.80430313478957,
                                    "lng": -118.2207222742193
                                },
                                {
                                    "lat": 33.80283707612409,
                                    "lng": -118.22095028820254
                                },
                                {
                                    "lat": 33.800305121701044,
                                    "lng": -118.22204462948062
                                },
                                {
                                    "lat": 33.79680803770973,
                                    "lng": -118.22358486443783
                                },
                                {
                                    "lat": 33.79497135730837,
                                    "lng": -118.2242285946014
                                },
                                {
                                    "lat": 33.793679877856405,
                                    "lng": -118.22442698760683
                                },
                                {
                                    "lat": 33.791825297644756,
                                    "lng": -118.22474885268862
                                },
                                {
                                    "lat": 33.78982106846222,
                                    "lng": -118.22490301371225
                                },
                                {
                                    "lat": 33.78803659091747,
                                    "lng": -118.22519303752365
                                },
                                {
                                    "lat": 33.78569425360792,
                                    "lng": -118.2255792756218
                                },
                                {
                                    "lat": 33.784606374397804,
                                    "lng": -118.22594405604782
                                },
                                {
                                    "lat": 33.78286212636418,
                                    "lng": -118.22683671351186
                                },
                                {
                                    "lat": 33.78170287199331,
                                    "lng": -118.22769502039662
                                },
                                {
                                    "lat": 33.78018517240976,
                                    "lng": -118.22879056483796
                                },
                                {
                                    "lat": 33.77852649024862,
                                    "lng": -118.23018531352571
                                },
                                {
                                    "lat": 33.77716468269636,
                                    "lng": -118.23257387225212
                                },
                                {
                                    "lat": 33.776932817654746,
                                    "lng": -118.23399007861198
                                },
                                {
                                    "lat": 33.77687931024831,
                                    "lng": -118.23508441989006
                                },
                                {
                                    "lat": 33.77671878782849,
                                    "lng": -118.23631823603691
                                },
                                {
                                    "lat": 33.77620154687401,
                                    "lng": -118.23834598605217
                                },
                                {
                                    "lat": 33.77536325317742,
                                    "lng": -118.23962271754326
                                },
                                {
                                    "lat": 33.77445712430188,
                                    "lng": -118.24030144435153
                                },
                                {
                                    "lat": 33.77320857336238,
                                    "lng": -118.24052674990878
                                },
                                {
                                    "lat": 33.771549756111256,
                                    "lng": -118.24034435969577
                                },
                                {
                                    "lat": 33.769644030818206,
                                    "lng": -118.24008686763034
                                },
                                {
                                    "lat": 33.76489848629331,
                                    "lng": -118.2393183370875
                                },
                                {
                                    "lat": 33.76247244290297,
                                    "lng": -118.23901792967783
                                },
                                {
                                    "lat": 33.7594754709629,
                                    "lng": -118.2387604376124
                                },
                                {
                                    "lat": 33.75836941913243,
                                    "lng": -118.23863169157968
                                },
                                {
                                    "lat": 33.75826238110115,
                                    "lng": -118.23807379210459
                                },
                                {
                                    "lat": 33.7584407777457,
                                    "lng": -118.23743006194101
                                },
                                {
                                    "lat": 33.7590473235602,
                                    "lng": -118.2361855169581
                                },
                                {
                                    "lat": 33.75972522262691,
                                    "lng": -118.23421141112314
                                },
                                {
                                    "lat": 33.76023978950134,
                                    "lng": -118.22941303253174
                                },
                                {
                                    "lat": 33.76008200945602,
                                    "lng": -118.23309561217295
                                },
                                {
                                    "lat": 33.76129507356653,
                                    "lng": -118.23056360686289
                                },
                            ],
                            strokeColor: '#2F1835',
                            strokeOpacity: 1,
                            strokeWeight: 4,
                            map: map,
                        });
                        mapLines.push(portzonesLine5);

                        const portzonesLine2 = new google.maps.Polyline({
                            path: [
                                {
                                    "lat": 33.775095898801176,
                                    "lng": -118.23991373476943
                                },
                                {
                                    "lat": 33.776094719004014,
                                    "lng": -118.24062183794936
                                },
                                {
                                    "lat": 33.77714703483369,
                                    "lng": -118.2412226527687
                                },
                                {
                                    "lat": 33.77823500879457,
                                    "lng": -118.2415659755226
                                },
                                {
                                    "lat": 33.77916047464135,
                                    "lng": -118.24158743319472
                                },
                                {
                                    "lat": 33.781063702706525,
                                    "lng": -118.24171617922744
                                },
                                {
                                    "lat": 33.78362070543784,
                                    "lng": -118.24201258925596
                                },
                                {
                                    "lat": 33.78513609793097,
                                    "lng": -118.24221091678262
                                },
                                {
                                    "lat": 33.78604563160783,
                                    "lng": -118.2425113241923
                                },
                                {
                                    "lat": 33.786634148251004,
                                    "lng": -118.24253278186441
                                },
                                {
                                    "lat": 33.78839439792291,
                                    "lng": -118.24198615433846
                                },
                                {
                                    "lat": 33.79200707554014,
                                    "lng": -118.24055743079627
                                },
                                {
                                    "lat": 33.79502991438026,
                                    "lng": -118.23943350797094
                                },
                                {
                                    "lat": 33.798580024568174,
                                    "lng": -118.23822511132003
                                },
                                {
                                    "lat": 33.80020265640463,
                                    "lng": -118.23760283882858
                                },
                            ],
                            strokeColor: '#000',
                            strokeOpacity: 1,
                            strokeWeight: 4,
                            map: map,
                        });
                        mapLines.push(portzonesLine2);

                        const portzonesLine6 = new google.maps.Polyline({
                            path: [
                                {
                                    "lat": 33.80652029183245,
                                    "lng": -118.2881817945159
                                },
                                {
                                    "lat": 33.80294012458114,
                                    "lng": -118.2890078196645
                                },
                                {
                                    "lat": 33.80199510923835,
                                    "lng": -118.28907219268086
                                },
                                {
                                    "lat": 33.801085744999824,
                                    "lng": -118.28885761595967
                                },
                                {
                                    "lat": 33.79918444020896,
                                    "lng": -118.28812467880786
                                },
                                {
                                    "lat": 33.79716764883448,
                                    "lng": -118.28627676236664
                                },
                                {
                                    "lat": 33.79637103207342,
                                    "lng": -118.28562638042993
                                },
                                {
                                    "lat": 33.795301120489746,
                                    "lng": -118.28491827725
                                },
                                {
                                    "lat": 33.79353573714102,
                                    "lng": -118.28373810528345
                                },
                                {
                                    "lat": 33.791495259868405,
                                    "lng": -118.28254273690085
                                },
                                {
                                    "lat": 33.7902291242673,
                                    "lng": -118.28198483742575
                                },
                                {
                                    "lat": 33.788945136649055,
                                    "lng": -118.28168443001609
                                },
                                {
                                    "lat": 33.78798213329944,
                                    "lng": -118.28149131096701
                                },
                                {
                                    "lat": 33.78483449072248,
                                    "lng": -118.28110260455165
                                },
                                {
                                    "lat": 33.78147021298419,
                                    "lng": -118.28041204812192
                                },
                                {
                                    "lat": 33.77981155570835,
                                    "lng": -118.2802833020892
                                },
                                {
                                    "lat": 33.77656058582565,
                                    "lng": -118.28003848381819
                                },
                                {
                                    "lat": 33.77288224127744,
                                    "lng": -118.2798018365366
                                },
                                {
                                    "lat": 33.772097425527186,
                                    "lng": -118.27986620955296
                                },
                                {
                                    "lat": 33.77129476561932,
                                    "lng": -118.28005932860204
                                },
                                {
                                    "lat": 33.76918409891913,
                                    "lng": -118.28085326247044
                                },
                                {
                                    "lat": 33.76755283730456,
                                    "lng": -118.28183336864467
                                },
                                {
                                    "lat": 33.76521437736171,
                                    "lng": -118.283059739869
                                },
                                {
                                    "lat": 33.76325214892626,
                                    "lng": -118.28430428485191
                                },
                                {
                                    "lat": 33.76159927627328,
                                    "lng": -118.28640344555946
                                },
                                {
                                    "lat": 33.76058244789456,
                                    "lng": -118.28781965191932
                                },
                                {
                                    "lat": 33.759815358854546,
                                    "lng": -118.28857067044349
                                },
                                {
                                    "lat": 33.75693238928348,
                                    "lng": -118.29055921683047
                                },
                                {
                                    "lat": 33.75548399775981,
                                    "lng": -118.29099651892935
                                },
                                {
                                    "lat": 33.75459198005884,
                                    "lng": -118.2911681803063
                                },
                                {
                                    "lat": 33.75264231276741,
                                    "lng": -118.2911463440358
                                },
                                {
                                    "lat": 33.751148763013894,
                                    "lng": -118.29112570133175
                                },
                                {
                                    "lat": 33.75018533478347,
                                    "lng": -118.29108278598751
                                },
                                {
                                    "lat": 33.748793697118096,
                                    "lng": -118.28885118808712
                                },
                                {
                                    "lat": 33.74843686330962,
                                    "lng": -118.28760664310421
                                },
                                {
                                    "lat": 33.748401179847114,
                                    "lng": -118.28554670658077
                                },
                                {
                                    "lat": 33.749342878408044,
                                    "lng": -118.28207219831567
                                },
                                {
                                    "lat": 33.74980675716838,
                                    "lng": -118.28005517713648
                                },
                                {
                                    "lat": 33.75024387139614,
                                    "lng": -118.27730859510523
                                },
                                {
                                    "lat": 33.75020818868556,
                                    "lng": -118.27597821943384
                                },
                                // through polygon
                                {
                                    "lat": 33.756441109499434,
                                    "lng": -118.24533956498418
                                },
                                {
                                    "lat": 33.75815373834749,
                                    "lng": -118.23915975541387
                                },
                                {
                                    "lat": 33.76000904765501,
                                    "lng": -118.23383825272832
                                },
                                {
                                    "lat": 33.761364825215686,
                                    "lng": -118.23066251725469
                                },
                            ],
                            strokeColor: '#C01946',
                            strokeOpacity: 1,
                            strokeWeight: 4,
                            map: map,
                        });
                        mapLines.push(portzonesLine6);


                        const portzonesLine10 = new google.maps.Polyline({
                            path: [
                                {
                                    "lat": 33.781130481943094,
                                    "lng": -118.24165383762652
                                },
                                {
                                    "lat": 33.78159418867338,
                                    "lng": -118.23487321323687
                                },
                                {
                                    "lat": 33.78204526038922,
                                    "lng": -118.22851994690154
                                },
                                {
                                    "lat": 33.78208092984584,
                                    "lng": -118.2261166876242
                                },
                                {
                                    "lat": 33.782656951682064,
                                    "lng": -118.22123818330398
                                },
                                {
                                    "lat": 33.78262128246531,
                                    "lng": -118.22040133409133
                                },
                                {
                                    "lat": 33.78251427472598,
                                    "lng": -118.21975760392776
                                },
                                {
                                    "lat": 33.78231809352329,
                                    "lng": -118.21945719651809
                                },
                                {
                                    "lat": 33.78167991148108,
                                    "lng": -118.21881294250488
                                },
                                {
                                    "lat": 33.78215758129593,
                                    "lng": -118.21937136582962
                                },
                                {
                                    "lat": 33.78178305159553,
                                    "lng": -118.21915678910842
                                },
                                {
                                    "lat": 33.781542281637535,
                                    "lng": -118.21875982217422
                                },
                                {
                                    "lat": 33.78141743768915,
                                    "lng": -118.2183413975679
                                },
                                {
                                    "lat": 33.78108303335941,
                                    "lng": -118.21703247956863
                                },
                                {
                                    "lat": 33.780535571746015,
                                    "lng": -118.21506441587978
                                },
                                {
                                    "lat": 33.77988543418094,
                                    "lng": -118.21274213064662
                                },
                                {
                                    "lat": 33.77919450039128,
                                    "lng": -118.21024546927109
                                },
                                {
                                    "lat": 33.77880212232829,
                                    "lng": -118.20876488989487
                                },
                                {
                                    "lat": 33.77835623598395,
                                    "lng": -118.20773492163315
                                },
                                {
                                    "lat": 33.77808870306325,
                                    "lng": -118.20730576819076
                                },
                                {
                                    "lat": 33.77760256179992,
                                    "lng": -118.20715269877896
                                },
                                {
                                    "lat": 33.77655025156616,
                                    "lng": -118.20721707179531
                                },
                                {
                                    "lat": 33.77523038655772,
                                    "lng": -118.2070883257626
                                },
                                {
                                    "lat": 33.77353593545283,
                                    "lng": -118.20717415645107
                                },
                                {
                                    "lat": 33.77250552107042,
                                    "lng": -118.20716566648467
                                },
                                {
                                    "lat": 33.77129258473143,
                                    "lng": -118.20644182592896
                                },
                                {
                                    "lat": 33.77081544443277,
                                    "lng": -118.20645791918305
                                },
                                {
                                    "lat": 33.76739542064339,
                                    "lng": -118.20646187111828
                                },
                                {
                                    "lat": 33.76653702988931,
                                    "lng": -118.2063701158966
                                },
                                {
                                    "lat": 33.76215519952648,
                                    "lng": -118.20504624646598
                                },
                                {
                                    "lat": 33.76162089151098,
                                    "lng": -118.2043852274276
                                },
                                {
                                    "lat": 33.7606749304186,
                                    "lng": -118.20298353895681
                                },
                                {
                                    "lat": 33.759175249067155,
                                    "lng": -118.20079744820923
                                },
                                {
                                    "lat": 33.758628989193355,
                                    "lng": -118.20001643136668
                                },
                            ],
                            strokeColor: '#F16D4A',
                            strokeOpacity: 1,
                            strokeWeight: 4,
                            map: map,
                        });
                        mapLines.push(portzonesLine10);

                        break;
                    case "5.3":
                        goToAnInnerCaseFromAMarker("5.3");
                        //drawing stuff:
                        drawCaseFivePolygons("#21325E", "red");
                        var highwayLineConfig = (color) => ({
                            strokeColor: color,
                            strokeOpacity: 1.0,
                            strokeWeight: 2,
                        });
                        var blackHighwayConfig = highwayLineConfig("#21325E");
                        var orangeHighwayConfig = highwayLineConfig("#21325E");
                        const highway91Line = new google.maps.Polyline({
                            path: [
                                { "lat": 34.06421307792177, "lng": -117.29628669490602 },
                                { "lat": 34.055482198842626, "lng": -117.29869393239196 },
                                { "lat": 34.052922187386926, "lng": -117.30045346150573 },
                                { "lat": 34.05114435616931, "lng": -117.30245941693232 },
                                { "lat": 34.04224705260994, "lng": -117.3149918330305 },
                                { "lat": 34.02990257237165, "lng": -117.3292490517494 },
                                { "lat": 34.02048745322295, "lng": -117.33868467521516 },
                                { lat: 33.98613122171183, lng: -117.36442663330543 },
                                { lat: 33.980722245030826, lng: -117.36974813599097 },
                                { lat: 33.96820705702631, lng: -117.37721540588844 },
                                { lat: 33.95781363291921, lng: -117.37876035828101 },
                                { lat: 33.947871669534095, lng: -117.38702763399789 },
                                { lat: 33.8970364269666, lng: -117.48030616892021 },
                                { lat: 33.89692830441849, lng: -117.4940819944207 },
                                { lat: 33.884673612184855, lng: -117.52103283060234 },
                                { lat: 33.88225096460959, lng: -117.54549457681816 },
                                { lat: 33.882776136614304, lng: -117.6431765059106 },
                                { lat: 33.86966974095471, lng: -117.67121765304677 },
                                //bend
                                { lat: 33.873660535674055, lng: -117.69396278549306 },
                                { lat: 33.86637572851498, lng: -117.7162745726849 },
                                { lat: 33.87097242992675, lng: -117.73910553581966 },
                                { lat: 33.86826432571792, lng: -117.76052029259456 },
                                { lat: 33.8541701329435, lng: -117.79063837143671 },
                                { lat: 33.85395629629157, lng: -117.80943529221308 },
                                { lat: 33.84697067128691, lng: -117.81939165207636 },
                                { lat: 33.84404794440211, lng: -117.82763139817011 },
                                { lat: 33.85140358279093, lng: -117.83832890668884 },
                                { lat: 33.85142140306493, lng: -117.840517589245 },
                                { lat: 33.846298802997055, lng: -117.8640356693464 },
                                { lat: 33.84664631843439, lng: -117.86863834001596 },
                                { lat: 33.8535250510292, lng: -117.88511783220346 },
                                { lat: 33.85405602967927, lng: -117.88741298686932 },
                                { lat: 33.854012710780836, lng: -117.89525964883444 },
                                { lat: 33.85376007384168, lng: -117.91401525768616 },
                                { lat: 33.85420556728586, lng: -117.91998049053528 },
                                { lat: 33.85368879467498, lng: -117.92519470486023 },
                                { lat: 33.85368030103612, lng: -117.9650883244512 },
                                { lat: 33.85728363030556, lng: -117.9777561477109 },
                                { lat: 33.85610756496807, lng: -117.98586714777194 },
                                { lat: 33.85593096620577, lng: -118.02662136555439 },
                                { lat: 33.87598332100417, lng: -118.06597251655037 },
                                { lat: 33.87648707086493, lng: -118.06907712360817 },
                                { lat: 33.876563612318634, lng: -118.1073655252131 },
                                { lat: 33.87669688624784, lng: -118.19051110249117 },
                                { "lat": 33.875607122815985, "lng": -118.19242236479346 }
                                // { lat: 33.872706233500644, lng: -118.20012413960055 },
                                // { lat: 33.872988275714235, lng: -118.21730478140032 },
                                // { lat: 33.87313080176872, lng: -118.24545724722063 },
                                // { lat: 33.872675120373735, lng: -118.28970601762875 }
                            ],
                            strokeColor: blackHighwayConfig.strokeColor,
                            strokeOpacity: blackHighwayConfig.strokeOpacity,
                            strokeWeight: blackHighwayConfig.strokeWeight,
                            map: map,
                        });
                        mapLines.push(highway91Line);
                        const highway60Line = new google.maps.Polyline({
                            path: [
                                // { "lat": 34.020491210616235, "lng": -117.33868448417745 },
                                { "lat": 33.99389049315677, "lng": -117.35860861361475 },
                                { "lat": 33.998782658956394, "lng": -117.37124201194786 },
                                { "lat": 34.00276740707237, "lng": -117.37999674217247 },
                                { "lat": 34.00518662722665, "lng": -117.38857981102012 },
                                { lat: 34.004642323994894, lng: -117.39770093053282 },
                                { lat: 34.00423432239786, lng: -117.4092908622019 },
                                { lat: 34.01184738621241, lng: -117.4344746135051 },
                                { lat: 34.01932219418977, lng: -117.4822135166488 },
                                { lat: 34.017847234227936, lng: -117.5345161828589 },
                                { lat: 34.03054328554417, lng: -117.58258357661815 },
                                { lat: 34.02998052154486, lng: -117.71162101670375 },
                                { lat: 34.025712509712754, lng: -117.72406646653285 },
                                { lat: 34.02322273701038, lng: -117.749129027568 },
                                { lat: 34.02497514696109, lng: -117.75839696354981 },
                                { lat: 34.023410141905806, lng: -117.76856790013429 },
                                { lat: 34.02597593963566, lng: -117.77907251523554 },
                                { lat: 34.02533572133316, lng: -117.786539785133 },
                                { lat: 34.02775429846681, lng: -117.79671072171747 },
                                { lat: 34.02461591799215, lng: -117.80913778679174 },
                                { lat: 34.02022661387616, lng: -117.81451566330496 },
                                { lat: 34.00468764057054, lng: -117.82971164729588 },
                                { lat: 34.001978338077194, lng: -117.83512598348317 },
                                { lat: 33.994007271853214, lng: -117.88509028675166 },
                                { lat: 33.994185176380135, lng: -117.91000264408198 },
                                { lat: 33.99723811126824, lng: -117.93261145974628 },
                                { lat: 34.01220060533001, lng: -117.98067173592791 },
                                { lat: 34.0257470248601, lng: -117.99523510563182 },
                                { lat: 34.02850200260994, lng: -118.00189744707805 },
                                { lat: 34.029173227553656, lng: -118.01270846522218 },
                                { lat: 34.03009794395367, lng: -118.01888827479249 },
                                { "lat": 34.03406677617121, "lng": -118.0272936300474 }
                                // { lat: 34.03649955031964, lng: -118.03399447596436 },
                                // { lat: 34.04098038735403, lng: -118.05995825922852 },
                                // { lat: 34.04133599920202, lng: -118.07145957148438 },
                                // { lat: 34.03757679817865, lng: -118.08631413466166 },
                                // { lat: 34.032498109719064, lng: -118.12575605197878 },
                                // { lat: 34.03662446707779, lng: -118.15855074130238 },
                                // { lat: 34.03555756779965, lng: -118.17013788424671 }
                            ],
                            strokeColor: orangeHighwayConfig.strokeColor,
                            strokeOpacity: orangeHighwayConfig.strokeOpacity,
                            strokeWeight: orangeHighwayConfig.strokeWeight,
                            map: map,
                        });
                        mapLines.push(highway60Line);
                        const highway210Line = new google.maps.Polyline({
                            path: [
                                // { lat: 34.136020126748285, lng: -117.45220208817145 },
                                // { lat: 34.133872803024595, lng: -117.67680463296854 },
                                // { lat: 34.12051537646576, lng: -117.69851979715311 },
                                // { lat: 34.119733759557626, lng: -117.70375546915018 },
                                // { lat: 34.120657487854686, lng: -117.74495419961893 },
                                // { lat: 34.119315702254035, lng: -117.75168427305374 },
                                // { lat: 34.119670985318855, lng: -117.80262478666458 },
                                // { lat: 34.120652635498054, lng: -117.82541283445511 },
                                // { lat: 34.120901329868246, lng: -117.83442505674515 },
                                // { lat: 34.11759718782921, lng: -117.84581908064041 },
                                // { lat: 34.116993190919494, lng: -117.86047294676489 },
                                // { lat: 34.11759718782924, lng: -117.86336973250097 },
                                // { lat: 34.12026182858147, lng: -117.86954954207128 },
                                // { lat: 34.120865802145886, lng: -117.87942007124609 },
                                // { lat: 34.120679104245966, lng: -117.90532324135694 },
                                // { lat: 34.12082121535971, lng: -117.90901396096143 },
                                // { lat: 34.12762095166821, lng: -117.91806865311719 },
                                // { lat: 34.13075767603281, lng: -117.92879748917676 },
                                // { lat: 34.129088051602025, lng: -117.93630767441846 },
                                // { lat: 34.128768332523435, lng: -117.94057775117017 },
                                // { lat: 34.13427443662104, lng: -117.95772243119336 },

                                // { lat: 34.12706131950231, lng: -117.96312566353957 },
                                // { "lat": 34.11583463419866, "lng": -117.97754521920363 },
                                // { "lat": 34.097357097718216, "lng": -117.98595662667434 },
                                // { "lat": 34.08570807769921, "lng": -117.99591298653762 },
                                // { "lat": 34.06743726469244, "lng": -118.00067658974807 },
                                { "lat": 34.064214075775844, "lng": -117.29628569121996 },
                                { "lat": 34.06436497298656, "lng": -117.29771734581222 },
                                { "lat": 34.06509134196738, "lng": -117.30319480977984 },
                                { "lat": 34.065046329836925, "lng": -117.30887105597203 },
                                { "lat": 34.064868573822146, "lng": -117.31384923590367 },
                                { "lat": 34.06601627731373, "lng": -117.3252092813032 },
                                { "lat": 34.06617625557697, "lng": -117.32923259482554 },
                                { "lat": 34.066851716025155, "lng": -117.33401765570811 },
                                { "lat": 34.06791822155915, "lng": -117.33743645028386 },
                                { "lat": 34.068398144669764, "lng": -117.3409018643311 },
                                { "lat": 34.06867300814597, "lng": -117.34523290144611 },
                                { "lat": 34.06889937686753, "lng": -117.34971153997593 },
                                { "lat": 34.06895270117432, "lng": -117.35391724371128 },
                                { "lat": 34.06884605252715, "lng": -117.36021446936024 },
                                { "lat": 34.06878042186331, "lng": -117.36406502297253 },
                                { "lat": 34.06882023193537, "lng": -117.36712341601023 },
                                { "lat": 34.06878468234564, "lng": -117.36968760782847 },
                                { "lat": 34.068713583121465, "lng": -117.37121110254893 },
                                { "lat": 34.06848159632443, "lng": -117.37798050237961 },
                                { "lat": 34.06829464990133, "lng": -117.38508473850052 },
                                { "lat": 34.06822355026592, "lng": -117.3883033893184 },
                                { "lat": 34.06831074715262, "lng": -117.39122493568445 },
                                { "lat": 34.06845996482295, "lng": -117.39492412809113 },
                                { "lat": 34.06844218995437, "lng": -117.3971342683194 },
                                { "lat": 34.068005324088006, "lng": -117.40241737277219 },
                                { "lat": 34.06773869923714, "lng": -117.4073526373596 },
                                { "lat": 34.06747207354724, "lng": -117.42036671549985 },
                                { "lat": 34.0672288420717, "lng": -117.43121861834979 },
                                { "lat": 34.06738881804556, "lng": -117.43533849139666 },
                                { "lat": 34.0673354927545, "lng": -117.43598222156024 },
                                { "lat": 34.06705000594978, "lng": -117.43931725577275 },
                                { "lat": 34.0668535268957, "lng": -117.44810589641675 },
                                { "lat": 34.066948886347525, "lng": -117.45366132364136 },
                                { "lat": 34.066628932436515, "lng": -117.45765245065552 },
                                { "lat": 34.06633681910136, "lng": -117.4695301833709 },
                                { "lat": 34.065982853426135, "lng": -117.48260906932632 },
                                { "lat": 34.066148979038296, "lng": -117.48821450891076 },
                                { "lat": 34.065935674551525, "lng": -117.49074651422082 },
                                { "lat": 34.06550014050269, "lng": -117.50263415081615 },
                                { "lat": 34.06573122152689, "lng": -117.50585280163402 },
                                { "lat": 34.06663776407463, "lng": -117.51104555828685 },
                                { "lat": 34.06743968830136, "lng": -117.51682347129925 },
                                { "lat": 34.06731822448779, "lng": -117.54121141760251 },
                                { "lat": 34.06744078533971, "lng": -117.56597661458856 },
                                { "lat": 34.06752084389297, "lng": -117.59310986153386 },
                                { "lat": 34.067995390294875, "lng": -117.60224961140202 },
                                { "lat": 34.068781412867175, "lng": -117.60634466143308 },
                                { "lat": 34.069696810084515, "lng": -117.60917707415281 },
                                { "lat": 34.07050947973878, "lng": -117.61094673061415 },
                                { "lat": 34.07356574742553, "lng": -117.6163568708667 },
                                { "lat": 34.07778754202773, "lng": -117.62358200110734 },
                                { "lat": 34.080977945884335, "lng": -117.62916023612611 },
                                { "lat": 34.083883895051954, "lng": -117.63425292077055 },
                                { "lat": 34.08579010030847, "lng": -117.63775641910598 },
                                { "lat": 34.08666554890749, "lng": -117.64013999648434 },
                                { "lat": 34.08734412033652, "lng": -117.64433624530125 },
                                { "lat": 34.08734370135388, "lng": -117.65160956703171 },
                                { "lat": 34.08730476664153, "lng": -117.6613363315839 },
                                { "lat": 34.0873216889682, "lng": -117.6714544073584 },
                                { "lat": 34.08726981115839, "lng": -117.67782823587234 },
                                { "lat": 34.087277229491995, "lng": -117.68305672202453 },
                                { "lat": 34.0868490450994, "lng": -117.68613995812325 },
                                { "lat": 34.08479379385692, "lng": -117.69107657775245 },
                                { "lat": 34.08264939701799, "lng": -117.69623289402581 },
                                { "lat": 34.081885202328664, "lng": -117.7000320796959 },
                                { "lat": 34.08178152952565, "lng": -117.704915494749 },
                                { "lat": 34.081802438921294, "lng": -117.71453904092422 },
                                { "lat": 34.081647671533425, "lng": -117.72414100318467 },
                                { "lat": 34.08154103886895, "lng": -117.7312971368364 },
                                { "lat": 34.08141663392401, "lng": -117.73304593711411 },
                                { "lat": 34.080789206191476, "lng": -117.7352915239037 },
                                { "lat": 34.078442466901826, "lng": -117.74078561263238 },
                                { "lat": 34.07625864941256, "lng": -117.74632245121029 },
                                { "lat": 34.07401140495962, "lng": -117.7518464749454 },
                                { "lat": 34.07204403020693, "lng": -117.75689496536168 },
                                { "lat": 34.07103477641944, "lng": -117.76035775187161 },
                                { "lat": 34.0708581319034, "lng": -117.76279010210895 },
                                { "lat": 34.07161198801023, "lng": -117.76813790754112 },
                                { "lat": 34.07244200799014, "lng": -117.77318008206043 },
                                { "lat": 34.07281132359316, "lng": -117.77604468128834 },
                                { "lat": 34.07290747014179, "lng": -117.78258880476132 },
                                { "lat": 34.07278669720165, "lng": -117.78789560028132 },
                                { "lat": 34.071968346507475, "lng": -117.79148622318208 },
                                { "lat": 34.06953615943893, "lng": -117.79705983157633 },
                                { "lat": 34.065501319963055, "lng": -117.80638130854365 },
                                { "lat": 34.06426359373249, "lng": -117.81115154553865 },
                                { "lat": 34.063646440037815, "lng": -117.8182766283265 },
                                { "lat": 34.06376154394798, "lng": -117.82244938644327 },
                                { "lat": 34.064275488991406, "lng": -117.82697601785797 },
                                { "lat": 34.06512374942051, "lng": -117.82927060237188 },
                                { "lat": 34.067087296497824, "lng": -117.83350792198578 },
                                { "lat": 34.06826411795896, "lng": -117.83735781119134 },
                                { "lat": 34.06891980175701, "lng": -117.84148635723568 },
                                { "lat": 34.06835610482297, "lng": -117.84541536239925 },
                                { "lat": 34.06835610482297, "lng": -117.84541536239925 },
                                { "lat": 34.06824945542486, "lng": -117.8484733126389 },
                                { "lat": 34.06834452659414, "lng": -117.85371026497957 },
                                { "lat": 34.06803064577447, "lng": -117.85708097149339 },
                                { "lat": 34.06806619568058, "lng": -117.85880831409898 },
                                { "lat": 34.06847501852861, "lng": -117.86060002972093 },
                                { "lat": 34.06939930639167, "lng": -117.86285308529344 },
                                { "lat": 34.07144336874165, "lng": -117.86778225153596 },
                                { "lat": 34.07179885281167, "lng": -117.8728249465879 },
                                { "lat": 34.07196174541664, "lng": -117.88920774490211 },
                                { "lat": 34.07208616424949, "lng": -117.90092717650973 },
                                { "lat": 34.07223661454276, "lng": -117.9197983504071 },
                                { "lat": 34.07243212913509, "lng": -117.93713614947937 },
                                { "lat": 34.071912058374195, "lng": -117.94500486111369 },
                                { "lat": 34.067371566998176, "lng": -117.98410768770987 },
                                { "lat": 34.06511884672437, "lng": -117.99999612246758 },
                                { "lat": 34.063384449242676, "lng": -118.00016160561721 },
                                { "lat": 34.04468210622003, "lng": -118.00986047341506 },
                                { "lat": 34.0419795254105, "lng": -118.01277871682326 },
                                { "lat": 34.038138867688126, "lng": -118.02170510842483 },
                                { "lat": 34.03381083254543, "lng": -118.02764789763194 },
                                { "lat": 34.016653834975415, "lng": -118.05438102536651 },
                                { "lat": 34.01047522596334, "lng": -118.05727572689277 },
                                { "lat": 34.008394118843725, "lng": -118.05879922161323 },
                                { "lat": 34.00206922312241, "lng": -118.06638156032972 },
                                { "lat": 33.99726098563576, "lng": -118.06832802047 },
                                { "lat": 33.988751894415174, "lng": -118.07044972458627 },
                                { "lat": 33.98429367396997, "lng": -118.07265103284352 },
                                { "lat": 33.97798144186958, "lng": -118.0785015392316 },
                                { "lat": 33.96726549981193, "lng": -118.08330263100551 },
                                { "lat": 33.954398111827246, "lng": -118.08932093242838 },
                                { "lat": 33.93197004695649, "lng": -118.10164184868728 },
                                { "lat": 33.92461787897401, "lng": -118.10424175065943 },
                                { "lat": 33.914284733840546, "lng": -118.10489532041778 },
                                { "lat": 33.91396524247896, "lng": -118.10538321037563 },
                                { "lat": 33.91325011474528, "lng": -118.13260346907943 },
                                { "lat": 33.91239535701974, "lng": -118.15481801166631 },
                                { "lat": 33.9108995103718, "lng": -118.1691517366419 },
                                { "lat": 33.91276505238202, "lng": -118.17999807455772 }
                                // { "lat": 33.90275006787816, "lng": -118.1053811422152 },
                                // { "lat": 33.883492169458755, "lng": -118.10424956326227 },
                                // { "lat": 33.87957309210077, "lng": -118.10356291775446 },
                                // { "lat": 33.876556528803015, "lng": -118.1024345462726 },
                                // { lat: 34.135598760309094, lng: -117.96604016222416 },
                                // { lat: 34.135361920541825, lng: -118.00581963608376 },
                                // { lat: 34.138558807506385, lng: -118.01504643509499 },
                                // { lat: 34.144196045191904, lng: -118.02363628461286 },
                                // { lat: 34.14799637765024, lng: -118.03303474500105 },
                                // { lat: 34.148697503593354, lng: -118.04144923228853 },
                                // {lat: 34.14822025930057, lng: -118.07422691851808},
                                // {lat: 34.14765199766496, lng: -118.08392578631593},
                                // {lat: 34.15234004183173, lng: -118.0935388234253},
                                // {lat: 34.15202041072229, lng: -118.12330061465455},
                                // {lat: 34.151496338211786, lng: -118.15035744208699},
                                // {lat: 34.145955839082355, lng: -118.16396160621052},
                                // {lat: 34.14116461022795, lng: -118.17757407109298},

                                // { lat: 34.03555756779965, lng: -118.17013788424671 }
                            ],
                            strokeColor: orangeHighwayConfig.strokeColor,
                            strokeOpacity: orangeHighwayConfig.strokeOpacity,
                            strokeWeight: orangeHighwayConfig.strokeWeight,
                            map: map,
                        });
                        mapLines.push(highway210Line);
                        const highway710Line = new google.maps.Polyline({
                            path: [
                                // { lat: 34.02994298462678, lng: -118.17151494415441 },
                                // { lat: 34.02709766599878, lng: -118.17241616638341 },
                                // { lat: 34.02005509211895, lng: -118.17344613464513 },
                                // { lat: 34.015502006083096, lng: -118.17271657379308 },
                                // { lat: 34.005829644504416, lng: -118.17262171382373 },
                                // { lat: 33.99712433583461, lng: -118.17685675573537 },
                                // { lat: 33.99454801065574, lng: -118.17683802755819 },
                                // { lat: 33.99267690074888, lng: -118.17564388010221 },
                                // { lat: 33.98905189665316, lng: -118.17155667167653 },
                                // { lat: 33.9835376694721, lng: -118.16837267140255 },
                                // { lat: 33.979374084304155, lng: -118.16742853382931 },
                                // { lat: 33.97116784030258, lng: -118.16789558066606 },
                                // { lat: 33.96726845236369, lng: -118.16779087068865 },
                                // { lat: 33.963993912780886, lng: -118.16933582308123 },
                                // { lat: 33.95897508028432, lng: -118.1703228759987 },
                                // { lat: 33.95366671192955, lng: -118.17070911409685 },
                                // { lat: 33.94829127019467, lng: -118.1703228759987 },
                                // { lat: 33.93907981458631, lng: -118.17186497665959 },
                                // { lat: 33.93716473796411, lng: -118.17343883143275 },
                                // { lat: 33.934173888156394, lng: -118.17727975474207 },
                                // { lat: 33.93055235434323, lng: -118.1789425299226 },
                                // { lat: 33.92845483989395, lng: -118.17874941087352 },
                                // { lat: 33.92513611391384, lng: -118.17771090639584 },
                                // { lat: 33.9236052087105, lng: -118.17787193781257 },
                                // { lat: 33.91619079147256, lng: -118.17942204700798 },
                                { "lat": 33.9127642548985, "lng": -118.17999777164293 },
                                { lat: 33.90935510752201, lng: -118.18090201136802 },
                                { lat: 33.9065235603261, lng: -118.18274737117027 },
                                { lat: 33.90346039707401, lng: -118.1854724955294 },
                                { lat: 33.898829825084995, lng: -118.18725348231528 },
                                { "lat": 33.89089537525271, "lng": -118.18838396056547 },
                                { "lat": 33.885005806994634, "lng": -118.19047048076081 },
                                { "lat": 33.87850507822474, "lng": -118.19237857556463 },
                                { "lat": 33.87560447712341, "lng": -118.19242786843759 }
                                // { lat: 33.89102852361802, lng: -118.1883907389376 },
                                // { lat: 33.885595646950286, lng: -118.19030542565798 },
                                // { lat: 33.877668431539206, lng: -118.19262285424685 },
                                // { lat: 33.87558539280039, lng: -118.19327651969142 }
                            ],
                            strokeColor: orangeHighwayConfig.strokeColor,
                            strokeOpacity: orangeHighwayConfig.strokeOpacity,
                            strokeWeight: orangeHighwayConfig.strokeWeight,
                            map: map,
                        });
                        mapLines.push(highway710Line);
                        const highwayLongBeachLine = new google.maps.Polyline({
                            path: [
                                { lat: 33.875606394114655, lng: -118.1924281479795 },
                                { lat: 33.84909322250627, lng: -118.20581773538184 },
                                { lat: 33.83255395866635, lng: -118.20907930154395 },
                                { lat: 33.82556658389353, lng: -118.20719102639747 },
                                { lat: 33.80205091468132, lng: -118.20736268777442 },
                                { "lat": 33.79549738204598, "lng": -118.20690648490354 },
                                { "lat": 33.79132460866329, "lng": -118.20772187644407 },
                                { "lat": 33.78629561152351, "lng": -118.20763604575559 },
                                { "lat": 33.7811817011758, "lng": -118.20760910582767 },
                                { "lat": 33.77899504928883, "lng": -118.20742809505502 },
                                { "lat": 33.77646238970799, "lng": -118.2069560262684 },
                                { "lat": 33.77223189201396, "lng": -118.206941021852 }
                            ],
                            strokeColor: blackHighwayConfig.strokeColor,
                            strokeOpacity: blackHighwayConfig.strokeOpacity,
                            strokeWeight: blackHighwayConfig.strokeWeight,
                            map: map,
                        });
                        mapLines.push(highwayLongBeachLine);
                        break;
                    case "6":
                        goToACaseFromAMarker("6");


                        /*
                            Lee: 26.549567895894896, -81.79224798574057
                            Orange: 28.514330012399206, -81.49992205191707
                            Sumter: 28.583778084571108, -82.21301295149435
                            Seminole: 28.724636314221076, -81.37379446482117
                            St Lucie: 27.300291537478792, -80.37251919048023
                            Fort Drum: 27.60202052747045, -80.82259363820837
                            Holmes County: MISSING
                            Canoe Creek: 28.094568817031174, -81.27450517944544
                            Snapper Creek: 25.66211651907673, -80.38747127024149
                            Baker County: 30.255211748311588, -82.40015024795593
                            Pascoe County: 28.215899431470607, -82.36928620811264
                        */
                        duvalData.forEach((data, idx) => {
                            var highwayLineConfig = (color) => ({
                                strokeColor: color,
                                strokeOpacity: 1,
                                strokeWeight: 2,
                            });
                            var orangeHighwayConfig = highwayLineConfig(getColorByValue(data.NumberOfStops / duvalDataTotalStops, 2500));
                            var corridor_line = new google.maps.Polyline({
                                path: data.GeographyJSON.coordinates.map(
                                    (pos, idx) => {
                                        // if (idx % 4 == 0)
                                        return {
                                            'lat': pos[1],
                                            'lng': pos[0]
                                        };
                                    }
                                ),
                                strokeColor: orangeHighwayConfig.strokeColor,
                                strokeOpacity: orangeHighwayConfig.strokeOpacity,
                                strokeWeight: orangeHighwayConfig.strokeWeight,
                                map: map,
                            });
                            mapLines.push(corridor_line);
                        });

                        const Letterusthreeohonehighway = document.createElement("div");
                        Letterusthreeohonehighway.className = "box-letter arrow-left";
                        // Letterusthreeohonehighway.textContent = "US 301 HWY";
                        // Letterusthreeohonehighway.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>US 301 HWY`;
                        Letterusthreeohonehighway.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>Baldwin, Florida`;
                        const markerusthreeohonehighway = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 30.279872621144648, lng: -81.98463587600153 },
                            content: Letterusthreeohonehighway,
                        });
                        markerusthreeohonehighway.addListener("click", ({ domEvent, latLng }) => {
                            animateCaseSegueOverlay(() => {
                                case__segue_actions("6.2");
                            });
                        });
                        innerMarkers.push(markerusthreeohonehighway);

                        // const LetterjacksonvilleFlorida = document.createElement("div");
                        // LetterjacksonvilleFlorida.className = "box-letter arrow-left";
                        // LetterjacksonvilleFlorida.textContent = "Jacksonville";
                        // const markerjacksonvilleFlorida = new google.maps.marker.AdvancedMarkerView({
                        //     map,
                        //     position: { lat: 30.337403339850187, lng: -81.76358979913455 },
                        //     content: LetterjacksonvilleFlorida,
                        // });
                        // markerjacksonvilleFlorida.addListener("click", ({ domEvent, latLng }) => {
                        //     animateCaseSegueOverlay(() => {
                        //         case__segue_actions("6.1");
                        //     });
                        // });
                        // innerMarkers.push(markerjacksonvilleFlorida);

                        // addMultipleNamedMarkers([
                        //     {
                        //         position: { lat: 26.549567895894896, lng: -81.79224798574057 },
                        //         innerHTML: "<span>Lee</span>",
                        //         className: "interactable",
                        //         sentFunction: () => {
                        //             let infoWindow = new google.maps.InfoWindow({
                        //                 content: '<table class="im-data-table freight-parking-case-study"> <thead> <tr> <th>Name</th> <th>Yearly Total Stops</th> </tr> </thead> <tbody> <tr> <td>Lee<br></td> <td>924,473</td> </tr> <tr> <td>Orange</td> <td>522,665</td> </tr> <tr> <td>Sumter</td> <td>322,113</td> </tr> <tr> <td>Seminole</td> <td>93,588</td> </tr> <tr> <td>St Lucie</td> <td>339,394</td> </tr> <tr> <td>Fort Drum</td> <td>107,756</td> </tr> <tr> <td>Canoe Creek</td> <td>294,404</td> </tr> <tr> <td>Snapper Creek</td> <td>162,822</td> </tr> <tr> <td>Baker County</td> <td>191,774</td> </tr> <tr> <td>Pascoe County</td> <td>115,863</td> </tr> <tbody> </table>',
                        //                 position: { lat: 26.549567895894896, lng: -81.79224798574057 }
                        //             });
                        //             infoWindows.push(infoWindow)
                        //             infoWindow.open(map);
                        //         }
                        //     },
                        //     {
                        //         position: { lat: 28.514330012399206, lng: -81.49992205191707 },
                        //         innerHTML: "<span>Orange</span>"
                        //     },
                        //     {
                        //         position: { lat: 28.583778084571108, lng: -82.21301295149435 },
                        //         innerHTML: "<span>Sumter</span>"
                        //     },
                        //     {
                        //         position: { lat: 28.724636314221076, lng: -81.37379446482117 },
                        //         innerHTML: "<span>Seminole</span>"
                        //     },
                        //     {
                        //         position: { lat: 27.300291537478792, lng: -80.37251919048023 },
                        //         innerHTML: "<span>St Lucie</span>"
                        //     },
                        //     {
                        //         position: { lat: 27.60202052747045, lng: -80.82259363820837 },
                        //         innerHTML: "<span>Fort Drum</span>"
                        //     },
                        //     // {
                        //     // position: { lat: 27.60202052747045, lng: -80.82259363820837},
                        //     //innerHTML: "<span>Holmes County</span>"
                        //     // },
                        //     {
                        //         position: { lat: 28.094568817031174, lng: -81.27450517944544 },
                        //         innerHTML: "<span>Canoe Creek</span>"
                        //     },
                        //     {
                        //         position: { lat: 25.66211651907673, lng: -80.38747127024149 },
                        //         innerHTML: "<span>Snapper Creek</span>"
                        //     },
                        //     {
                        //         position: { lat: 30.255211748311588, lng: -82.40015024795593 },
                        //         innerHTML: "<span>Baker County</span>",
                        //         className: "flipped"
                        //     },
                        //     {
                        //         position: { lat: 28.215899431470607, lng: -82.36928620811264 },
                        //         innerHTML: "<span>Pascoe County</span>"
                        //     }
                        // ]);

                        break;
                    case "6.1":
                        animateCaseSegueOverlay(() => {
                            goToAnInnerCaseFromAMarker("6.1");
                        });
                        var line_sw = 20;
                        var line_opacity = .6;
                        // var lineSymbol = {
                        //     path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                        //     scale: 9,
                        //     strokeWeight: 8,
                        //     strokeOpacity: 1,
                        //     fillOpacity: 0,
                        //     fillColor: '#000'
                        // };

                        const us301hwPulseContent = document.createElement("div");
                        us301hwPulseContent.className = "box-letter hidden";
                        // Letterusthreeohonehighway.textContent = "US 301 HWY";
                        us301hwPulseContent.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>`;
                        const us301hwpulse = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { "lat": 30.28061748906959, "lng": -81.98430626205005 },
                            content: us301hwPulseContent,
                        });
                        innerMarkers.push(us301hwpulse);
                        var highwayHighlight301 = new google.maps.Polyline({
                            path: [
                                { "lat": 30.282749235358274, "lng": -81.98349350929742 },
                                { "lat": 30.278073355546738, "lng": -81.98529837770435 },

                            ],
                            strokeColor: "red",
                            strokeOpacity: line_opacity,
                            strokeWeight: line_sw,
                            // icons: [
                            //     {
                            //         icon: lineSymbol,
                            //         offset: "100%",
                            //     },
                            // ],
                            map: map,
                        });
                        highwayHighlight301.addListener("click", ({ domEvent, latLng }) => {
                            // show additional sidebar content
                            animateCaseSegueOverlay(() => {
                                case__segue_actions("6.2");
                            });
                        });
                        mapLines.push(highwayHighlight301);

                        addMultipleNamedMarkers([
                            {
                                position: { "lat": 30.278516375333957, "lng": -81.98527962331767 },
                                innerHTML: `<img src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/parking.png'}"/>`,
                                className: "interactable parking-icon non-interactive-icon",
                                // sentFunction: () => {
                                //     // let infoWindow = new google.maps.InfoWindow({
                                //     //     content: '<table class="im-data-table freight-parking-case-study"> <thead> <tr> <th>Name</th> <th>Yearly Total Stops</th> </tr> </thead> <tbody> <tr> <td>Lee<br></td> <td>924,473</td> </tr> <tr> <td>Orange</td> <td>522,665</td> </tr> <tr> <td>Sumter</td> <td>322,113</td> </tr> <tr> <td>Seminole</td> <td>93,588</td> </tr> <tr> <td>St Lucie</td> <td>339,394</td> </tr> <tr> <td>Fort Drum</td> <td>107,756</td> </tr> <tr> <td>Canoe Creek</td> <td>294,404</td> </tr> <tr> <td>Snapper Creek</td> <td>162,822</td> </tr> <tr> <td>Baker County</td> <td>191,774</td> </tr> <tr> <td>Pascoe County</td> <td>115,863</td> </tr> <tbody> </table>',
                                //     //     position: { lat: 26.549567895894896, lng: -81.79224798574057 }
                                //     // });
                                //     // infoWindows.push(infoWindow)
                                //     // infoWindow.open(map);
                                // }
                            }, {
                                position: { "lat": 30.279259393791314, "lng": -81.9849320618196 },
                                innerHTML: `<img src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/parking.png'}"/>`,
                                className: "interactable parking-icon non-interactive-icon",
                            },
                            {
                                position: { "lat": 30.280031233377215, "lng": -81.98464662199015 },
                                innerHTML: `<img src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/parking.png'}"/>`,
                                className: "interactable parking-icon non-interactive-icon",
                            },
                            {
                                position:
                                {
                                    "lat": 30.280993238565603,
                                    "lng": -81.98427727774137
                                },
                                innerHTML: `<img src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/parking.png'}"/>`,
                                className: "interactable parking-icon non-interactive-icon",
                            },
                            {
                                position:
                                {
                                    "lat": 30.281760400392965,
                                    "lng": -81.98397820095781
                                },
                                innerHTML: `<img src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/parking.png'}"/>`,
                                className: "interactable parking-icon non-interactive-icon",
                            },
                            {
                                position:
                                {
                                    "lat": 30.282626669583426,
                                    "lng": -81.98364560703996
                                },
                                innerHTML: `<img src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/parking.png'}"/>`,
                                className: "interactable parking-icon non-interactive-icon",
                            },
                        ]);

                        // let infoWindow = new google.maps.InfoWindow({
                        //     content: '<table class="im-data-table freight-parking-case-study"> <thead> <tr> <th>Name</th> <th>Yearly Total Stops</th> </tr> </thead> <tbody> <tr> <td>Lee<br></td> <td>84043</td> </tr> <tr> <td>Orange</td> <td>47515</td> </tr> <tr> <td>Sumter</td> <td>29283</td> </tr> <tr> <td>Seminole</td> <td>8508</td> </tr> <tr> <td>St Lucie</td> <td>30854</td> </tr> <tr> <td>Fort Drum</td> <td>9796</td> </tr> <tr> <td>Canoe Creek</td> <td>26764</td> </tr> <tr> <td>Snapper Creek</td> <td>14802</td> </tr> <tr> <td>Baker County</td> <td>17434</td> </tr> <tr> <td>Pascoe County</td> <td>10533</td> </tr> <tbody> </table>',
                        //     position: { lat: 30.337403339850187, lng: -81.76358979913455 }
                        // });

                        // infoWindow.open(map);
                        break;
                    case "6.2":
                        animateCaseSegueOverlay(() => {
                            goToAnInnerCaseFromAMarker("6.2");
                        });
                        $('.interactive__map-top__bar-nav__options').addClass('show');
                        // $('.interactive__map-top__bar-nav__options').addClass('vertical');
                        interactive__map_top__bar_nav__options = "";
                        // Button One
                        interactive__map_top__bar_nav__options += '<button class="interactive__map-top__bar-nav__options-option not-bound-width tooltip" data-option="6.0.1">';
                        // interactive__map_top__bar_nav__options += '<span class="tooltiptext">Click me to see some data!</span>';
                        interactive__map_top__bar_nav__options += 'TA Travel Center';
                        interactive__map_top__bar_nav__options += '<span class="sr-only">';
                        interactive__map_top__bar_nav__options += 'Flag';
                        interactive__map_top__bar_nav__options += '</span>';
                        interactive__map_top__bar_nav__options += '</button>';
                        // Button Two
                        interactive__map_top__bar_nav__options += '<button class="interactive__map-top__bar-nav__options-option not-bound-width tooltip" data-option="6.0.2">';
                        // interactive__map_top__bar_nav__options += '<span class="tooltiptext">Click me to see some data!</span>';
                        interactive__map_top__bar_nav__options += 'Pilot Travel Center';
                        interactive__map_top__bar_nav__options += '<span class="sr-only">';
                        interactive__map_top__bar_nav__options += 'Flag';
                        interactive__map_top__bar_nav__options += '</span>';
                        interactive__map_top__bar_nav__options += '</button>';
                        $('.interactive__map-top__bar-nav__options').html(interactive__map_top__bar_nav__options);

                        var USHighway301StopOneConfig = {
                            strokeColor: "red",
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: "red",
                            fillOpacity: 0.6
                        }

                        // Construct the polygon.
                        // Define the LatLng coordinates for the polygon's path.
                        const USHighway301StopOneCoords = [
                            // { "lat": 30.28724453957321, "lng": -81.98625214537066 },
                            { "lat": 30.287133952414056, "lng": -81.98580085901803 },
                            { "lat": 30.286828211064968, "lng": -81.98459520833472 },
                            { "lat": 30.286645344212847, "lng": -81.98419456808799 },
                            { "lat": 30.286404517180916, "lng": -81.98387151952129 },
                            { "lat": 30.286088904621735, "lng": -81.98361603558847 },
                            { "lat": 30.285858812402573, "lng": -81.98348623765654 },
                            { "lat": 30.28562024956335, "lng": -81.98340577138609 },
                            { "lat": 30.285024998007724, "lng": -81.98333335174269 },
                            { "lat": 30.28437450069283, "lng": -81.98340374047778 },
                            { "lat": 30.284732237218495, "lng": -81.98569275055652 }
                        ];

                        const USHighway301StopOneThree = new google.maps.Polygon({
                            paths: USHighway301StopOneCoords,
                            strokeColor: USHighway301StopOneConfig.strokeColor,
                            strokeOpacity: USHighway301StopOneConfig.strokeOpacity,
                            strokeWeight: USHighway301StopOneConfig.strokeWeight,
                            fillColor: USHighway301StopOneConfig.fillColor,
                            fillOpacity: USHighway301StopOneConfig.fillOpacity,
                        });

                        USHighway301StopOneThree.addListener("click", ({ domEvent, latLng }) => {
                            animateCaseSegueOverlay(() => {
                                case__segue_actions("6.1");
                            });
                        });
                        mapLines.push(USHighway301StopOneThree);
                        USHighway301StopOneThree.setMap(map);


                        var USHighway301StopTwoConfig = {
                            strokeColor: "red",
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: "red",
                            fillOpacity: 0.6
                        }

                        // Construct the polygon.
                        // Define the LatLng coordinates for the polygon's path.
                        const USHighway301StopTwoCoords = [
                            { "lat": 30.28437450069283, "lng": -81.98340374047778 },
                            { "lat": 30.284732237218495, "lng": -81.98569275055652 },
                            { "lat": 30.283340144641933, "lng": -81.98570166464579 },
                            { "lat": 30.283026167518063, "lng": -81.98372915829538 }
                        ];

                        const USHighway301StopTwoThree = new google.maps.Polygon({
                            paths: USHighway301StopTwoCoords,
                            strokeColor: USHighway301StopTwoConfig.strokeColor,
                            strokeOpacity: USHighway301StopTwoConfig.strokeOpacity,
                            strokeWeight: USHighway301StopTwoConfig.strokeWeight,
                            fillColor: USHighway301StopTwoConfig.fillColor,
                            fillOpacity: USHighway301StopTwoConfig.fillOpacity,
                        });

                        USHighway301StopTwoThree.addListener("click", ({ domEvent, latLng }) => {
                            animateCaseSegueOverlay(() => {
                                case__segue_actions("6.1");
                            });
                        });
                        mapLines.push(USHighway301StopTwoThree);
                        USHighway301StopTwoThree.setMap(map);

                        const pulseHTMLBaldwinFl = document.createElement("div");
                        pulseHTMLBaldwinFl.className = "box-letter simple-pulse scale-3";
                        pulseHTMLBaldwinFl.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>`;

                        const markerPulseHTMLBaldwinFl = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: {
                                "lat": 30.28454386302428,
                                "lng": -81.9844228036068
                            },
                            content: pulseHTMLBaldwinFl,
                        });
                        innerMarkers.push(markerPulseHTMLBaldwinFl);



                        addMultipleNamedMarkers([
                            {
                                position: { "lat": 30.278516375333957, "lng": -81.98527962331767 },
                                innerHTML: `<img src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/parking.png'}"/>`,
                                className: "interactable parking-icon non-interactive-icon",
                                sentFunction: () => {
                                    // let infoWindow = new google.maps.InfoWindow({
                                    //     content: '<table class="im-data-table freight-parking-case-study"> <thead> <tr> <th>Name</th> <th>Yearly Total Stops</th> </tr> </thead> <tbody> <tr> <td>Lee<br></td> <td>924,473</td> </tr> <tr> <td>Orange</td> <td>522,665</td> </tr> <tr> <td>Sumter</td> <td>322,113</td> </tr> <tr> <td>Seminole</td> <td>93,588</td> </tr> <tr> <td>St Lucie</td> <td>339,394</td> </tr> <tr> <td>Fort Drum</td> <td>107,756</td> </tr> <tr> <td>Canoe Creek</td> <td>294,404</td> </tr> <tr> <td>Snapper Creek</td> <td>162,822</td> </tr> <tr> <td>Baker County</td> <td>191,774</td> </tr> <tr> <td>Pascoe County</td> <td>115,863</td> </tr> <tbody> </table>',
                                    //     position: { lat: 26.549567895894896, lng: -81.79224798574057 }
                                    // });
                                    // infoWindows.push(infoWindow)
                                    // infoWindow.open(map);
                                    animateCaseSegueOverlay(() => {
                                        case__segue_actions("6.1");
                                    });
                                }
                            }, {
                                position: { "lat": 30.279259393791314, "lng": -81.9849320618196 },
                                innerHTML: `<img src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/parking.png'}"/>`,
                                className: "interactable parking-icon non-interactive-icon",
                            },
                            {
                                position: { "lat": 30.280031233377215, "lng": -81.98464662199015 },
                                innerHTML: `<img src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/parking.png'}"/>`,
                                className: "interactable parking-icon non-interactive-icon",
                            },
                            {
                                position:
                                {
                                    "lat": 30.280993238565603,
                                    "lng": -81.98427727774137
                                },
                                innerHTML: `<img src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/parking.png'}"/>`,
                                className: "interactable parking-icon non-interactive-icon",
                            },
                            {
                                position:
                                {
                                    "lat": 30.281760400392965,
                                    "lng": -81.98397820095781
                                },
                                innerHTML: `<img src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/parking.png'}"/>`,
                                className: "interactable parking-icon non-interactive-icon",
                            },
                            {
                                position:
                                {
                                    "lat": 30.282626669583426,
                                    "lng": -81.98364560703996
                                },
                                innerHTML: `<img src="${siteURL + 'wp-content/plugins/geotab-interactive-map-altitude/assets/img/parking.png'}"/>`,
                                className: "interactable parking-icon non-interactive-icon",
                            },
                        ]);

                        break;
                    case "7":
                        goToACaseFromAMarker("7");

                        const LetterQueenstonLewistonBridge = document.createElement("div");
                        LetterQueenstonLewistonBridge.className = "box-letter";
                        LetterQueenstonLewistonBridge.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>Queenston-Lewiston Bridge`;
                        const markerQueenstonLewistonBridge = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 43.15297390763491, lng: -79.04445973756523 },
                            content: LetterQueenstonLewistonBridge,
                        });
                        markerQueenstonLewistonBridge.addListener("click", ({ domEvent, latLng }) => {
                            animateCaseSegueOverlay(() => {
                                goToAnInnerCaseFromAMarker("7.1");
                                case__segue_actions("7.1");
                            });
                        });
                        innerMarkers.push(markerQueenstonLewistonBridge);

                        const LetterNiagara = document.createElement("div");
                        LetterNiagara.className = "box-letter";
                        LetterNiagara.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>Niagara`;
                        const markerNiagara = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 43.20462441814384, lng: -78.89307016629596 },
                            content: LetterNiagara,
                        });
                        markerNiagara.addListener("click", ({ domEvent, latLng }) => {
                            animateCaseSegueOverlay(() => {
                                goToAnInnerCaseFromAMarker("7.2");
                                case__segue_actions("7.2");
                            });
                        });
                        innerMarkers.push(markerNiagara);
                        break;
                    case "7.1":
                        goToAnInnerCaseFromAMarker("7.1");
                        var lewistonQueenstonBridgeConfig = {
                            strokeColor: "#21325E",
                            strokeOpacity: 1,
                            strokeWeight: 2,
                            fillColor: "#21325E",
                            fillOpacity: 0.8
                        }

                        // Construct the polygon.
                        // Define the LatLng coordinates for the polygon's path.
                        const lewistonQueenstonBridgeCoords = [
                            { "lat": 43.157378804002796, "lng": -79.05134775980174 },
                            { "lat": 43.15712835721497, "lng": -79.03443911417186 },
                            { "lat": 43.14638948571142, "lng": -79.0363917623347 },
                            { "lat": 43.148612555672955, "lng": -79.05471661432445 }
                        ];

                        const lewistonQueenstonBridgeThree = new google.maps.Polygon({
                            paths: lewistonQueenstonBridgeCoords,
                            strokeColor: lewistonQueenstonBridgeConfig.strokeColor,
                            strokeOpacity: lewistonQueenstonBridgeConfig.strokeOpacity,
                            strokeWeight: lewistonQueenstonBridgeConfig.strokeWeight,
                            fillColor: lewistonQueenstonBridgeConfig.fillColor,
                            fillOpacity: lewistonQueenstonBridgeConfig.fillOpacity,
                        });

                        lewistonQueenstonBridgeThree.addListener("click", ({ domEvent, latLng }) => {
                            // show additional sidebar content
                            // animateCaseSegueOverlay(() => {
                            //     case__segue_actions("5.3");
                            // });
                        });
                        mapLines.push(lewistonQueenstonBridgeThree);
                        lewistonQueenstonBridgeThree.setMap(map);
                        break;
                    case "7.2":
                        goToAnInnerCaseFromAMarker("7.2");
                        // var niagaraPolyConfig = {
                        //     strokeColor: "#2d3672",
                        //     strokeOpacity: 0.8,
                        //     strokeWeight: 2,
                        //     fillColor: "#2d3672",
                        //     fillOpacity: 0.9
                        // }

                        // // Construct the polygon.
                        // // Define the LatLng coordinates for the polygon's path.
                        // const niagaraCanadaCoords = [
                        //     { "lat": 43.22559614655314, "lng": -79.2153234054853 },
                        //     { "lat": 43.17253777889534, "lng": -79.19609733126654 },
                        //     { "lat": 43.16151988330103, "lng": -79.17549796603217 },
                        //     { "lat": 43.15350562010041, "lng": -79.14803214571967 },
                        //     { "lat": 43.15350562010041, "lng": -79.0889806320478 },
                        //     { "lat": 43.15751288309113, "lng": -79.0560216476728 },
                        //     { "lat": 43.185556366030944, "lng": -79.05739493868842 },
                        //     { "lat": 43.19679529683309, "lng": -79.0528531059921 },
                        //     { "lat": 43.202426441865725, "lng": -79.053196428746 },
                        //     { "lat": 43.20805706718717, "lng": -79.05920457693936 },
                        //     { "lat": 43.214938236790104, "lng": -79.06074952933194 },
                        //     { "lat": 43.22144335585653, "lng": -79.05714464041593 },
                        //     { "lat": 43.228762051821235, "lng": -79.05862023293885 },
                        //     { "lat": 43.23501556865627, "lng": -79.05982186257752 },
                        //     { "lat": 43.245895158345064, "lng": -79.05810524880799 },
                        //     { "lat": 43.25193826359268, "lng": -79.05836759461586 },
                        //     { "lat": 43.25508294479311, "lng": -79.06115833832942 },
                        //     { "lat": 43.25723954867311, "lng": -79.06420532777034 },
                        //     //this
                        //     { "lat": 43.26219498938769, "lng": -79.07718470227499 },
                        //     { "lat": 43.26237240426598, "lng": -79.08572130471987 },
                        //     { "lat": 43.25629350790843, "lng": -79.11469781155482 },
                        //     { "lat": 43.257543697507174, "lng": -79.12740075344935 },
                        //     { "lat": 43.25729366164086, "lng": -79.13289391751185 },
                        //     { "lat": 43.2297834483921, "lng": -79.19331872219935 },
                        //     { "lat": 43.22815645642636, "lng": -79.19343232018795 },
                        // ];

                        // const niagaraCanadaPoly = new google.maps.Polygon({
                        //     paths: niagaraCanadaCoords,
                        //     strokeColor: niagaraPolyConfig.strokeColor,
                        //     strokeOpacity: niagaraPolyConfig.strokeOpacity,
                        //     strokeWeight: niagaraPolyConfig.strokeWeight,
                        //     fillColor: niagaraPolyConfig.fillColor,
                        //     fillOpacity: niagaraPolyConfig.fillOpacity,
                        // });

                        // mapLines.push(niagaraCanadaPoly);
                        // niagaraCanadaPoly.setMap(map);


                        // Construct the polygon.
                        // Define the LatLng coordinates for the polygon's path.
                        // const niagaraUSACoords = [
                        //     { "lat": 43.26160269136801, "lng": -79.06349945029328 },
                        //     { "lat": 43.264352834786536, "lng": -79.07070922812531 },
                        //     { "lat": 43.450548852613764, "lng": -79.20097483057619 },
                        //     { "lat": 43.63105948754089, "lng": -78.68877351318407 },
                        //     { "lat": 43.63229406290386, "lng": -78.55141855667851 },
                        //     { "lat": 42.90309712122749, "lng": -78.39074520600585 },
                        //     { "lat": 42.90108520030421, "lng": -78.47176937592772 },
                        //     { "lat": 42.891024610873984, "lng": -78.53356747163085 },
                        //     { "lat": 42.89203074367734, "lng": -78.60360531342772 },
                        //     { "lat": 42.886999915528456, "lng": -78.65991024506835 },
                        //     { "lat": 42.84271093511632, "lng": -78.69286922944335 },
                        //     { "lat": 42.85781302078423, "lng": -78.74917416108397 },
                        //     { "lat": 42.891024610873984, "lng": -78.80410580170897 },
                        //     { "lat": 42.87089850808057, "lng": -78.88732723516038 },
                        //     { "lat": 42.90712076610859, "lng": -78.90119747232272 },
                        //     { "lat": 42.9594042499052, "lng": -78.91506770948506 },
                        //     { "lat": 42.991556638614185, "lng": -78.94267085680364 },
                        //     { "lat": 43.008630757353934, "lng": -78.91053584494254 },
                        //     { "lat": 43.03272731783228, "lng": -78.88169673361442 },
                        //     { "lat": 43.0548075235843, "lng": -78.89542964377067 },
                        //     { "lat": 43.07538680146252, "lng": -78.94060525938771 },
                        //     { "lat": 43.08341130233737, "lng": -79.04222879454396 },
                        //     { "lat": 43.10848109381445, "lng": -79.06145486876271 },
                        //     { "lat": 43.134542789178525, "lng": -79.04085550352833 },
                        //     { "lat": 43.1673547021389, "lng": -79.04703531309865 },
                        //     { "lat": 43.18630195146959, "lng": -79.04772195860646 },
                        //     { "lat": 43.19906732898748, "lng": -79.04566202208302 },
                        //     { "lat": 43.2088272866177, "lng": -79.05046854063771 },
                        //     { "lat": 43.213581572113924, "lng": -79.05184183165333 },
                        //     { "lat": 43.22234833252623, "lng": -79.04879242176034 },
                        // ];

                        // const niagaraUSAPoly = new google.maps.Polygon({
                        //     paths: niagaraUSACoords,
                        //     strokeColor: niagaraPolyConfig.strokeColor,
                        //     strokeOpacity: niagaraPolyConfig.strokeOpacity,
                        //     strokeWeight: niagaraPolyConfig.strokeWeight,
                        //     fillColor: niagaraPolyConfig.fillColor,
                        //     fillOpacity: niagaraPolyConfig.fillOpacity,
                        // });

                        // mapLines.push(niagaraUSAPoly);
                        // niagaraUSAPoly.setMap(map);

                        const NiagaraRouteALetter = document.createElement("div");

                        NiagaraRouteALetter.className = "box-letter non-interactive";
                        NiagaraRouteALetter.textContent = "A";

                        const NiagaraRouteAMarker = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position:
                            {
                                "lat": 42.98078229758728,
                                "lng": -78.78714336147561
                            },
                            content: NiagaraRouteALetter,
                        });
                        NiagaraRouteAMarker.addListener("click", ({ domEvent, latLng }) => {
                            // animateCaseSegueOverlay(() => {
                            // goToAnInnerCaseFromAMarker("1.1");
                            // });
                        });
                        innerMarkers.push(NiagaraRouteAMarker);

                        var niagaraLineRouteAConfig = {
                            strokeColor: "#21325E",
                            strokeWeight: 4,
                            strokeOpacity: 0.8
                        }

                        const niagaraLineRouteA = new google.maps.Polyline({
                            path: [
                                { "lat": 43.15302625178321, "lng": -79.04446244562708 },
                                { "lat": 43.15231027369211, "lng": -79.03811952572524 },
                                { "lat": 43.1517684783749, "lng": -79.03621740159576 },
                                { "lat": 43.151628608769734, "lng": -79.0352373360382 },
                                { "lat": 43.151542509701144, "lng": -79.03236200797424 },
                                { "lat": 43.15136248398397, "lng": -79.03155734526977 },
                                { "lat": 43.150830230936116, "lng": -79.02986218917236 },
                                { "lat": 43.1499323773421, "lng": -79.0279023823482 },
                                { "lat": 43.14863833575102, "lng": -79.02555838337342 },
                                { "lat": 43.14736872297172, "lng": -79.02396568688343 },
                                { "lat": 43.14593250137674, "lng": -79.02279145950384 },
                                { "lat": 43.144836583874174, "lng": -79.02240522140569 },
                                { "lat": 43.143959835726235, "lng": -79.02230866188115 },
                                { "lat": 43.140448828485084, "lng": -79.0223061474408 },
                                { "lat": 43.138692943339116, "lng": -79.02201064314944 },
                                { "lat": 43.13685313849765, "lng": -79.0213186332236 },
                                { "lat": 43.133789336714386, "lng": -79.02000752558065 },
                                { "lat": 43.13048706385249, "lng": -79.01869130425992 },
                                { "lat": 43.13012688787159, "lng": -79.01854110055508 },
                                { "lat": 43.126503467878116, "lng": -79.01691356211681 },
                                { "lat": 43.125208205234834, "lng": -79.01598077651691 },
                                { "lat": 43.124064055341684, "lng": -79.01469585518994 },
                                { "lat": 43.12295731447287, "lng": -79.01280554408216 },
                                { "lat": 43.122001075754206, "lng": -79.01000651434595 },
                                { "lat": 43.12108319210627, "lng": -79.00673305424465 },
                                { "lat": 43.12024024981598, "lng": -79.00463797738323 },
                                { "lat": 43.119310135268265, "lng": -79.00284649586459 },
                                { "lat": 43.118198077683665, "lng": -79.00130690789004 },
                                { "lat": 43.11657526280619, "lng": -78.99973982436244 },
                                { "lat": 43.11103455503723, "lng": -78.99601678779227 },
                                { "lat": 43.109985007199235, "lng": -78.99506192138298 },
                                { "lat": 43.10877435668508, "lng": -78.99352901551575 },
                                { "lat": 43.10762294356663, "lng": -78.9910721120581 },
                                { "lat": 43.10588848533246, "lng": -78.98620228731747 },
                                { "lat": 43.10526967220933, "lng": -78.98474316561338 },
                                { "lat": 43.1042043590145, "lng": -78.98332695925352 },
                                { "lat": 43.10353688333133, "lng": -78.9827385682836 },
                                { "lat": 43.102510707345665, "lng": -78.98219139764456 },
                                { "lat": 43.101112128048605, "lng": -78.98187905465076 },
                                { "lat": 43.099850897558134, "lng": -78.98209899578998 },
                                { "lat": 43.09876057158231, "lng": -78.98260024236318 },
                                { "lat": 43.09757891583559, "lng": -78.9835305299238 },
                                { "lat": 43.09212467478472, "lng": -78.98872393202744 },
                                { "lat": 43.09092922381345, "lng": -78.98971963750309 },
                                { "lat": 43.08917952991639, "lng": -78.99056367616612 },
                                { "lat": 43.08792682749419, "lng": -78.99078696539942 },
                                { "lat": 43.08739402233604, "lng": -78.9908191519076 },
                                { "lat": 43.063766789615144, "lng": -78.99074758343102 },
                                { "lat": 43.06299861908695, "lng": -78.99074758343102 },
                                { "lat": 43.060952891324824, "lng": -78.99054589033886 },
                                { "lat": 43.05987035042702, "lng": -78.99046287512665 },
                                { "lat": 43.053496908872795, "lng": -78.99049892004656 },
                                { "lat": 43.04845784639359, "lng": -78.99048730918874 },
                                { "lat": 43.046733503225255, "lng": -78.99032052214564 },
                                { "lat": 43.04470889869169, "lng": -78.98969905798245 },
                                { "lat": 43.043294891708086, "lng": -78.98894615902977 },
                                { "lat": 43.01629002165961, "lng": -78.97092313624648 },
                                { "lat": 43.015341484964026, "lng": -78.97019483948087 },
                                { "lat": 43.014208415776956, "lng": -78.96899766313547 },
                                {
                                    "lat": 43.013255824199014,
                                    "lng": -78.96764881755735
                                },
                                {
                                    "lat": 43.01226800619263,
                                    "lng": -78.96563267840065
                                },
                                {
                                    "lat": 43.011428584698486,
                                    "lng": -78.9636049283854
                                },
                                { "lat": 43.00741109246775, "lng": -78.95387763273665 },
                                {
                                    "lat": 43.00551680239796,
                                    "lng": -78.94936099297576
                                },
                                {
                                    "lat": 43.00368326143646,
                                    "lng": -78.94583192614155
                                },
                                {
                                    "lat": 43.00194069407487,
                                    "lng": -78.94279814280738
                                },
                                { "lat": 43.00051419706569, "lng": -78.94026670237885 },
                                {
                                    "lat": 42.99293323868553,
                                    "lng": -78.92675271186559
                                },
                                {
                                    "lat": 42.992086385549996,
                                    "lng": -78.92456994819422
                                },
                                {
                                    "lat": 42.99134659861541,
                                    "lng": -78.92291161821778
                                },
                                {
                                    "lat": 42.99020846903386,
                                    "lng": -78.92048618687443
                                },
                                {
                                    "lat": 42.98893562206099,
                                    "lng": -78.91776857877565
                                },
                                { "lat": 42.98857914128831, "lng": -78.91662582546606 },
                                {
                                    "lat": 42.988275089040464,
                                    "lng": -78.91538609614915
                                },
                                {
                                    "lat": 42.9882112442313,
                                    "lng": -78.91428346028394
                                },
                                { "lat": 42.98839627001394, "lng": -78.91273708537264 },
                                { "lat": 42.98946264476884, "lng": -78.91015896819084 },
                                {
                                    "lat": 42.99067500516209,
                                    "lng": -78.90752471722054
                                },
                                { "lat": 42.99149658428625, "lng": -78.90496164297953 },
                                { "lat": 42.992324185951944, "lng": -78.90147689988754 },
                                { "lat": 42.9932394650042, "lng": -78.89652137975189 },
                                { "lat": 42.99543436448656, "lng": -78.87545812608059 },
                                {
                                    "lat": 42.99576198146516,
                                    "lng": -78.86317271255112
                                },
                                {
                                    "lat": 42.99661382414565,
                                    "lng": -78.85963502514537
                                },
                                {
                                    "lat": 42.99918758833897,
                                    "lng": -78.85435643780406
                                },
                                {
                                    "lat": 43.000718444698855,
                                    "lng": -78.85047464820673
                                },
                                {
                                    "lat": 43.00103230318582,
                                    "lng": -78.84622602912714
                                },
                                {
                                    "lat": 43.00109216588708,
                                    "lng": -78.83810505026328
                                },
                                {
                                    "lat": 43.00133126241603,
                                    "lng": -78.8354837493669
                                },
                                {
                                    "lat": 43.003151601165605,
                                    "lng": -78.82911082074752
                                },
                                {
                                    "lat": 43.00395027430922,
                                    "lng": -78.82617486168859
                                },
                                {
                                    "lat": 43.004178017142685,
                                    "lng": -78.82321521431967
                                },
                                {
                                    "lat": 43.003826884157114,
                                    "lng": -78.81932591245265
                                },
                                {
                                    "lat": 43.00299519349307,
                                    "lng": -78.81649349973293
                                },
                                {
                                    "lat": 43.00180130305332,
                                    "lng": -78.81396894307002
                                },
                                {
                                    "lat": 42.999415968197134,
                                    "lng": -78.81064300389156
                                },
                                {
                                    "lat": 42.99252922055414,
                                    "lng": -78.80156580620995
                                },
                                {
                                    "lat": 42.99071237214598,
                                    "lng": -78.79965144717956
                                },
                                {
                                    "lat": 42.98639595261358,
                                    "lng": -78.7960036429193
                                },
                                {
                                    "lat": 42.984475178719805,
                                    "lng": -78.79376027715985
                                },
                                {
                                    "lat": 42.98307482871375,
                                    "lng": -78.79150855099707
                                },
                                {
                                    "lat": 42.98078229758728,
                                    "lng": -78.78714336147561
                                },
                                {
                                    "lat": 42.97851929069552,
                                    "lng": -78.78320915512032
                                },
                                {
                                    "lat": 42.96973528017956,
                                    "lng": -78.77169444397754
                                },
                                {
                                    "lat": 42.968518260630724,
                                    "lng": -78.77020549401219
                                },
                                {
                                    "lat": 42.96678269849156,
                                    "lng": -78.76868952549816
                                },
                                {
                                    "lat": 42.9658144207674,
                                    "lng": -78.76797873859472
                                },
                                {
                                    "lat": 42.96451115120558,
                                    "lng": -78.76744229679174
                                },
                                {
                                    "lat": 42.96348372701618,
                                    "lng": -78.76718745482485
                                },
                                {
                                    "lat": 42.959086877893064,
                                    "lng": -78.76654372466128
                                },
                                {
                                    "lat": 42.955874454523986,
                                    "lng": -78.76629836372287
                                },
                                {
                                    "lat": 42.95399826028605,
                                    "lng": -78.76611636199152
                                },
                                //90
                                {
                                    "lat": 42.95252198270127,
                                    "lng": -78.76467869795954
                                },
                                {
                                    "lat": 42.95162677585455,
                                    "lng": -78.76241491355097
                                },
                                {
                                    "lat": 42.9514697206792,
                                    "lng": -78.76071975745356
                                },
                                {
                                    "lat": 42.951768125169735,
                                    "lng": -78.7581341079632
                                },
                                {
                                    "lat": 42.9519959939644,
                                    "lng": -78.7556149359109
                                },
                                {
                                    "lat": 42.95202740476296,
                                    "lng": -78.75454205230494
                                },
                                {
                                    "lat": 42.95196834843528,
                                    "lng": -78.74417686822002
                                },
                                {
                                    "lat": 42.95173969413866,
                                    "lng": -78.74132863262916
                                },
                                {
                                    "lat": 42.95110544609889,
                                    "lng": -78.73715689808138
                                },
                                {
                                    "lat": 42.95077562697405,
                                    "lng": -78.73320868641146
                                },
                                {
                                    "lat": 42.95069806455992,
                                    "lng": -78.73082030608626
                                },
                                {
                                    "lat": 42.95075021984759,
                                    "lng": -78.70668370226258
                                },
                                {
                                    "lat": 42.950465002805565,
                                    "lng": -78.70316189692333
                                },
                                {
                                    "lat": 42.94754279145496,
                                    "lng": -78.67479673539286
                                },
                                {
                                    "lat": 42.94733860610129,
                                    "lng": -78.67159954224711
                                },
                                {
                                    "lat": 42.94769158573014,
                                    "lng": -78.64242149362883
                                },
                                {
                                    "lat": 42.948821886326265,
                                    "lng": -78.62702482186343
                                },
                                {
                                    "lat": 42.95021201514855,
                                    "lng": -78.60987528228993
                                },
                                {
                                    "lat": 42.95099730306452,
                                    "lng": -78.60601290130849
                                },
                                {
                                    "lat": 42.962585447237096,
                                    "lng": -78.56260927968523
                                },
                                {
                                    "lat": 42.96450121697519,
                                    "lng": -78.55190233220291
                                },
                                {
                                    "lat": 42.967144492264445,
                                    "lng": -78.53433578959273
                                },
                                {
                                    "lat": 42.97008315257658,
                                    "lng": -78.52377635312772
                                },
                                {
                                    "lat": 42.97367963578078,
                                    "lng": -78.51528791486342
                                },
                                {
                                    "lat": 42.97880983783543,
                                    "lng": -78.50272814068941
                                },
                                {
                                    "lat": 42.98039684107144,
                                    "lng": -78.49396618076632
                                },
                                {
                                    "lat": 42.98152899200957,
                                    "lng": -78.48190880545094
                                },
                                {
                                    "lat": 42.984624690249,
                                    "lng": -78.46954563456674
                                },
                                {
                                    "lat": 42.991974498949155,
                                    "lng": -78.43553278597437
                                }
                            ],
                            strokeColor: niagaraLineRouteAConfig.strokeColor,
                            strokeOpacity: niagaraLineRouteAConfig.strokeOpacity,
                            strokeWeight: niagaraLineRouteAConfig.strokeWeight,
                            map: map,
                        });
                        mapLines.push(niagaraLineRouteA);



                        const NiagaraRouteBLetter = document.createElement("div");

                        NiagaraRouteBLetter.className = "box-letter non-interactive";
                        NiagaraRouteBLetter.textContent = "B";

                        const NiagaraRouteBMarker = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position:
                            {
                                "lat": 43.177440653871066,
                                "lng": -78.62401514994166
                            },
                            content: NiagaraRouteBLetter,
                        });
                        NiagaraRouteBMarker.addListener("click", ({ domEvent, latLng }) => {
                            // animateCaseSegueOverlay(() => {
                            // goToAnInnerCaseFromAMarker("1.1");
                            // });
                        });
                        innerMarkers.push(NiagaraRouteBMarker);

                        var niagaraLineRouteBConfig = {
                            strokeColor: "#21325E",
                            strokeWeight: 3,
                            strokeOpacity: 1
                        }

                        const niagaraLineRouteB = new google.maps.Polyline({
                            path: [
                                { "lat": 43.15302625178321, "lng": -79.04446244562708 },
                                { "lat": 43.15231027369211, "lng": -79.03811952572524 },
                                { "lat": 43.1517684783749, "lng": -79.03621740159576 },
                                { "lat": 43.151628608769734, "lng": -79.0352373360382 },
                                { "lat": 43.151542509701144, "lng": -79.03236200797424 },
                                { "lat": 43.15136248398397, "lng": -79.03155734526977 },
                                { "lat": 43.150830230936116, "lng": -79.02986218917236 },
                                { "lat": 43.1499323773421, "lng": -79.0279023823482 },
                                { "lat": 43.14863833575102, "lng": -79.02555838337342 },
                                { "lat": 43.14736872297172, "lng": -79.02396568688343 },
                                { "lat": 43.14593250137674, "lng": -79.02279145950384 },
                                { "lat": 43.144836583874174, "lng": -79.02240522140569 },
                                { "lat": 43.143959835726235, "lng": -79.02230866188115 },
                                { "lat": 43.140448828485084, "lng": -79.0223061474408 },
                                { "lat": 43.138692943339116, "lng": -79.02201064314944 },
                                { "lat": 43.13685313849765, "lng": -79.0213186332236 },
                                { "lat": 43.133789336714386, "lng": -79.02000752558065 },
                                { "lat": 43.13048706385249, "lng": -79.01869130425992 },
                                { "lat": 43.13012688787159, "lng": -79.01854110055508 },
                                //31
                                {
                                    "lat": 43.1299656792585,
                                    "lng": -79.01383115027868
                                },
                                {
                                    "lat": 43.129975763295256,
                                    "lng": -79.00836409279462
                                },
                                {
                                    "lat": 43.13023415126545,
                                    "lng": -79.00666893669721
                                },
                                {
                                    "lat": 43.13079952914259,
                                    "lng": -79.00545558819144
                                },
                                {
                                    "lat": 43.13359819897104,
                                    "lng": -79.00069092613698
                                },
                                {
                                    "lat": 43.13413060206061,
                                    "lng": -78.99958585602285
                                },
                                {
                                    "lat": 43.13447509570755,
                                    "lng": -78.99856661659719
                                },
                                {
                                    "lat": 43.13472563532282,
                                    "lng": -78.99706457954885
                                },
                                {
                                    "lat": 43.13513533377867,
                                    "lng": -78.99392116006162
                                },
                                {
                                    "lat": 43.13535555253977,
                                    "lng": -78.99119542885109
                                },
                                {
                                    "lat": 43.13557039065557,
                                    "lng": -78.98808751370646
                                },
                                {
                                    "lat": 43.13578029697831,
                                    "lng": -78.98662636008908
                                },
                                {
                                    "lat": 43.136093464652845,
                                    "lng": -78.9854783746307
                                },
                                {
                                    "lat": 43.13698687133271,
                                    "lng": -78.98346562314197
                                },
                                {
                                    "lat": 43.13821247931266,
                                    "lng": -78.98068525570513
                                },
                                {
                                    "lat": 43.13979338879821,
                                    "lng": -78.97604321950399
                                },
                                {
                                    "lat": 43.1401143645775,
                                    "lng": -78.9747128438326
                                },
                                {
                                    "lat": 43.14037028582938,
                                    "lng": -78.9730547227103
                                },
                                {
                                    "lat": 43.14038594307582,
                                    "lng": -78.97138102428501
                                },
                                {
                                    "lat": 43.14021371314439,
                                    "lng": -78.97001846210544
                                },
                                {
                                    "lat": 43.13998668203897,
                                    "lng": -78.96924598590915
                                },
                                {
                                    "lat": 43.13954827476001,
                                    "lng": -78.96796493768986
                                },
                                {
                                    "lat": 43.1390106141136,
                                    "lng": -78.96603818641236
                                },
                                {
                                    "lat": 43.137160236694264,
                                    "lng": -78.95840746982132
                                },
                                {
                                    "lat": 43.136948852377564,
                                    "lng": -78.95709855182206
                                },
                                {
                                    "lat": 43.1369137417897,
                                    "lng": -78.95560782377402
                                },
                                {
                                    "lat": 43.13705600108157,
                                    "lng": -78.95043780798147
                                },
                                {
                                    "lat": 43.1371969237936,
                                    "lng": -78.9492361783428
                                },
                                {
                                    "lat": 43.13748787535603,
                                    "lng": -78.94803626966556
                                },
                                {
                                    "lat": 43.142788001711565,
                                    "lng": -78.93093309051392
                                },
                                {
                                    "lat": 43.14296805268336,
                                    "lng": -78.93019280082581
                                },
                                {
                                    "lat": 43.1430898412266,
                                    "lng": -78.92929273190077
                                },
                                {
                                    "lat": 43.14312423800617,
                                    "lng": -78.92843101055098
                                },
                                {
                                    "lat": 43.14337061318889,
                                    "lng": -78.91444114965363
                                },
                                {
                                    "lat": 43.1433549567068,
                                    "lng": -78.91161946576996
                                },
                                {
                                    "lat": 43.14369167012336,
                                    "lng": -78.83818402389711
                                },
                                {
                                    "lat": 43.1437855098582,
                                    "lng": -78.83405359765464
                                },
                                {
                                    "lat": 43.1438481353215,
                                    "lng": -78.83325966378624
                                },
                                {
                                    "lat": 43.14439541634124,
                                    "lng": -78.82589290921086
                                },
                                {
                                    "lat": 43.14441107255688,
                                    "lng": -78.82443378750676
                                },
                                {
                                    "lat": 43.1446376913869,
                                    "lng": -78.77750904248268
                                },
                                {
                                    "lat": 43.1446455194642,
                                    "lng": -78.77695114300758
                                },
                                {
                                    "lat": 43.14482556496537,
                                    "lng": -78.77575487778694
                                },
                                {
                                    "lat": 43.15026694226719,
                                    "lng": -78.75429437983911
                                },
                                {
                                    "lat": 43.15140393838438,
                                    "lng": -78.75138318475916
                                },
                                {
                                    "lat": 43.15760781683035,
                                    "lng": -78.73383553511562
                                },
                                {
                                    "lat": 43.159548737357184,
                                    "lng": -78.73001606947841
                                },
                                {
                                    "lat": 43.16283563956329,
                                    "lng": -78.72516663557948
                                },
                                {
                                    "lat": 43.16490598398351,
                                    "lng": -78.72244056870039
                                },
                                {
                                    "lat": 43.165547670130316,
                                    "lng": -78.721110193029
                                }, {
                                    "lat": 43.165704683836,
                                    "lng": -78.71936897313026
                                },
                                {
                                    "lat": 43.16605482116134,
                                    "lng": -78.71635107633269
                                },
                                {
                                    "lat": 43.16759961713336,
                                    "lng": -78.7035378923055
                                },
                                {
                                    "lat": 43.16766221819608,
                                    "lng": -78.70203585525717
                                },
                                {
                                    "lat": 43.16769351870338,
                                    "lng": -78.70160670181478
                                },
                                {
                                    "lat": 43.16768560839774,
                                    "lng": -78.7017491489577
                                },
                                {
                                    "lat": 43.175068388961506,
                                    "lng": -78.67445776368282
                                },
                                {
                                    "lat": 43.17620773283633,
                                    "lng": -78.67148309216914
                                },
                                {
                                    "lat": 43.18103170656212,
                                    "lng": -78.65926524937497
                                },
                                {
                                    "lat": 43.18137593589117,
                                    "lng": -78.65808507740842
                                },
                                {
                                    "lat": 43.18169156567863,
                                    "lng": -78.65632832489685
                                },
                                {
                                    "lat": 43.18185103444668,
                                    "lng": -78.6540801393363
                                },
                                {
                                    "lat": 43.18171551647691,
                                    "lng": -78.64983684967842
                                },
                                {
                                    "lat": 43.181349548450555,
                                    "lng": -78.6471709037428
                                },
                                {
                                    "lat": 43.18074682656953,
                                    "lng": -78.64265005883588
                                },
                                {
                                    "lat": 43.17980649562984,
                                    "lng": -78.6350784494879
                                },
                                {
                                    "lat": 43.17954964315254,
                                    "lng": -78.63379343361656
                                },
                                {
                                    "lat": 43.17486196745768,
                                    "lng": -78.61193901609116
                                },
                                {
                                    "lat": 43.17462724081357,
                                    "lng": -78.61050135205917
                                },
                                {
                                    "lat": 43.17476041686684,
                                    "lng": -78.60498297946205
                                },
                                {
                                    "lat": 43.17437518319334,
                                    "lng": -78.60120450353307
                                },
                                {
                                    "lat": 43.17389007660091,
                                    "lng": -78.59961663579625
                                },
                                {
                                    "lat": 43.17249535678616,
                                    "lng": -78.59699369665015
                                },
                                {
                                    "lat": 43.16892932579282,
                                    "lng": -78.59143959205787
                                },
                                {
                                    "lat": 43.16845982599811,
                                    "lng": -78.5902379624192
                                },
                                {
                                    "lat": 43.16641835792478,
                                    "lng": -78.581025234258
                                },
                                {
                                    "lat": 43.165727133703406,
                                    "lng": -78.57560624709774
                                },
                                {
                                    "lat": 43.16562241123114,
                                    "lng": -78.57349456812236
                                },
                                {
                                    "lat": 43.16530939482359,
                                    "lng": -78.56569470430705
                                },
                                {
                                    "lat": 43.165008432669495,
                                    "lng": -78.55975168435526
                                },
                                {
                                    "lat": 43.164632809012716,
                                    "lng": -78.55270803052507
                                },
                                {
                                    "lat": 43.163793381480616,
                                    "lng": -78.54115234351677
                                },
                                {
                                    "lat": 43.163088606404415,
                                    "lng": -78.53648522902519
                                },
                                {
                                    "lat": 43.16171126508833,
                                    "lng": -78.53221515227348
                                },
                                {
                                    "lat": 43.159918367475555,
                                    "lng": -78.52842249768584
                                },
                                {
                                    "lat": 43.15778842404803,
                                    "lng": -78.52579146225605
                                },
                                {
                                    "lat": 43.15668025308716,
                                    "lng": -78.52448357273057
                                },
                                {
                                    "lat": 43.155850634687006,
                                    "lng": -78.5228313319774
                                },
                                {
                                    "lat": 43.1553519061007,
                                    "lng": -78.52045838996042
                                },
                                {
                                    "lat": 43.155156238145274,
                                    "lng": -78.52007215186228
                                },
                                {
                                    "lat": 43.15502318357775,
                                    "lng": -78.52007215186228
                                },
                                {
                                    "lat": 43.15408536769714,
                                    "lng": -78.51972324167339
                                },
                                {
                                    "lat": 43.15184684248114,
                                    "lng": -78.51890785013286
                                },
                                {
                                    "lat": 43.14838039365155,
                                    "lng": -78.51905529919452
                                },
                                {
                                    "lat": 43.14704968741817,
                                    "lng": -78.51851885739154
                                },
                                {
                                    "lat": 43.14615731524649,
                                    "lng": -78.51776783886737
                                },
                                {
                                    "lat": 43.14477902383055,
                                    "lng": -78.51540706997551
                                },
                                {
                                    "lat": 43.138166960732484,
                                    "lng": -78.50408376994964
                                },
                                {
                                    "lat": 43.13722748475484,
                                    "lng": -78.50291432681915
                                },
                                {
                                    "lat": 43.13510587021236,
                                    "lng": -78.50078138108087
                                },
                                {
                                    "lat": 43.13424464133964,
                                    "lng": -78.49964412445856
                                },
                                {
                                    "lat": 43.13358696748768,
                                    "lng": -78.49814208741022
                                },
                                {
                                    "lat": 43.13310153701258,
                                    "lng": -78.49593194718194
                                },
                                {
                                    "lat": 43.13300850624095,
                                    "lng": -78.49115283664536
                                },
                                {
                                    "lat": 43.132710981979734,
                                    "lng": -78.48965079959702
                                },
                                {
                                    "lat": 43.13170878434544,
                                    "lng": -78.48656290400427
                                },
                                {
                                    "lat": 43.1311137217297,
                                    "lng": -78.4853612743656
                                },
                                {
                                    "lat": 43.1303189465363,
                                    "lng": -78.48426825898889
                                },
                                {
                                    "lat": 43.12770370032032,
                                    "lng": -78.48122126954797
                                },
                                {
                                    "lat": 43.12707960844705,
                                    "lng": -78.4798333648479
                                },
                                {
                                    "lat": 43.126500161595146,
                                    "lng": -78.47779488599659
                                },
                                {
                                    "lat": 43.12574843858101,
                                    "lng": -78.47464060819507
                                },
                                {
                                    "lat": 43.12559705832428,
                                    "lng": -78.47347468915017
                                },
                                {
                                    "lat": 43.125573951061284,
                                    "lng": -78.47225518905778
                                },
                                {
                                    "lat": 43.126242270654885,
                                    "lng": -78.46063770097594
                                },
                                {
                                    "lat": 43.12607000088715,
                                    "lng": -78.4585777644525
                                },
                                {
                                    "lat": 43.12558451074972,
                                    "lng": -78.45674313348631
                                },
                                {
                                    "lat": 43.12436284471854,
                                    "lng": -78.45463667216094
                                },
                                {
                                    "lat": 43.12106668314415,
                                    "lng": -78.44991735709057
                                },
                                {
                                    "lat": 43.11942376043612,
                                    "lng": -78.44676402961144
                                },
                                {
                                    "lat": 43.118082055511145,
                                    "lng": -78.44338209292613
                                },
                                {
                                    "lat": 43.11703195730302,
                                    "lng": -78.44102609169484
                                },
                                {
                                    "lat": 43.11688315649683,
                                    "lng": -78.4403179885149
                                },
                                {
                                    "lat": 43.1168057857525,
                                    "lng": -78.43844969291379
                                },
                                {
                                    "lat": 43.116881766334416,
                                    "lng": -78.43502391408427
                                },
                                {
                                    "lat": 43.116803449973496,
                                    "lng": -78.43433726857646
                                },
                                {
                                    "lat": 43.11650651103849,
                                    "lng": -78.43303674687743
                                },
                                {
                                    "lat": 43.11593671992985,
                                    "lng": -78.43132525103668
                                },
                                {
                                    "lat": 43.1156234490468,
                                    "lng": -78.4308049024878
                                },
                                {
                                    "lat": 43.09677318882213,
                                    "lng": -78.4040768961546
                                },
                                {
                                    "lat": 43.096541032497484,
                                    "lng": -78.40334743745171
                                },
                                {
                                    "lat": 43.09648619283557,
                                    "lng": -78.40242475755059
                                },
                                {
                                    "lat": 43.096501073987355,
                                    "lng": -78.39426297366145
                                },
                                {
                                    "lat": 43.09641101268367,
                                    "lng": -78.3909746934254
                                }

                            ],
                            strokeColor: niagaraLineRouteBConfig.strokeColor,
                            strokeOpacity: niagaraLineRouteBConfig.strokeOpacity,
                            strokeWeight: niagaraLineRouteBConfig.strokeWeight,
                            map: map,
                        });
                        mapLines.push(niagaraLineRouteB);
                        break;
                    case "8":
                        goToACaseFromAMarker("8");
                        let bothCorridorHeatmapData = bothCorridorData.map((data, idx) => {
                            // if (idx % 100 === 0)
                            return { location: new google.maps.LatLng(data.position.lat, data.position.lng), weight: data.weight * 1.5 }
                        },
                        );
                        setTimeout(() => {
                            var heatmap = new google.maps.visualization.HeatmapLayer({
                                data: bothCorridorHeatmapData
                            });
                            var gradient = [
                                'rgba(0, 0, 0, 1)',
                                'rgba(115, 0, 0, 1)',
                                'rgba(125, 0, 0, 1)',
                                'rgba(135, 0, 0, 1)',
                                'rgba(145, 0, 0, 1)',
                                'rgba(155, 0, 0, 1)',
                                'rgba(175, 0, 0, 1)',
                                'rgba(195, 0, 0, 1)',
                                'rgba(205, 0, 0, 1)',
                                'rgba(215, 0, 0, 1)',
                                'rgba(225, 0, 0, 1)',
                                'rgba(235, 0, 0, 1)',
                                'rgba(245, 0, 0, 1)',
                                'rgba(255, 0, 0, 1)'
                            ]
                            heatmap.set('gradient', gradient);
                            heatmap.set('radius', 10);
                            // heatmap.set('maxIntensity', 0);
                            // heatmap.set('dissipating', false);
                            heatmap.setMap(map);
                            heatMaps.push(heatmap);
                        }, 500);

                        const LetterDallasInner = document.createElement("div");
                        LetterDallasInner.className = "box-letter";
                        // LetterDallasInner.textContent = "Dallas";
                        LetterDallasInner.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>Dallas`;
                        const markerDallasInner = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 32.78940977777302, lng: -90.14285235341303 },
                            content: LetterDallasInner,
                        });
                        markerDallasInner.addListener("click", ({ domEvent, latLng }) => {
                            // show additional sidebar content
                            case__segue_actions("8.1");
                            // goToAnInnerCaseFromAMarker("8.1")
                        });
                        innerMarkers.push(markerDallasInner);

                        const LetterSavannahInner = document.createElement("div");
                        LetterSavannahInner.className = "box-letter arrow-up";
                        // LetterSavannahInner.textContent = "Savannah";
                        LetterSavannahInner.innerHTML = `<div class="dot"> <div class="centraldot"></div> <div class="wave"></div> <div class="wave2"></div> </div>Savannah`;
                        const markerSavannahInner = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: { lat: 31.26194114443286, lng: -83.11160235341303 },
                            content: LetterSavannahInner,
                        });
                        markerSavannahInner.addListener("click", ({ domEvent, latLng }) => {
                            // show additional sidebar content
                            case__segue_actions("8.2");
                            // goToAnInnerCaseFromAMarker("8.1")
                        });
                        innerMarkers.push(markerSavannahInner);
                        break;
                    case "8.1":
                        animateCaseSegueOverlay(() => {
                            goToAnInnerCaseFromAMarker("8.1");
                        });
                        let firstCorridorHeatmapData = firstCorridorData.map((data) => ({ location: new google.maps.LatLng(data.position.lat, data.position.lng), weight: data.weight * 1.5 }),
                        );
                        setTimeout(() => {
                            var heatmap = new google.maps.visualization.HeatmapLayer({
                                data: firstCorridorHeatmapData
                            });
                            var gradient = [
                                'rgba(0, 0, 0, 1)',
                                'rgba(115, 0, 0, 1)',
                                'rgba(125, 0, 0, 1)',
                                'rgba(135, 0, 0, 1)',
                                'rgba(145, 0, 0, 1)',
                                'rgba(155, 0, 0, 1)',
                                'rgba(175, 0, 0, 1)',
                                'rgba(195, 0, 0, 1)',
                                'rgba(205, 0, 0, 1)',
                                'rgba(215, 0, 0, 1)',
                                'rgba(225, 0, 0, 1)',
                                'rgba(235, 0, 0, 1)',
                                'rgba(245, 0, 0, 1)',
                                'rgba(255, 0, 0, 1)'
                            ]
                            heatmap.set('gradient', gradient);
                            heatmap.set('radius', 10);
                            heatmap.set('maxIntensity', 0);
                            heatmap.setMap(map);
                            heatMaps.push(heatmap);
                        }, 500);
                        break;
                    case "8.2":
                        animateCaseSegueOverlay(() => {
                            goToAnInnerCaseFromAMarker("8.2");
                        });
                        let secondCorridorHeatmapData = secondCorridorData.map((data) => ({ location: new google.maps.LatLng(data.position.lat, data.position.lng), weight: data.weight * 1.5 }),
                        );
                        setTimeout(() => {
                            var heatmap = new google.maps.visualization.HeatmapLayer({
                                data: secondCorridorHeatmapData
                            });
                            // heatmap.setMap(map);
                            // heatMaps.push(heatmap);

                            // var gradient = [
                            //     'rgba(0, 0, 0, 1)',
                            //     'rgba(219, 0, 0, 1)'];
                            // var gradient = [
                            //     'rgba(0, 255, 255, 0)',
                            //     'rgba(0, 255, 255, 1)',
                            //     'rgba(0, 191, 255, 1)',
                            //     'rgba(0, 127, 255, 1)',
                            //     'rgba(0, 63, 255, 1)',
                            //     'rgba(0, 0, 255, 1)',
                            //     'rgba(0, 0, 223, 1)',
                            //     'rgba(0, 0, 191, 1)',
                            //     'rgba(0, 0, 159, 1)',
                            //     'rgba(0, 0, 127, 1)',
                            //     'rgba(63, 0, 91, 1)',
                            //     'rgba(127, 0, 63, 1)',
                            //     'rgba(191, 0, 31, 1)',
                            //     'rgba(255, 0, 0, 1)'
                            // ]
                            var gradient = [
                                'rgba(0, 0, 0, 1)',
                                'rgba(115, 0, 0, 1)',
                                'rgba(125, 0, 0, 1)',
                                'rgba(135, 0, 0, 1)',
                                'rgba(145, 0, 0, 1)',
                                'rgba(155, 0, 0, 1)',
                                'rgba(175, 0, 0, 1)',
                                'rgba(195, 0, 0, 1)',
                                'rgba(205, 0, 0, 1)',
                                'rgba(215, 0, 0, 1)',
                                'rgba(225, 0, 0, 1)',
                                'rgba(235, 0, 0, 1)',
                                'rgba(245, 0, 0, 1)',
                                'rgba(255, 0, 0, 1)'
                            ]
                            heatmap.set('gradient', gradient);
                            heatmap.set('radius', 20);
                            heatmap.set('maxIntensity', 0);
                            // heatmap.set('dissipating', )
                            // heatmap.set('opacity', 1);
                            // heatmaps.set('maxIntensity', 0.025);
                            heatmap.setMap(map);
                            heatMaps.push(heatmap);
                        }, 500);
                        break;
                }
            }
            // map._on({
            //     obj: map.gMap,
            //     event: "zoom_changed",
            //     callback: function () {
            //         var zoomLevel = map.zoom();
            //         switch (zoomLevel) {
            //             case 7:
            //                 map.heatmap.setData(gridData[zoomLevel]);
            //                 map.heatmap.set('radius', 0.04);
            //                 break;
            //             case 8:
            //                 map.heatmap.setData(gridData[zoomLevel]);
            //                 map.heatmap.set('radius', 0.03);
            //                 break;
            //             case 9:
            //                 map.heatmap.setData(gridData[zoomLevel]);
            //                 map.heatmap.set('radius', 0.02);
            //                 break;
            //             case 10:
            //                 map.heatmap.setData(gridData[zoomLevel]);
            //                 map.heatmap.set('radius', 0.01);
            //                 break;
            //             case 11:
            //                 map.heatmap.setData(gridData[zoomLevel]);
            //                 map.heatmap.set('radius', 0.005);
            //                 break;
            //             case 12:
            //                 map.heatmap.setData(gridData[zoomLevel]);
            //                 map.heatmap.set('radius', 0.0025);
            //                 break;
            //             case 13:
            //                 map.heatmap.setData(gridData[zoomLevel]);
            //                 map.heatmap.set('radius', 0.00225);
            //                 break;
            //             default:
            //                 map.heatmap.setData(gridData[zoomLevel]);
            //                 map.heatmap.set('radius', 0.000625);
            //         }
            //     }
            // });

            function clearHeatmaps() {
                infoWindows.forEach((infoWindow) => {
                    infoWindow.close();
                })
                heatMaps.forEach((heatmap) => {
                    heatmap.setMap(null);
                })
            }

            function addMultipleNamedMarkers(markerData) {
                if (markerData.length)
                    markerData.forEach((marker) => {
                        const multipleNamedMarkerContent = document.createElement("div");
                        multipleNamedMarkerContent.className = "location-advanced-markers" + (marker.className ? " " + marker.className : "");
                        multipleNamedMarkerContent.innerHTML = marker.innerHTML;
                        const multipleAdvancedMarkerView = new google.maps.marker.AdvancedMarkerView({
                            map,
                            position: marker.position,
                            content: multipleNamedMarkerContent,
                        });
                        multipleAdvancedMarkerView.addListener("click", ({ domEvent, latLng }) => {
                            if (marker.sentFunction !== null && marker.sentFunction !== undefined) {
                                if (typeof marker.sentFunction === 'function')
                                    marker.sentFunction();
                                else
                                    console.warn("marker.sentFunction is not a function, but is defined", marker.sentFunction);
                            } else
                                console.warn("marker.sentFunction is not defined");
                        });
                        innerMarkers.push(multipleAdvancedMarkerView);
                    });
                else
                    console.warn("No marker data sent to addMultipleNamedMarkers");
            }

            function goToAnInnerCaseFromAMarker(c) {
                let casesegue = c;
                jQuery('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').removeClass('opened-menu');
                // setTimeout(function () {
                //     jQuery('.interactive__map-loading').removeClass('open');
                // }, 2000);
                let latLng;
                let selectedState = {
                    zoom: 5
                };
                if (casesegue)
                    casesegue = casesegue.toString();
                selectedState = get_selected_state_by_casegue(casesegue);
                // parentNavs.forEach(parentNav => {
                //     parentNav.forEach(parentNavParentCase => {
                //         if (parentNavParentCase.case === casesegue)
                //             selectedState = parentNavParentCase;
                //         else if (parentNavParentCase.hasChildren) return parentNavParentCase.children.forEach(parentNavParentCaseChild => {
                //             if (parentNavParentCaseChild.case === casesegue)
                //                 selectedState = parentNavParentCaseChild;
                //         })
                //     });
                // })
                latLng = new google.maps.LatLng(selectedState.center.lat, selectedState.center.lng);

                updateDynamicSidebarContent(selectedState, latLng);

                clickedMeSubmenuLevelThree(casesegue);
            }


            // document.getElementById('interactive__map-drawer-nav').innerHTML = parentOneMarkup + parentTwoMarkup + parentThreeMarkup;
            // Create event listener for all link clicks

            $('.interactive__map-top__bar-breadcrumbs-breadcrumb.navigation-home').click(function () {
                theZOOMfunction({
                    center: {
                        lat: 40.499607186451186,
                        lng: -101.08626144589797
                    },
                    zoom: 4,
                })
            });
            // .interactive__map-top__bar-breadcrumbs-breadcrumb.first-child
            $('body').on('click', '.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child', function () {
                if ($(this).hasClass('opened-menu')) {
                    $(this).removeClass('opened-menu');
                } else {
                    // if ($(`.interactive__map-top__bar-nav-container-submenu.breadcrumb-menu[data-casesubmenu="${casesegue_local}"]`).children().length > 0)
                    $(this).addClass('opened-menu');
                }
                // if (casesegue)
                // theZOOMfunction(casesegue);
            });

            document.querySelectorAll('a.case__segue').forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    let { casesegue, level } = link.dataset;
                    if (casesegue) {
                        casesegue = casesegue.toString();
                        $('span.current-case').removeClass('current-case');
                        e.target.classList.add('current-case');
                    }
                    if (level === 'third') {
                        jQuery('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').removeClass('opened-menu');
                        let latLng;
                        let selectedState = {
                            zoom: 5
                        };
                        selectedState = get_selected_state_by_casegue(casesegue);
                        // parentNavs.forEach(parentNav => {
                        //     parentNav.forEach(parentNavParentCase => {
                        //         if (parentNavParentCase.case === casesegue)
                        //             selectedState = parentNavParentCase;
                        //         else if (parentNavParentCase.hasChildren) return parentNavParentCase.children.forEach(parentNavParentCaseChild => {
                        //             if (parentNavParentCaseChild.case === casesegue)
                        //                 selectedState = parentNavParentCaseChild;
                        //         })
                        //     });
                        // })
                        latLng = new google.maps.LatLng(selectedState.center.lat, selectedState.center.lng);

                        // TODO: Remove this if animation doubles up
                        // map.setCenter(latLng);
                        // map.setZoom(selectedState.zoom);
                    } else {
                        let latLng;
                        let selectedState = {
                            zoom: 5
                        };
                        selectedState = get_selected_state_by_casegue(casesegue);
                        // parentNavs.forEach(parentNav => {
                        //     parentNav.forEach(parentNavParentCase => {
                        //         if (parentNavParentCase.case === casesegue)
                        //             selectedState = parentNavParentCase;
                        //         else if (parentNavParentCase.hasChildren) return parentNavParentCase.children.forEach(parentNavParentCaseChild => {
                        //             if (parentNavParentCaseChild.case === casesegue)
                        //                 selectedState = parentNavParentCaseChild;
                        //         })
                        //     });
                        // })
                        latLng = new google.maps.LatLng(selectedState.center.lat, selectedState.center.lng);
                        // map.setCenter(latLng);
                        // map.setZoom(selectedState.zoom);
                        jQuery('.interactive__map-top__bar-breadcrumbs-breadcrumb.first-child').removeClass('opened-menu');
                        // jQuery('.interactive__map-loading').addClass('open');
                        // let latLng;
                        // let selectedState = {
                        //     zoom: 5
                        // };
                        // parentNavs.forEach(parentNav => {
                        //     parentNav.forEach(parentNavParentCase => {
                        //         if (parentNavParentCase.case === casesegue)
                        //             selectedState = parentNavParentCase;
                        //         else if (parentNavParentCase.hasChildren) return parentNavParentCase.children.forEach(parentNavParentCaseChild => {
                        //             if (parentNavParentCaseChild.case === casesegue)
                        //                 selectedState = parentNavParentCaseChild;
                        //         })
                        //     });
                        // })
                        // latLng = new google.maps.LatLng(selectedState.center.lat, selectedState.center.lng);
                        // map.setCenter(latLng);
                        // map.setZoom(selectedState.zoom);
                    }

                    animateCaseSegueOverlay(() => {
                        case__segue_actions(casesegue);
                    });
                });
            });

            function get_selected_state_by_casegue(c) {
                let selectedState = {
                    zoom: 4
                };

                parentNavs.forEach(parentNav => {
                    parentNav.forEach(parentNavParentCase => {
                        if (parentNavParentCase.case === c)
                            selectedState = parentNavParentCase;
                        else if (parentNavParentCase.hasChildren) return parentNavParentCase.children.forEach(parentNavParentCaseChild => {
                            if (parentNavParentCaseChild.case === c)
                                selectedState = parentNavParentCaseChild;
                        })
                    });
                })

                return selectedState;
            }

            function theZOOMfunction(c) {
                let casesegue = c;
                let latLng;
                let selectedState = {
                    zoom: 4
                };
                if (typeof c === 'object') {
                    latLng = new google.maps.LatLng(c.center.lat, c.center.lng);
                } else {
                    if (casesegue)
                        casesegue = casesegue.toString();
                    // parentNavs.forEach(parentNav => {
                    //     parentNav.forEach(parentNavParentCase => {
                    //         if (parentNavParentCase.case === casesegue)
                    //             selectedState = parentNavParentCase;
                    //         else if (parentNavParentCase.hasChildren) return parentNavParentCase.children.forEach(parentNavParentCaseChild => {
                    //             if (parentNavParentCaseChild.case === casesegue)
                    //                 selectedState = parentNavParentCaseChild;
                    //         })
                    //     });
                    // })
                    selectedState = get_selected_state_by_casegue(casesegue);

                    latLng = new google.maps.LatLng(selectedState.center.lat, selectedState.center.lng);
                }

                document.getElementById("interactive__map-drawer").classList.remove('show');

                /**
                 * Handy functions to project lat/lng to pixel
                 * Extracted from: https://developers.google.com/maps/documentation/javascript/examples/map-coordinates
                 **/
                function project(latLng) {
                    var TILE_SIZE = 256

                    var siny = Math.sin(latLng.lat() * Math.PI / 180)

                    // Truncating to 0.9999 effectively limits latitude to 89.189. This is
                    // about a third of a tile past the edge of the world tile.
                    siny = Math.min(Math.max(siny, -0.9999), 0.9999)

                    return new google.maps.Point(
                        TILE_SIZE * (0.5 + latLng.lng() / 360),
                        TILE_SIZE * (0.5 - Math.log((1 + siny) / (1 - siny)) / (4 * Math.PI)))
                }

                /**
                 * Handy functions to project lat/lng to pixel
                 * Extracted from: https://developers.google.com/maps/documentation/javascript/examples/map-coordinates
                 **/
                function getPixel(latLng, zoom) {
                    var scale = 1 << zoom
                    var worldCoordinate = project(latLng)
                    return new google.maps.Point(
                        Math.floor(worldCoordinate.x * scale),
                        Math.floor(worldCoordinate.y * scale))
                }

                /**
                 * Given a map, return the map dimension (width and height)
                 * in pixels.
                 **/
                function getMapDimenInPixels(map) {
                    var zoom = map.getZoom()
                    var bounds = map.getBounds()
                    var southWestPixel = getPixel(bounds.getSouthWest(), zoom)
                    var northEastPixel = getPixel(bounds.getNorthEast(), zoom)
                    return {
                        width: Math.abs(southWestPixel.x - northEastPixel.x),
                        height: Math.abs(southWestPixel.y - northEastPixel.y)
                    }
                }

                /**
                 * Given a map and a destLatLng returns true if calling
                 * map.panTo(destLatLng) will be smoothly animated or false
                 * otherwise.
                 *
                 * optionalZoomLevel can be optionally be provided and if so
                 * returns true if map.panTo(destLatLng) would be smoothly animated
                 * at optionalZoomLevel.
                 **/
                function willAnimatePanTo(map, destLatLng, optionalZoomLevel) {
                    var dimen = getMapDimenInPixels(map)

                    var mapCenter = map.getCenter()
                    optionalZoomLevel = !!optionalZoomLevel ? optionalZoomLevel : map.getZoom()

                    var destPixel = getPixel(destLatLng, optionalZoomLevel)
                    var mapPixel = getPixel(mapCenter, optionalZoomLevel)
                    var diffX = Math.abs(destPixel.x - mapPixel.x)
                    var diffY = Math.abs(destPixel.y - mapPixel.y)

                    return diffX < dimen.width && diffY < dimen.height
                }

                /**
                 * Returns the optimal zoom value when animating
                 * the zoom out.
                 *
                 * The maximum change will be currentZoom - 3.
                 * Changing the zoom with a difference greater than
                 * 3 levels will cause the map to "jump" and not
                 * smoothly animate.
                 *
                 * Unfortunately the magical number "3" was empirically
                 * determined as we could not find any official docs
                 * about it.
                 **/
                function getOptimalZoomOut(latLng, currentZoom) {
                    if (willAnimatePanTo(map, latLng, currentZoom - 1)) {
                        return currentZoom - 1
                    } else if (willAnimatePanTo(map, latLng, currentZoom - 2)) {
                        return currentZoom - 2
                    } else {
                        return currentZoom - 3
                    }
                }

                /**
                 * Given a map and a destLatLng, smoothly animates the map center to
                 * destLatLng by zooming out until distance (in pixels) between map center
                 * and destLatLng are less than map width and height, then panTo to destLatLng
                 * and finally animate to restore the initial zoom.
                 *
                 * optionalAnimationEndCallback can be optionally be provided and if so
                 * it will be called when the animation ends
                 **/
                function smoothlyAnimatePanToWorkarround(map, destLatLng, optionalAnimationEndCallback) {
                    var initialZoom = map.getZoom(), listener;

                    function zoomIn() {
                        if (map.getZoom() < initialZoom) {
                            // map.setZoom(Math.min(map.getZoom() + 3, initialZoom))
                        } else {
                            google.maps.event.removeListener(listener)

                            //here you should (re?)enable only the ui controls that make sense to your app
                            // map.setOptions({ draggable: true, zoomControl: true, scrollwheel: true, disableDoubleClickZoom: false })

                            // if (!!optionalAnimationEndCallback) {
                            //     optionalAnimationEndCallback()
                            // }
                        }
                    }

                    function zoomOut() {
                        if (willAnimatePanTo(map, destLatLng)) {
                            google.maps.event.removeListener(listener)
                            listener = google.maps.event.addListener(map, 'idle', zoomIn)
                            map.panTo(destLatLng)
                        } else {
                            map.setZoom(getOptimalZoomOut(destLatLng, map.getZoom()))
                        }
                    }

                    //here you should disable all the ui controls that your app uses
                    // map.setOptions({ draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true })
                    map.setZoom(getOptimalZoomOut(destLatLng, initialZoom))
                    listener = google.maps.event.addListener(map, 'idle', zoomOut)
                    // console.log("running", listener);
                }

                function smoothlyAnimatePanTo(map, destLatLng) {
                    return new Promise(function (fulfill, reject) {
                        //do stuff
                        if (willAnimatePanTo(map, destLatLng)) {
                            map.panTo(destLatLng);
                            // fulfill('result')
                        } else {
                            smoothlyAnimatePanToWorkarround(map, destLatLng);
                            // fulfill('result');
                        }
                        // google.maps.event.clearListeners(map, 'idle');
                        let listener = google.maps.event.addListener(map, 'bounds_changed', () => {
                            // console.log("idle"); fulfill('result');
                        });
                        // let listenert = google.maps.event.addListener(map, 'tilesloaded', () => {
                        //     console.log("tilesloaded");// fulfill('result')
                        // });

                        // reject(''); //if the action did not succeed
                    });
                }

                // Dallas
                // Traffic Calming
                // Ontario California
                async function delay(ms) {
                    // return await for better async stack trace support in case of errors.
                    return await new Promise(resolve => setTimeout(resolve, ms));
                }
                function zoomOutAnimate(x) {
                    return new Promise(async function (fulfill, reject) {
                        let currZoom = x.getZoom();
                        let y = 4;
                        let xyz = Array(Math.abs(y - currZoom) + 1).fill().map((_, idx) => y - currZoom > 0 ? currZoom + idx : currZoom - idx);

                        for (var i = 0; i <= xyz.length - 1; i++) {
                            await delay(200);
                            map.setZoom(xyz[i]);
                        }

                        fulfill('Done');
                    });
                }

                async function zoomInAnimate(x, y) {
                    let currZoom = x.getZoom();
                    let xyz = Array(Math.abs(y - currZoom) + 1).fill().map((_, idx) => y - currZoom > 0 ? currZoom + idx : currZoom - idx);

                    for (var i = 0; i <= xyz.length - 1; i++) {
                        await delay(200);
                        map.setZoom(xyz[i]);
                    }
                }


                if (latLng)
                    zoomOutAnimate(map).then((result) => {
                        // console.log(result);
                        map.panTo(latLng);
                        zoomInAnimate(map, selectedState.zoom);
                        // setTimeout(() => {
                        // map.setZoom(selectedState.zoom);
                        // console.log('ran');
                        // var listener = google.maps.event.addListener(map, 'idle', () => zoomInAnimate(map, selectedState.zoom))
                        // }, 500)
                    });
                // smoothlyAnimatePanTo(map, latLng).then((result) => setTimeout(() => {
                //     // map.setZoom(selectedState.zoom);
                //     console.log('ran');
                //     zoomInAnimate(map, selectedState.zoom);
                // }, 1));

                // map.panTo(latLng);

                // let selectedState = parentNavs.find(parentNav => {
                //     console.log(parentNav);
                //     let attempt = parentNav.find(parentNavParentCase => {
                //         if (parentNavParentCase.case === casesegue)
                //             return parentNavParentCase;
                //         else if (parentNavParentCase.hasChildren) return parentNavParentCase.children.some(parentNavParentCaseChild => parentNavParentCaseChild.case === casesegue)
                //     })
                //     console.log("check attempt", attempt);
                //     if (attempt !== undefined)
                //         return attempt;
                // })
                // console.log('finished search', selectedState);

            }
        };

        // Append the 'script' element to 'head'
        document.head.appendChild(script);

    });
})(jQuery);